import {
  Box,
  Flex,
  Text,
  SimpleGrid,
  Td,
  Tr,
  Menu,
  MenuButton,
  MenuItem,
  Image,
  MenuList,
  Spacer,
  RadioGroup,
  Stack,
  Checkbox,
  Divider,
  Radio,
  Th,
  Collapse,
  useDisclosure,
  Heading,
  Textarea,
  VStack,
  Button,
  CheckboxGroup,
  InputGroup,
  Input,
  InputRightElement,
  Card,
  CardBody,
} from "@chakra-ui/react";
import { Global, css } from "@emotion/react";
import React, { useState, useEffect, useRef } from "react";
import MiniSideBar from "../../components/mini-sidebar";
import SecondaryNav from "../../components/seconday-nav";
import useLoader from "../../components/loader/loaderstates";
import Loader from "../../components/loader/loader";
import { useLocation, useNavigate } from "react-router-dom";
import DoctorCard from "../../components/doctor-card";
import ModalRight from "../../components/modal-right";
import { DropdownInput, PrimaryButton, PrimaryInput, SearchBar, Toaster } from "../../components";
import DynamicModal from "../../components/dynamic-modal";
import moment from "moment";
import SimpleTable from "../../components/simple-table";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css"; // core Swiper styles
import "swiper/css/navigation"; // navigation module styles
import { getCountry } from "../../middleware/services/country";
import { actionAccessMain, downloadDocument, formatDate_Do_MMM_YYYY, formatDate_Do_MMM_YYYY_Time, formatDate_YYYY_MM_DD, formatToDecimal, getCurrency, getLoginID, getPatientId, useScreenType, validationOfNumberWithOnly1Decimal } from "../../auth";
import DatePicker from "../../components/date-picker";
import { format } from "date-fns";
import { COLORS } from "../../components/styles/colors";
import { BookAppointment, DischargeSummaryLogs, documentProcessingStatus, FetchCategories, FetchFilteredFollowupsList, FetchFilteredPrescriptionsList, FetchLogsData, FetchPrescriptionViewDetails, GetFollowupsList, GetImagingList, GetOrderList, GetOrderVaccinationList, getProcedureCategoryData, GetProceduresList, saveImagingNotification, saveLabNotification, saveNotification, saveProcedureNotification } from "../../middleware/services/prescriptions";
import MobileNavbar from "../../components/mobile-navbar";
import MobileSecondaryNav from "../../components/mobile-secondary-navbar";
import { AddLabFee, DeleteLabFee,  UpdateLabFee } from "../../middleware/services/billing";
import SimpleTableLabs from "../../components/simple-table-labs";
import { AddDoctorFavLab, DeleteDoctorFavLab, GetDoctorFavLab, UpdateDoctorFavLab } from "../../middleware/services/doctorfavourite";
import { AddDoctorFavVaccine, DeleteDoctorFavVaccine, GetDoctorFavVaccine, UpdateDoctorFavVaccine } from "../../middleware/services/doctorfavourite/vaccination";
import { AddDoctorFavMedicine, DeleteDoctorFavMedicine, GetDoctorFavMedicine, UpdateDoctorFavMedicine } from "../../middleware/services/doctorfavourite/medicine";
import { getVaccineList } from "../../middleware/services/messages";
import { GetDoctorMasterData } from "../../middleware/services/visits/patient-overview/updatedoctornotes";
import { AddMedicine, DeleteMedication, EditMedicine, FetchFilteredMedicinesList, FetchMedicineViewDetails } from "../../middleware/services/medicines";
import { DeleteMedicine, FetchMedicationsData, FetchMedicineAIAnswer, FetchMedicineAIPrompts, FetchMyHealthAIData, GetAIMedicineComposition, GetMedicineName } from "../../middleware/services/medications.js";
import { uploadImageInProfile } from "../../middleware/services/profile";
import MiniDropdownInput from "../../components/mini-dropdown";
import DropdownInputForVitals from "../../components/dropdown-input-forVitals";
import DropdownWithMultiLingual from "../../components/dropdown-multilingual";
import { languageCodeMap, languageOptions } from "../../components/language-dropdown";
import { GPUChatAudioManagerSpeechMode } from "../../components/patient-health/doctor-notes/cheif-complaint-audio/gpuChatVoiceManagerSpeechMode";
import { AudioDisplayForClutter } from "../../components/patient-health/doctor-notes/notes-transcription/utils/audio-display-multi-lingual";
import { CorrectMedicalTermsUsingAI } from "../../middleware/services/visits/aicalls";
import { useHybridTranscriber } from "../../components/patient-health/doctor-notes/cheif-complaint-audio/useHybridTranscriber";
import { useForm } from "react-hook-form";
import { AddDoctorFavProcedure, DeleteDoctorFavProcedure, GetDoctorFavProcedure, UpdateDoctorFavProcedure } from "../../middleware/services/doctorfavourite/procedure.js";

const DoctorfavIndex = () => {
  const { isLoading, showLoader, dismissLoader } = useLoader();
  const [activeTab, setActiveTab] = useState("MedicineSetup");
  const navigate = useNavigate();
  
  var [labsViewdata, setLabsViewdata] = useState([]);
  var [imagingViewdata, setImagingViewdata] = useState([]);

  let itemPerPageCommonValue = 30;

  let [pagesize, setPagesize] = useState(itemPerPageCommonValue);
  let [pageno, setPageno] = useState(1);

  // states for item count display
  let [countTo, setCountTo] = useState(itemPerPageCommonValue);
  let [countFrom, setCountFrom] = useState(1);
  let [totalExceedsPageCount, setTotalExceedsPageCount] = useState(false);


  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItemCount, setTotalItemCount] = useState(0);
  const [refresh, setRefresh] = useState(false);
  const [showFilterCount, setShowFilterCount] = useState(false);
  var [logsData, setLogsData] = useState(null);
  const showLabLogs = useRef()
  const showImagingLogs = useRef()
  const showProcedureLogs = useRef()
  const tableRef = useRef()
  const screenType = useScreenType()
  const { isOpen, onToggle } = useDisclosure()
  const formatDate = (dateString) => {
    if (!dateString) return "-";
    return moment(dateString).format("Do MMM, YYYY");
  };

// Imaging states
// const [imaginglist, setImagingList] = useState(null);
const [imagingCurrentPage, setImagingCurrentPage] = useState(1);
const [imagingTotalPages, setImagingTotalPages] = useState(1);
const [imagingTotalItemCount, setImagingTotalItemCount] = useState(0);
const [imagingCountFrom, setImagingCountFrom] = useState(1);
const [imagingCountTo, setImagingCountTo] = useState(30);

// Procedure states
// const [imaginglist, setImagingList] = useState(null);
const [procedureCurrentPage, setProcedureCurrentPage] = useState(1);
const [procedureTotalPages, setProcedureTotalPages] = useState(1);
const [procedureTotalItemCount, setProcedureTotalItemCount] = useState(0);
const [procedureCountFrom, setProcedureCountFrom] = useState(1);
const [procedureCountTo, setProcedureCountTo] = useState(30);
const [procedurePageSize, setProcedurePageSize] = useState(30);


// Medicine states
// const [medicineViewData, setMedicineViewData] = useState(null);
const [medicineCurrentPage, setMedicineCurrentPage] = useState(1);
const [medicineTotalPages, setMedicineTotalPages] = useState(1);
const [medicineTotalItemCount, setMedicineTotalItemCount] = useState(0);
const [medicineCountFrom, setMedicineCountFrom] = useState(0); // Start with 0
const [medicineCountTo, setMedicineCountTo] = useState(0); // Start with 0
// const [medicineCountFrom, setMedicineCountFrom] = useState(1);
// const [medicineCountTo, setMedicineCountTo] = useState(30);
const [medicinePageSize, setMedicinePageSize] = useState(30);

// ================= TAB CHANGE HANDLER =================
const tabChanged = (tabName) => {
  setActiveTab(tabName);
  setSerachText("");
  
  // Reset and fetch data based on tab
  switch(tabName) {
    case "MedicineSetup":
      setMedicineCurrentPage(1);
      // setMedicineCountFrom(1);
      // setMedicineCountTo(medicinePageSize);
      fetchMedicinesList(1);
      break;
    case "labsetup":
      setLabCurrentPage(1);
      setLabCountFrom(1);
      setLabCountTo(labPageSize);
      fetchLabList(1);
      // setLabCurrentPage(1);
      // fetchLabList(1);
      break;
    case "imagingsetup":
      setImagingCurrentPage(1);
      fetchImagingList(1);
      break;
    case "vaccinationsetup":
      setVaccineCurrentPage(1);
      setVaccineCountFrom(1);
      setVaccineCountTo(vaccinePageSize);
      fetchVaccineList(1);
      break;
    case "proceduresetup":
      setProcedureCurrentPage(1);
      setProcedureCountFrom(1);
      setProcedureCountTo(procedurePageSize);
      fetchProcedureList(1);
      break;
  }
};

  // ------------------- lAB PRICIING ---------------------------------
  const [actionAccess, setActionAccess] = useState(null);
  var [patientid, setPatientID] = useState("");
  var [lablist, setLabList] = useState(null);
  const [currency, setCurrency] = useState("");
  const [labamount, setLabAmount] = useState("");
  const [labsgst, setLabSGST] = useState("");
  const [labcgst, setLabCGST] = useState("");
  const [LabId, setLabID] = useState("");
  const [description, setDescription] = useState("");
  const [labname, setLabName] = useState("");
  const addlabprice = useRef();
  const editlabprice = useRef();
  const { showSuccessToast, showErrorToast } = Toaster();
  const [searchtext, setSerachText] = useState("");
  const deletelabprice = useRef();
  const location = useLocation();

  const addOrder = useRef();
  const addImaging = useRef();
  const addProcedure = useRef();
  const [orderInputFields, setOrderInputFields] = useState([{ id: 1 }]);
  const [currentOrderType, setCurrentOrderType] = useState("lab"); 
  const [currentOrderNames, setCurrentOrderNames] = useState([
    { id: 1, name: "" },
  ]);
  const [isSaveButtonDisabled, setIsSaveButtonDisabled] = useState(false);
  const openSearchSpecificOrder = useRef();
  const [specificSearchOrderData, setSpecificSearchOrderData] = useState([]);
const [selectedItems, setSelectedItems] = useState([]);

// Add these states at the beginning with other lab states
const [labCurrentPage, setLabCurrentPage] = useState(1);
const [labTotalPages, setLabTotalPages] = useState(1);
const [labTotalItemCount, setLabTotalItemCount] = useState(0);
const [labCountFrom, setLabCountFrom] = useState(1);
const [labCountTo, setLabCountTo] = useState(30);
const [labTotalExceedsPageCount, setLabTotalExceedsPageCount] = useState(false);
const [labPageSize, setLabPageSize] = useState(30); // Default page size

const handleCheckboxChange = (item) => {
  // console.log('checkitem name: ', item)
      setSelectedItems((prevSelectedItems) => {
        if (prevSelectedItems.some((selectedItem) => selectedItem.id === item.id)) {
      // If the item is already selected, remove it from the selected items
      return prevSelectedItems.filter(
        (selectedItem) => selectedItem.id !== item.id
      );
    } else {
      // For lab items, we need to store both id and testname (which will be used as ordername)
      console.log('selecredTIemsl ', [
        ...prevSelectedItems,
        { 
          id: item.id, 
          testname: item.subtype,
          // testname: item.testname,
          // category: 'lab' // Add category for consistency
        }
      ]);
      return [
        ...prevSelectedItems,
        { 
          id: item.id, 
          testname: item.subtype,
          // testname: item.testname,
          // category: 'lab' // Add category for consistency
        }
      ];
    }
      });
    };

    const isChecked = (id) => {
      return selectedItems.some((selectedItem) => selectedItem.id === id);
    };

  const addOrderInputField = () => {
    const newId = orderInputFields.length + 1;
    setOrderInputFields([...orderInputFields, { id: newId }]);
    setCurrentOrderNames([...currentOrderNames, { id: newId, name: "" }]);
  };

  const deleteOrderInputField = (id) => {
    setOrderInputFields(orderInputFields.filter((field) => field.id !== id));
    setCurrentOrderNames(
      currentOrderNames.filter((order) => order.id !== id)
    );
  };
  const handleAddOrderName = (id, value) => {
  setCurrentOrderNames(prevNames => 
    prevNames.map(order => 
      order.id === id ? { ...order, name: value } : order
    )
  );
};
//   const AddOrder = async () => {
//   const hasEmptyOrderName = currentOrderNames.some(
//     (order) => order.name.trim() === ""
//   );
//   if (hasEmptyOrderName) {
//     showErrorToast(`${currentOrderType} name cannot be empty.`);
//     return;
//   }
//   // For lab type, we need to use the specific format
//   if (currentOrderType === "lab") {
//     const labOrders = currentOrderNames
//       .filter(order => order.name.trim() !== "") // Filter out empty names
//       .map(order => ({
//         ordername: order.name.trim()
//       }));

//     if (labOrders.length === 0) {
//       showErrorToast("Lab name cannot be empty.");
//       return;
//     }

//     const inputToSave = {
//       input: {
//         doctorid: "",
//         type: 'lab',
//         lab: labOrders
//       },
//     };

//     console.log('Saving manual labs:', inputToSave);

//     try {
//       setIsSaveButtonDisabled(true);
//       const result = await AddDoctorFavLab(inputToSave.input); // Use AddDoctorFavLab for consistency
      
//       if (result) {
//         showSuccessToast("Lab Saved successfully");        
//         // Reset states
//         setCurrentOrderNames([{ id: 1, name: "" }]);
//         setOrderInputFields([{ id: 1 }]);
//         setCurrentOrderType("lab"); // Keep as lab since we're in lab context
        
//         addOrder.current.closeRight();
//       }
//     } catch (error) {
//       console.error("Error in Add Doctor Fav Lab:", error);
//       showErrorToast("Error Happened While Saving.");
//       addOrder.current.closeRight();
//     }
//   } 
  
//   fetchLabList(pageno);
//   setIsSaveButtonDisabled(false);
// };

const AddOrder = async () => {
  const hasEmptyOrderName = currentOrderNames.some(
    (order) => order.name.trim() === ""
  );
  
  if (hasEmptyOrderName) {
    showErrorToast("Lab name cannot be empty.");
    return;
  }
  
  // For lab type, we need to use the specific format
  if (currentOrderType === "lab") {
    const labOrders = currentOrderNames
      .filter(order => order.name.trim() !== "") // Filter out empty names
      .map(order => ({
        ordername: order.name.trim()
      }));

    if (labOrders.length === 0) {
      showErrorToast("Lab name cannot be empty.");
      return;
    }

    const inputToSave = {
      doctorid: "",
      type: 'lab',
      lab: labOrders
    };

    // console.log('Saving manual labs:', inputToSave);

    try {
      setIsSaveButtonDisabled(true);
      const result = await AddDoctorFavLab(inputToSave);
      
      if (result && result.output && result.output.result === 'success') {
        showSuccessToast("Lab Saved successfully");
        
        // Reset states
        setCurrentOrderNames([{ id: 1, name: "" }]);
        setOrderInputFields([{ id: 1 }]);
        
        addOrder.current.closeRight();
        
        // Refresh lab list
        fetchLabList(labCurrentPage);
      } else if (result && result.output && result.output.message === "A lab Test with the same name already exists") {
        showErrorToast("Lab name already exists");
      } else {
        showErrorToast(result?.output?.message || "Failed to save lab");
      }
    } catch (error) {
      console.error("Error in Add Doctor Fav Lab:", error);
      showErrorToast("Error Happened While Saving.");
    } finally {
      setIsSaveButtonDisabled(false);
    }
  }
};
  const fetchMasterData = async (category) => {
  try {
    const inputData = {
      input: {
        type: category,
        doctorid: getLoginID(),
        // appointmentid: appointmentId,
      },
    };
    
    // const result = await GetDoctorFavLab(inputData.input);
    const result = await GetDoctorMasterData(inputData.input);
    // console.log('result Adnan: ', result)

    if(result) {
      // console.log('Search lab data result: ', result);
      setSpecificSearchOrderData(result);
      addOrder.current.closeRight();
      setSearchValue('');
      openSearchSpecificOrder.current.openRight();
    } else {
      console.log('No lab data found');
      setSpecificSearchOrderData([]);
      // Still open the search modal even if no data
      addOrder.current.closeRight();
      openSearchSpecificOrder.current.openRight();
    }
  } catch (error) {
    console.error("Error fetching Master data:", error);
    setSpecificSearchOrderData([]);
    // Still open the search modal even on error
    addOrder.current.closeRight();
    openSearchSpecificOrder.current.openRight();
  }
};

// existing
//   const fetchMasterData = async (category) => {
//   try {
//     const inputData = {
//       input: {
//         type: category,
//       },
//     };
    
//     const result = await GetDoctorFavLab(inputData.input);

//     if(result && result.data) {
//       console.log('Search lab data result: ', result.data);
//       setSpecificSearchOrderData(result.data);
//       addOrder.current.closeRight();
//       setSearchValue('');
//       openSearchSpecificOrder.current.openRight();
//     } else {
//       console.log('No lab data found');
//       setSpecificSearchOrderData([]);
//       // Still open the search modal even if no data
//       addOrder.current.closeRight();
//       openSearchSpecificOrder.current.openRight();
//     }
//   } catch (error) {
//     console.error("Error fetching Master data:", error);
//     setSpecificSearchOrderData([]);
//     // Still open the search modal even on error
//     addOrder.current.closeRight();
//     openSearchSpecificOrder.current.openRight();
//   }
// };
      const handleSpecificOrderSearchSaveButtonClick = async () => {
  if (selectedItems.length === 0) {
    showErrorToast("Please select at least one lab");
    return;
  }
  // console.log(selectedItems, 'selectedITems')
  const labOrders = selectedItems.map(item => ({
    ordername: item.testname
  }));
  // console.log('labOrdes: ', labOrders)
  
  const input = {
    doctorid: "",
    type: 'lab',
    lab: labOrders
  };
  
  // console.log('Saving selected labs:', input);
  
  try {
    const result = await AddDoctorFavLab(input);
    if (result && result.output && result.output.result === "success") {
      showSuccessToast("Lab Saved successfully");

      setSelectedItems([]);
      setSearchValue("");

      openSearchSpecificOrder.current.closeRight();
      
      // Refresh lab list
      fetchLabList(labCurrentPage);
    } else {
      showErrorToast(result?.output?.message || "Failed to save labs");
    }
  } catch (error) {
    console.error("Error in saving labs:", error);
    showErrorToast("Error Happened While Saving.");
  }
};
  // const handleSpecificOrderSearchSaveButtonClick = async () => {
  // const labOrders = selectedItems.map(item => ({
  // ordername: item.testname // Use testname as ordername for the API
  // }));
  //       const input = {
  //           doctorid: "",
  //           type: 'lab',
  //           "lab": labOrders
  //       };
  //       // console.log(inputToSave);
  //       try {
  //         const result = await AddDoctorFavLab(input);
  //         if (result) {
  //           // alert('handleSpecificOrderSearchSaveButtonClick hit')
  //           showSuccessToast("Lab Saved successfully");

  //           setSelectedItems([]);
  //           setSearchValue("");

  //           openSearchSpecificOrder.current.closeRight();
  //         }
  //       } catch (error) {
  //         console.error("Error in Update Doctor Notes:", error);
  //         showErrorToast("Error Happened While Saving.");
  //         openSearchSpecificOrder.current.closeRight();
  //         addOrder.current.closeRight();
  //       }
  //       fetchLabList(pageno);
  //     };

//       useEffect(() => {
//   setActionAccess(actionAccessMain(12));
  
//   // Set default page size
//   setLabPageSize(itemPerPageCommonValue || 10);
//   setLabCountTo(itemPerPageCommonValue || 10);
  
//   fetchLabList(1);
  
//   const currency = getCurrency();
//   if(currency === "USD") {
//     const uscurrency = '$';
//     setCurrency(uscurrency);
//   } else {
//     setCurrency(currency);
//   }
// }, []);
  useEffect(() => {
    
    setActionAccess(actionAccessMain(12))
    if(activeTab === "labsetup"){
      fetchLabList(pageno);    
    } else if(activeTab === "MedicineSetup"){
      fetchMedicinesList(pageno);
    } else if(activeTab === "imagingsetup"){
      fetchImagingList(pageno);
    } else if(activeTab === "vaccinationsetup"){
      fetchVaccineList(pageno);
    } else if(activeTab === "proceduresetup"){
      fetchProcedureList(pageno);
    }
    // const currency = getCurrency();
    // if(currency == "USD"){
    //   const uscurrency = '$'
    //   setCurrency(uscurrency);
    // }else{
    // setCurrency(currency);
    // }   
  }, [pageno]);

  const fetchLabList = async (page) => {
  showLoader();
  try {
    const result = await GetDoctorFavLab({ 
      "doctorid": "",
      "type": "lab",
      "pageno": page,
      "pagesize": labPageSize
    });
    
    // console.log(result, "get fav labs result");
    
    if (result && result.data) {
      setLabList(result.data);
      const count = result.count || 0;
      
      // Calculate total pages
      const calculatedTotalPages = count > 0 ? Math.ceil(count / labPageSize) : 1;
      setLabTotalPages(calculatedTotalPages);
      setLabTotalItemCount(count);
      
      // Calculate from and to counts
      const from = count > 0 ? ((page - 1) * labPageSize) + 1 : 0;
      const to = Math.min(page * labPageSize, count);
      
      setLabCountFrom(from);
      setLabCountTo(to);
      
      // Check if total exceeds page count
      setLabTotalExceedsPageCount(count > labPageSize);
      
      // Also fetch for the add modal if it's page 1
      if (page === 1) {
        fetchMasterDataForModal("lab");
      }
    } else {
      setLabList([]);
      setLabTotalPages(1);
      setLabTotalItemCount(0);
      setLabCountFrom(0);
      setLabCountTo(0);
      setLabTotalExceedsPageCount(false);
    }
  } catch (error) {
    console.error("Error fetching lab list:", error);
    setLabList([]);
    setLabTotalPages(1);
    setLabTotalItemCount(0);
    setLabCountFrom(0);
    setLabCountTo(0);
    setLabTotalExceedsPageCount(false);
  } finally {
    dismissLoader();
  }
};
const handleLabNextClick = () => {
  if (labCurrentPage < labTotalPages) {
    const nextPage = labCurrentPage + 1;
    setLabCurrentPage(nextPage);
    fetchLabList(nextPage);
  }
};

const handleLabPrevClick = () => {
  if (labCurrentPage > 1) {
    const prevPage = labCurrentPage - 1;
    setLabCurrentPage(prevPage);
    fetchLabList(prevPage);
  }
};
  // const handleNextClick = () => {
  //   // item count logic for next
  //   //here
  //  if(countTo + pagesize < totalItemCount){
  //   setCountTo(countTo + pagesize)
  //  }else{
  //    setCountTo(totalItemCount)
  //  }
   
  //  setCountFrom(countFrom + pagesize)

  //   setCurrentPage(prevPage => Math.min(prevPage + 1, totalPages));
  //   fetchLabList(currentPage + 1);
    
      
   
  // };
  // const handlePreviousClick = () => {
  //     // item count logic for previous
  //    // setCurrentPage(currentPage - 1);
      
  //   //console.log(countTo +  " == " + totalItemCount + "| else count to -  " + pagesize)
  //     if(countTo == totalItemCount){
  //          //setCountTo(Math.floor(totalItemCount / 10) * 10)
  //        let updatedCountUnroundedValue  = totalItemCount - pagesize;
  //       setCountTo(Math.ceil(updatedCountUnroundedValue / itemPerPageCommonValue ) * itemPerPageCommonValue )
  //     }else{
  //       setCountTo(countTo - pagesize)
  //     }
      
  //     setCountFrom(countFrom - pagesize)

  //   setCurrentPage(prevPage => Math.max(prevPage - 1, 1));
  //   fetchLabList(currentPage - 1);
  //    // alert(currentPage - 1)
  
  // };
  const TableHeader = [
    { key: "name", label: "Name" },
    { key: "actions", label: "Actions" },

  ];
  const [showMetricsTable, setShowMetricsTable] = useState(false);
//    const openaddmodal = async (event) => {
//   event.stopPropagation();
  
//   // Fetch data for the modal first
//   await fetchMasterDataForModal("lab");
  
//   if (addOrder.current) {
//     addOrder.current.openRight();
//   }
// };
const openaddmodal = async (event) => {
  event.stopPropagation();
  
  // Set current order type to lab
  setCurrentOrderType("lab");
  
  // Reset states
  setCurrentOrderNames([{ id: 1, name: "" }]);
  setOrderInputFields([{ id: 1 }]);
  setSelectedItems([]);
  setSearchValue("");
  setIsSaveButtonDisabled(false);
  
  // Fetch data for the modal first
  await fetchMasterDataForModal("lab");
  
  if (addOrder.current) {
    addOrder.current.openRight();
  }
};
  const addLabtest = async () => {
  if(labname === "") {
    showErrorToast("Please specify the test name");
    return false;
  }
  
  showLoader();
  try {
    let input = {
      "doctorid": "",
      "name": labname,
      "type": "lab",
    };
    
    const response = await AddDoctorFavLab(input);
    // console.log(response, "response of add Dr fav lab");
    
    if(response && response.output) {
      if(response.output.message === "A lab Test with the same name already exists") {
        showErrorToast("Test name already exists");
      } else if(response.output.result === "success") {
        showSuccessToast("Lab test added successfully");
        addlabprice.current.closeRight();
        setLabName(""); // Reset the input field
        
        // Refresh the lab list
        if (searchtext) {
          // If we're in search mode, refresh search results
          await searchLabTests();
        } else {
          // Otherwise, refresh the normal list
          fetchLabList(labCurrentPage);
        }
      } else {
        showErrorToast("Failed to add lab test");
      }
    } else {
      showErrorToast("Failed to add lab test");
    }
  } catch (error) {
    console.error(error, "error in adding lab test");
    showErrorToast("Error adding lab test");
  } finally {
    dismissLoader();
  }
};
  const editDetailsSetState = (item) =>{
    setLabID(item.id)
    setLabName(item.testname)
  }
  const openEditModal = (item) => {
    editDetailsSetState(item)
    editlabprice.current.openRight();
  };
    const editLabtest = async () => {
  if(labname === "") {
    showErrorToast("Please specify the test name");
    return false;
  }
  
  showLoader();
  try {
    let input = {
      "doctorid": "",
      "name": labname,
      "type": "lab",
      "id": LabId
    };
    
    const response = await UpdateDoctorFavLab(input);
    // console.log('Update responseLabs: ', response);
    
    if(response && response.output) {
      if(response.output.isexists == 1) {
        showErrorToast('Test name already exists for the same doctor');
      } else if(response.output.result === "success") {
        showSuccessToast('Lab Test Updated Successfully');
        editlabprice.current.closeRight();
        setLabName(""); // Reset the input field
        
        // Refresh the lab list
        if (searchtext) {
          await searchLabTests();
        } else {
          fetchLabList(labCurrentPage);
        }
      } else {
        showErrorToast("Failed to update lab test");
      }
    } else {
      showErrorToast("Failed to update lab test");
    }
  } catch (error) {
    console.error(error, "error in updating lab test");
    showErrorToast("Error updating lab test");
  } finally {
    dismissLoader();
  }
};
    const openDeleteModal = (item) => {
      setLabID(item.id)
      setLabName(item.type)
      deletelabprice.current.openModal();
    };
    const deleteLab = async () => {
  showLoader();
  try {
    let input = {
      "id": LabId,
      "type": "lab",
    };
    
    const response = await DeleteDoctorFavLab(input);
    
    if(response && response.output && response.output.result === "success") {
      showSuccessToast("Lab Test Deleted Successfully!");
      deletelabprice.current.closeModal();
      
      // Check if we need to go to previous page after deletion
      if (lablist.length === 1 && labCurrentPage > 1) {
        const prevPage = labCurrentPage - 1;
        setLabCurrentPage(prevPage);
        fetchLabList(prevPage);
      } else {
        // Refresh current page
        if (searchtext) {
          await searchLabTests();
        } else {
          fetchLabList(labCurrentPage);
        }
      }
      
      // Reset delete modal state
      setLabID("");
      setLabName("");
    } else {
      showErrorToast("Failed to delete lab test");
    }
  } catch (error) {
    console.error(error, "error in deleting lab test");
    showErrorToast("Error deleting lab test");
  } finally {
    dismissLoader();
  }
};
    const searchanything = async (e) => {
  if (e.key === "Enter") {
    searchLabTests();
  }
};

const searchLabTests = async () => {
  showLoader();
  try {
    setLabCurrentPage(1);
    setLabCountFrom(1);
    
    const result = await GetDoctorFavLab({
      "doctorid": "",
      "type": "lab",
      "searchtext": searchtext,
      "pageno": 1,
      "pagesize": labPageSize
    });
    
    if (result && result.data) {
      setLabList(result.data);
      const count = result.count || 0;
      
      const calculatedTotalPages = count > 0 ? Math.ceil(count / labPageSize) : 1;
      setLabTotalPages(calculatedTotalPages);
      setLabTotalItemCount(count);
      
      const from = count > 0 ? 1 : 0;
      const to = Math.min(labPageSize, count);
      
      setLabCountFrom(from);
      setLabCountTo(to);
      setLabTotalExceedsPageCount(count > labPageSize);
    } else {
      setLabList([]);
      setLabTotalPages(1);
      setLabTotalItemCount(0);
      setLabCountFrom(0);
      setLabCountTo(0);
      setLabTotalExceedsPageCount(false);
    }
  } catch (error) {
    console.error("Error searching labs:", error);
    setLabList([]);
    setLabTotalPages(1);
    setLabTotalItemCount(0);
    setLabCountFrom(0);
    setLabCountTo(0);
    setLabTotalExceedsPageCount(false);
  } finally {
    dismissLoader();
  }
};
const Filteranything = async () => {
  await searchLabTests();
};
    // const searchanything = async (e) => {
    //      if (e.key === "Enter") {
    //       showLoader();
    //       try {
    //         setPageno(1);
    //         setPagesize(itemPerPageCommonValue);
    //         setCountFrom(1);
    //         setCountTo(itemPerPageCommonValue);
    //         setCurrentPage(1)

    //         const result = await GetDoctorFavLab({
    //           "doctorid":"",
    //           "type": "lab",
    //           searchtext: searchtext,
    //           "pageno":"1",
    //           pagesize,
    //         });
    //         if (result != null) {
    //           setLabList(result.data);
    //           if (result && result.count === 0 && result.pagesize === 0) {
    //             setTotalPages(1);
    //           } else {
    //             setTotalPages(Math.ceil(result.count / result.pagesize));
    //           }
    //           //here
              
    //           setTotalItemCount(result.count)
    //           if (result.count < itemPerPageCommonValue) {
    //             setCountTo(result.count);
    //             setTotalExceedsPageCount(true);
    //           }else if(result.count > itemPerPageCommonValue && pageno == 1) {
    //             setCountTo(itemPerPageCommonValue);
    //             setTotalExceedsPageCount(false);
    //           }
    //         }else{
    //           setLabList(null)
    //           setTotalPages(1);
    //           dismissLoader();
    //         }
    //         dismissLoader();
    //       } catch (error) {
    //         console.error("Error in home:", error);
    //       }
    //      } 
    //   };
      // const Filteranything = async (e) => {
      //     showLoader();
      //     try {
      //         setPageno(1);
      //        setPagesize(itemPerPageCommonValue);
      //        setCountFrom(1);
      //        setCountTo(itemPerPageCommonValue);
      //        setCurrentPage(1)

      //       const result = await GetDoctorFavLab({
      //         "doctorid":"",
      //         "type": "lab",
      //         searchtext: searchtext,
      //         "pageno":"1",
      //          pagesize,
      //       });
      //       if (result != null) {
      //         setLabList(result.data);
      //         if (result && result.count === 0 && result.pagesize === 0) {
      //           setTotalPages(1);
      //         } else {
      //           setTotalPages(Math.ceil(result.count / result.pagesize));
      //         }
      //         //here
      //         console.log(result.count , " result.output.count")
      //         setTotalItemCount(result.count)
      //         if (result.count < itemPerPageCommonValue) {
      //           setCountTo(result.count);
      //           setTotalExceedsPageCount(true);
      //         }else if(result.count > itemPerPageCommonValue && pageno == 1) {
      //           setCountTo(itemPerPageCommonValue);
      //           setTotalExceedsPageCount(false);
      //         }
      //       }else{
      //         setLabList(null)
      //         setTotalPages(1);
      //         dismissLoader();
      //       }
      //       dismissLoader();
      //     } catch (error) {
      //       console.error("Error in home:", error);
      //     }
      // };

      const gobackfunction = () => {
        if (window.history.length > 2 && location.key !== "default") {
          window.history.back();
      
          // Fallback if the page does not navigate
          setTimeout(() => {
            if (document.referrer === "" || window.history.length <= 1) {
              navigate("/home");
            }
          }, 500);
        } else {
          navigate("/home");
        }
      };

      //  const resetFields = () => {
      //   setCurrentPage(1);
      //   setPageno(1);
        
      //   //clear states for correct item count
      //   setPagesize(itemPerPageCommonValue);
      //   setCountFrom(1)
      //   setCountTo(itemPerPageCommonValue)
      //   setCurrentPage(1)

      //   fetchLabList(1)
      // };

      const resetFields = () => {
  setSerachText("");
  setLabCurrentPage(1);
  setLabCountFrom(1);
  setLabCountTo(labPageSize);
  fetchLabList(1);
};

const fetchMasterDataForModal = async (category) => {
  try {
    const inputData = {
      input: {
        type: category,
        doctorid: "",
      },
    };
    
    const result = await GetDoctorFavLab(inputData.input);

    if(result && result.data) {
      // console.log('Modal lab data: ', result.data);
      setSpecificSearchOrderData(result.data);
    } else {
      console.log('No lab data found for modal');
      setSpecificSearchOrderData([]);
    }
  } catch (error) {
    console.error("Error fetching modal lab data:", error);
    setSpecificSearchOrderData([]);
  }
};

// ------------------------- edit lab row start ---------------------------

const [ inputId , setInputId ] = useState("");
const [rowToDelete, setRowToDelete] = useState(null);
const deleteRowModal = useRef();
const [ labTestDetail , setLabTestDetail] = useState([]);
const [manualreportname, setManualReportName] = useState(null);  

const [rows, setRows] = useState([]);
  const initialRow = {
  metricname: '',
  unit: '',
  highrange: '',
  lowrange: '',
  formula: '',
};


const deleteRowHandler = () => {
  const newRows = rows.filter((_, i) => i !== rowToDelete);
  setRows(newRows);
  deleteRowModal.current.closeModal();
};  
  
// ------------------------- edit lab row end ---------------------------

// ------------------------- imaging setup start ---------------------------
  // var [doctorid, setDoctorid] = useState(getLoginID());
  var [patientid, setPatientID] = useState("");
  var [imaginglist, setImagingList] = useState(null);

  const [imagingname, setImagingName] = useState("");
  const addimagingprice = useRef();
  const editimagingprice = useRef();
  const deleteimagingprice = useRef();

  const addFavImaging = useRef();
  const [imagingInputFields, setImagingInputFields] = useState([{ id: 1 }]);
  const [currentImagingType, setCurrentImagingType] = useState("imaging"); 
  const [currentImagingNames, setCurrentImagingNames] = useState([
    { id: 1, name: "" },
  ]);
  const [isImagingSaveButtonDisabled, setIsImagingSaveButtonDisabled] = useState(false);
  const openSearchSpecificImaging = useRef();
  const [specificSearchImagingData, setSpecificSearchImagingData] = useState([]);
  const [selectedImagingItems, setSelectedImagingItems] = useState([]);

const handleImagingCheckboxChange = (item) => {
      setSelectedImagingItems((prevSelectedItems) => {
        if (prevSelectedItems.some((selectedItem) => selectedItem.id === item.id)) {
      // If the item is already selected, remove it from the selected items
      return prevSelectedItems.filter(
        (selectedItem) => selectedItem.id !== item.id
      );
    } else {
      // For lab items, we need to store both id and testname (which will be used as ordername)
      return [
        ...prevSelectedItems,
        { 
          id: item.id, 
          testname: item.subtype,
          // category: 'lab' // Add category for consistency
        }
      ];
    }
      });
    };

    const isImagingChecked = (id) => {
      return selectedImagingItems.some((selectedItem) => selectedItem.id === id);
    };

  const addImagingInputField = () => {
    const newId = imagingInputFields.length + 1;
    setImagingInputFields([...imagingInputFields, { id: newId }]);
    setCurrentImagingNames([...currentImagingNames, { id: newId, name: "" }]);
  };

  const deleteImagingInputField = (id) => {
    setImagingInputFields(imagingInputFields.filter((field) => field.id !== id));
    setCurrentImagingNames(
      currentImagingNames.filter((order) => order.id !== id)
    );
  };
  const handleAddImagingName = (id, value) => {
  setCurrentImagingNames(prevNames => 
    prevNames.map(order => 
      order.id === id ? { ...order, name: value } : order
    )
  );
};
  const AddImaging = async () => {
  const hasEmptyOrderName = currentImagingNames.some(
    (order) => order.name.trim() === ""
  );
  if (hasEmptyOrderName) {
    showErrorToast(`${currentImagingType} name cannot be empty.`);
    return;
  }
  // For lab type, we need to use the specific format
  if (currentImagingType === "imaging") {
    const imagingOrders = currentImagingNames
      .filter(order => order.name.trim() !== "") // Filter out empty names
      .map(order => ({
        ordername: order.name.trim()
      }));

    if (imagingOrders.length === 0) {
      showErrorToast("Lab name cannot be empty.");
      return;
    }

    const inputToSave = {
      input: {
        doctorid: "",
        type: 'imaging',
        lab: imagingOrders
      },
    };

    // console.log('Saving manual labs:', inputToSave);

    try {
      setIsSaveButtonDisabled(true);
      const result = await AddDoctorFavLab(inputToSave.input); // Use AddDoctorFavLab for consistency
      
      if (result) {
        showSuccessToast("Imaging Saved successfully");        
        // Reset states
        setCurrentImagingNames([{ id: 1, name: "" }]);
        setImagingInputFields([{ id: 1 }]);
        setCurrentImagingType("imaging"); // Keep as lab since we're in lab context
        
        addImaging.current.closeRight();
      }
    } catch (error) {
      console.error("Error in Add Doctor Fav Lab:", error);
      showErrorToast("Error Happened While Saving.");
      addImaging.current.closeRight();
    }
  } 
  
  fetchImagingList(pageno);
  setIsImagingSaveButtonDisabled(false);
};

// existing fucntion
  // const fetchMasterImagingData = async (category) => {
  //       try {
  //         const inputData = {
  //           input: {
  //             type: category,
  //             // doctorid: doctorId,
  //             // appointmentid: appointmentId,
  //           },
  //         };
  //         // console.log(inputData);
  //         const result = await GetDoctorFavLab(inputData.input);

  //         if(result && result.data) {
  //           console.log('data result: ', result.data)
  //           setSpecificSearchImagingData(result.data);
  //           addImaging.current.closeRight();
  //           setSearchValue('')
  //           openSearchSpecificImaging.current.openRight();
  //         } else {
  //           console.log('No lab data found');
  //           setSpecificSearchImagingData([]);
  //         }

  //       } catch (error) {
  //         console.error("Error fetching Master data:", error);
  //         // return [];
  //         setSpecificSearchImagingData([]);
  //       }
  //     };
  
  const fetchMasterImagingData = async (category) => {
        try {
          const inputData = {
            input: {
              type: category,
              doctorid: getLoginID(),
              // appointmentid: appointmentId,
            },
          };
          // console.log(inputData);
          // const result = await GetDoctorFavLab(inputData.input);
          const result = await GetDoctorMasterData(inputData.input);

          if(result) {
            // console.log('data result: ', result)
            setSpecificSearchImagingData(result);
            addImaging.current.closeRight();
            setSearchValue('')
            openSearchSpecificImaging.current.openRight();
          } else {
            console.log('No lab data found');
            setSpecificSearchImagingData([]);
          }

        } catch (error) {
          console.error("Error fetching Master data:", error);
          // return [];
          setSpecificSearchImagingData([]);
        }
      };
  const handleSpecificImagingSearchSaveButtonClick = async () => {
  const labOrders = selectedImagingItems.map(item => ({
  ordername: item.testname // Use testname as ordername for the API
  }));
        const input = {
            doctorid: "",
            type: 'imaging',
            "lab": labOrders
        };
        // console.log(inputToSave);
        try {
          const result = await AddDoctorFavLab(input);
          if (result) {
            // alert('handleSpecificOrderSearchSaveButtonClick hit')
            showSuccessToast("Imaging Saved successfully");
            setSelectedImagingItems([]);
            setSearchValue("");

            openSearchSpecificImaging.current.closeRight();
          }
        } catch (error) {
          console.error("Error in Update Doctor Notes:", error);
          showErrorToast("Error Happened While Saving.");
          openSearchSpecificImaging.current.closeRight();
          addImaging.current.closeRight();
        }
        fetchImagingList(pageno);
      };
  

  // useEffect(() => {
    
  // setActionAccess(actionAccessMain(12))
  //   fetchImagingList(pageno);    
  //   // const currency = getCurrency();
  //   // if(currency == "USD"){
  //   //   const uscurrency = '$'
  //   //   setCurrency(uscurrency);
  //   // }else{
  //   // setCurrency(currency);
  //   // }   
  // }, [pageno]);

  const fetchImagingList = async (page) => {
    setSerachText("");
  //  alert(countTo)
    showLoader()
    try {
        const result = await GetDoctorFavLab({ 
          "doctorid":"",
          "type": "imaging",
          "pageno":page,
          pagesize
        });
        if (result != null) {
          setImagingList(result.data);
          if (result && result.count === 0 && result.pagesize === 0) {
            setTotalPages(1);
          } else {
            setTotalPages(Math.ceil(result.count / result.pagesize));
          }
          
          setTotalItemCount(result.count)
          if (result.count < itemPerPageCommonValue) {
           // console.log("if bolock " ,result.output.count + " < " + itemPerPageCommonValue )
            setCountTo(result.count);
            setTotalExceedsPageCount(true);
          }else if(result.count > itemPerPageCommonValue && page == 1) {
            
          //  console.log("else bolock " ,result.output.count + " > " + itemPerPageCommonValue + " page - "+ page)
            setCountTo(itemPerPageCommonValue);
            setTotalExceedsPageCount(false);
          }
        }else{
          setImagingList(null)
          setTotalPages(1);
          dismissLoader();
        }
        dismissLoader();
      } catch (error) {
        console.error("Error in home:", error);
      }
  };
  const handleImagingNextClick = () => {
    // item count logic for next
    //here
   if(countTo + pagesize < totalItemCount){
    setCountTo(countTo + pagesize)
   }else{
     setCountTo(totalItemCount)
   }
   
   setCountFrom(countFrom + pagesize)

    setCurrentPage(prevPage => Math.min(prevPage + 1, totalPages));
    fetchImagingList(currentPage + 1);
    
      
   
  };

  const handleImagingPreviousClick = () => {
      // item count logic for previous
     // setCurrentPage(currentPage - 1);
      
    //console.log(countTo +  " == " + totalItemCount + "| else count to -  " + pagesize)
      if(countTo == totalItemCount){
           //setCountTo(Math.floor(totalItemCount / 10) * 10)
         let updatedCountUnroundedValue  = totalItemCount - pagesize;
        setCountTo(Math.ceil(updatedCountUnroundedValue / itemPerPageCommonValue ) * itemPerPageCommonValue )
      }else{
        setCountTo(countTo - pagesize)
      }
      
      setCountFrom(countFrom - pagesize)

    setCurrentPage(prevPage => Math.max(prevPage - 1, 1));
    fetchImagingList(currentPage - 1);
     // alert(currentPage - 1)
  
  };
  const imagingTableHeader = [
    { key: "name", label: "Name" },
    { key: "actions", label: "Actions" },

  ];
  // const addImaging = async() => {
  //   if(imagingname == ""){
  //     showErrorToast("Please specify the name");
  //     return false;
  //   } else {   
  //          let input = {
  //              "doctorid":"",
  //              "name": imagingname,
  //               "type": "imaging",
  //          }
  //          try {
  //            const response = await AddDoctorFavLab(input);
  //            if(response.output.message == "A Imaging Test with the same name already exists"){
  //             showErrorToast("Test name already exist")
  //            }else if(response){
  //             addimagingprice.current.closeRight();
  //              fetchImagingList();
  //             dismissLoader();
  //            }else{
  //              console.log("someting went wrong")
  //            }
  //            } catch (error) {
  //              console.log(error , " error in updating fee")
  //            }
          
  //      }
  //  }
  const editImagingDetailsSetState = (item) =>{
    setLabID(item.id)
    setImagingName(item.testname)

  }
  const openEditImagingModal = (item) => {
    // console.log(item , " edit imaign modal open , data send")
    editImagingDetailsSetState(item)
    editimagingprice.current.openRight();
  };
    const editImagingtest = async() => {
      if(imagingname == ""){
        showErrorToast("Please specify the name");
        return false;
      } else {   
            let input = {
                "doctorid":"",
                "name": imagingname,
                "id": LabId,
                "type": "imaging",
            }
            showLoader()
            try {
              const response = await UpdateDoctorFavLab(input);
              if(response.output.isexists == 1){
                showErrorToast('Test name already exists for the same doctor');
                return false;
              }
              if(response){
                showSuccessToast('Imaging Updated Successfully  ')
                editimagingprice.current.closeRight();
                fetchImagingList(pageno);
                    dismissLoader();
              }else{
                console.log("someting went wrong")
              }
              } catch (error) {
                console.log(error , " error in updating fee")
              }
           
        }
    }

    const openDeleteImagingModal = (item) => {
      setLabID(item.id)
      setImagingName(item.testname)
      deleteimagingprice.current.openModal();
    };
    const deleteImaging = async() => {
      showLoader();
            let input = {
                "doctorid":"",
                "id": LabId,
                "type": "imaging",
            }
            try {
              const response = await DeleteDoctorFavLab(input);
              // console.log(response.output.result == "success", " deleted respose ")
              if(response.output.result == "success"){
                showSuccessToast("Imaging Deleted Successfully!")
                deleteimagingprice.current.closeModal();
                fetchImagingList();
                    dismissLoader();
              }else{
                console.log("someting went wrong")
              }
              } catch (error) {
                console.log(error , " error in updating fee")
              }
              dismissLoader();
    }

    const searchanythingimaging = async (e) => {
         if (e.key === "Enter") {
          showLoader();
          try {
            setPageno(1);
             setPagesize(itemPerPageCommonValue);
             setCountFrom(1);
             setCountTo(itemPerPageCommonValue);
             setCurrentPage(1)

            const result = await GetDoctorFavLab({
              "doctorid":"",
              "type": "imaging",
              searchtext: searchtext,
              "pageno":"1",
              pagesize,
            });
            if (result != null) {
              setImagingList(result.data);
              if (result && result.count === 0 && result.pagesize === 0) {
                setTotalPages(1);
              } else {
                setTotalPages(Math.ceil(result.count / result.pagesize));
              }
              //here
              
              setTotalItemCount(result.count)
              if (result.count < itemPerPageCommonValue) {
                setCountTo(result.count);
                setTotalExceedsPageCount(true);
              }else if(result.count > itemPerPageCommonValue && pageno == 1) {
                setCountTo(itemPerPageCommonValue);
                setTotalExceedsPageCount(false);
              }
            }else{
              setImagingList(null)
              setTotalPages(1);
              dismissLoader();
            }
            dismissLoader();
          } catch (error) {
            console.error("Error in home:", error);
          }
         } 
      };
      const Filteranythingimaging = async (e) => {
          showLoader();
          try {
             setPageno(1);
             setPagesize(itemPerPageCommonValue);
             setCountFrom(1);
             setCountTo(itemPerPageCommonValue);
             setCurrentPage(1)

            const result = await GetDoctorFavLab({
              "doctorid":"",
              "type": "imaging",
              searchtext: searchtext,
              "pageno":"1",
               pagesize,
            });
            if (result != null) {
              setImagingList(result.data);
              if (result && result.count === 0 && result.pagesize === 0) {
                setTotalPages(1);
              } else {
                setTotalPages(Math.ceil(result.count / result.pagesize));
              }
              //here
              setTotalItemCount(result.count)
              if (result.count < itemPerPageCommonValue) {
                setCountTo(result.count);
                setTotalExceedsPageCount(true);
              }else if(result.count > itemPerPageCommonValue && pageno == 1) {
                setCountTo(itemPerPageCommonValue);
                setTotalExceedsPageCount(false);
              }
            }else{
              setImagingList(null)
              setTotalPages(1);
              dismissLoader();
            }
            dismissLoader();
          } catch (error) {
            console.error("Error in home:", error);
          }
      };
      // const gobackfunction = ()=>{
      //   window.history.back();
      //  }
      const gobackfunctionimaging = () => {
        if (window.history.length > 2 && location.key !== "default") {
          window.history.back();
      
          // Fallback if the page does not navigate
          setTimeout(() => {
            if (document.referrer === "" || window.history.length <= 1) {
              navigate("/home");
            }
          }, 500);
        } else {
          navigate("/home");
        }
      };
       const openaddmodalimaging = (event)=>{
        event.stopPropagation();
      // openAddOrder("lab");
      if (addImaging.current) {
          addImaging.current.openRight();
        } 
        // setImagingName("");
        // addimagingprice.current.openRight()
       }

       const imagingresetFields = () => {
        setCurrentPage(1);
        setPageno(1);

        //clear states for correct item count
        setPagesize(itemPerPageCommonValue);
        setCountFrom(1)
        setCountTo(itemPerPageCommonValue)
        
        fetchImagingList(1)
      };

// ------------------------- procedure setup start ---------------------------
  // var [doctorid, setDoctorid] = useState(getLoginID());
  var [patientid, setPatientID] = useState("");
  var [procedurelist, setProcedureList] = useState(null);

  const [procedurename, setProcedureName] = useState("");
  const addprocedureprice = useRef();
  const editprocedureprice = useRef();
  const deleteprocedureprice = useRef();

  const addFavProcedure = useRef();
  const [procedureInputFields, setProcedureInputFields] = useState([{ id: 1 }]);
  const [currentProcedureType, setCurrentProcedureType] = useState("procedures"); 
  const [currentProcedureNames, setCurrentProcedureNames] = useState([
    { id: 1, name: "" },
  ]);
  const [isProcedureSaveButtonDisabled, setIsProcedureSaveButtonDisabled] = useState(false);
  const openSearchSpecificProcedure = useRef();
  const [specificSearchProcedureData, setSpecificSearchProcedureData] = useState([]);
  const [selectedProcedureItems, setSelectedProcedureItems] = useState([]);

const handleProcedureCheckboxChange = (item) => {
      setSelectedProcedureItems((prevSelectedItems) => {
        if (prevSelectedItems.some((selectedItem) => selectedItem.id === item.id)) {
      // If the item is already selected, remove it from the selected items
      return prevSelectedItems.filter(
        (selectedItem) => selectedItem.id !== item.id
      );
    } else {
      // For lab items, we need to store both id and testname (which will be used as ordername)
      return [
        ...prevSelectedItems,
        { 
          id: item.id, 
          testname: item.subtype,
          // category: 'lab' // Add category for consistency
        }
      ];
    }
      });
    };

    const isProcedureChecked = (id) => {
      return selectedProcedureItems.some((selectedItem) => selectedItem.id === id);
    };

  const addProcedureInputField = () => {
    const newId = procedureInputFields.length + 1;
    setProcedureInputFields([...procedureInputFields, { id: newId }]);
    setCurrentProcedureNames([...currentProcedureNames, { id: newId, name: "" }]);
  };

  const deleteProcedureInputField = (id) => {
    setProcedureInputFields(procedureInputFields.filter((field) => field.id !== id));
    setCurrentProcedureNames(
      currentProcedureNames.filter((order) => order.id !== id)
    );
  };
  const handleAddProcedureName = (id, value) => {
  setCurrentProcedureNames(prevNames => 
    prevNames.map(order => 
      order.id === id ? { ...order, name: value } : order
    )
  );
};
  const AddProcedure = async () => {
  const hasEmptyOrderName = currentProcedureNames.some(
    (order) => order.name.trim() === ""
  );
  if (hasEmptyOrderName) {
    showErrorToast(`${currentProcedureType} name cannot be empty.`);
    return;
  }
  // For lab type, we need to use the specific format
  if (currentProcedureType === "procedures") {
    const procedureOrders = currentProcedureNames
      .filter(order => order.name.trim() !== "") // Filter out empty names
      .map(order => ({
        ordername: order.name.trim()
      }));

    if (procedureOrders.length === 0) {
      showErrorToast("Procedure name cannot be empty.");
      return;
    }

    const inputToSave = {
      input: {
        doctorid: "",
        type: 'procedure',
        lab: procedureOrders
      },
    };

    // console.log('Saving manual labs:', inputToSave);

    try {
      setIsSaveButtonDisabled(true);
      const result = await AddDoctorFavLab(inputToSave.input); // Use AddDoctorFavLab for consistency
      
      if (result) {
        showSuccessToast("Procedure Saved successfully");        
        // Reset states
        setCurrentProcedureNames([{ id: 1, name: "" }]);
        setProcedureInputFields([{ id: 1 }]);
        setCurrentProcedureType("procedures"); // Keep as lab since we're in lab context
        
        addProcedure.current.closeRight();
      }
    } catch (error) {
      console.error("Error in Add Doctor Fav Procedure:", error);
      showErrorToast("Error Happened While Saving.");
      addProcedure.current.closeRight();
    }
  } 
  
  fetchProcedureList(pageno);
  setIsProcedureSaveButtonDisabled(false);
};
  
  const fetchMasterProcedureData = async (category) => {
        try {
          const inputData = {
            input: {
              type: category,
              doctorid: getLoginID(),
              // appointmentid: appointmentId,
            },
          };
          // console.log(inputData);
          // const result = await GetDoctorFavLab(inputData.input);
          const result = await GetDoctorMasterData(inputData.input);

          if(result) {
            // console.log('data result: ', result)
            setSpecificSearchProcedureData(result);
            addProcedure.current.closeRight();
            setSearchValue('')
            openSearchSpecificProcedure.current.openRight();
          } else {
            console.log('No Procedure data found');
            setSpecificSearchProcedureData([]);
          }

        } catch (error) {
          console.error("Error fetching Master data:", error);
          // return [];
          setSpecificSearchProcedureData([]);
        }
      };
  const handleSpecificProcedureSearchSaveButtonClick = async () => {
  const labOrders = selectedProcedureItems.map(item => ({
  ordername: item.testname // Use testname as ordername for the API
  }));
        const input = {
            doctorid: "",
            type: 'procedure',
            "lab": labOrders
        };
        // console.log(inputToSave);
        try {
          const result = await AddDoctorFavLab(input);
          if (result) {
            // alert('handleSpecificOrderSearchSaveButtonClick hit')
            showSuccessToast("Procedure Saved successfully");
            setSelectedProcedureItems([]);
            setSearchValue("");

            openSearchSpecificProcedure.current.closeRight();
          }
        } catch (error) {
          console.error("Error in Update Doctor Notes:", error);
          showErrorToast("Error Happened While Saving.");
          openSearchSpecificProcedure.current.closeRight();
          addProcedure.current.closeRight();
        }
        fetchProcedureList(pageno);
      };

  const fetchProcedureList = async (page) => {
    setSerachText("");
  //  alert(countTo)
    showLoader()
    try {
        const result = await GetDoctorFavLab({ 
          "doctorid":"",
          "type": "procedure",
          "pageno":page,
          pagesize
        });
        if (result != null) {
          setProcedureList(result.data);
          if (result && result.count === 0 && result.pagesize === 0) {
            setTotalPages(1);
          } else {
            setTotalPages(Math.ceil(result.count / result.pagesize));
          }
          
          setTotalItemCount(result.count)
          if (result.count < itemPerPageCommonValue) {
           // console.log("if bolock " ,result.output.count + " < " + itemPerPageCommonValue )
            setCountTo(result.count);
            setTotalExceedsPageCount(true);
          }else if(result.count > itemPerPageCommonValue && page == 1) {
            
          //  console.log("else bolock " ,result.output.count + " > " + itemPerPageCommonValue + " page - "+ page)
            setCountTo(itemPerPageCommonValue);
            setTotalExceedsPageCount(false);
          }
        }else{
          setProcedureList(null)
          setTotalPages(1);
          dismissLoader();
        }
        dismissLoader();
      } catch (error) {
        console.error("Error in home:", error);
      }
  };
  const handleProcedureNextClick = () => {
    // item count logic for next
    //here
   if(countTo + pagesize < totalItemCount){
    setCountTo(countTo + pagesize)
   }else{
     setCountTo(totalItemCount)
   }
   
   setCountFrom(countFrom + pagesize)

    setCurrentPage(prevPage => Math.min(prevPage + 1, totalPages));
    fetchProcedureList(currentPage + 1);
  };

  const handleProcedurePreviousClick = () => {
      // item count logic for previous
     // setCurrentPage(currentPage - 1);
      
    //console.log(countTo +  " == " + totalItemCount + "| else count to -  " + pagesize)
      if(countTo == totalItemCount){
           //setCountTo(Math.floor(totalItemCount / 10) * 10)
         let updatedCountUnroundedValue  = totalItemCount - pagesize;
        setCountTo(Math.ceil(updatedCountUnroundedValue / itemPerPageCommonValue ) * itemPerPageCommonValue )
      }else{
        setCountTo(countTo - pagesize)
      }
      
      setCountFrom(countFrom - pagesize)

    setCurrentPage(prevPage => Math.max(prevPage - 1, 1));
    fetchProcedureList(currentPage - 1);
     // alert(currentPage - 1)
  
  };
  const procedureTableHeader = [
    { key: "name", label: "Name" },
    { key: "actions", label: "Actions" },

  ];

  const editProcedureDetailsSetState = (item) =>{
    setLabID(item.id)
    setProcedureName(item.testname)

  }
  const openEditProcedureModal = (item) => {
    // console.log(item , " edit imaign modal open , data send")
    editProcedureDetailsSetState(item)
    editprocedureprice.current.openRight();
  };
    const editProceduretest = async() => {
      if(procedurename == ""){
        showErrorToast("Please specify the name");
        return false;
      } else {   
            let input = {
                "doctorid":"",
                "name": procedurename,
                "id": LabId,
                "type": "procedure",
            }
            showLoader()
            try {
              const response = await UpdateDoctorFavLab(input);
              if(response.output.isexists == 1){
                showErrorToast('Test name already exists for the same doctor');
                return false;
              }
              if(response){
                showSuccessToast('Procedure Updated Successfully  ')
                editprocedureprice.current.closeRight();
                fetchProcedureList(pageno);
                    dismissLoader();
              }else{
                console.log("someting went wrong")
              }
              } catch (error) {
                console.log(error , " error in updating fee")
              }
           
        }
    }

    const openDeleteProcedureModal = (item) => {
      setLabID(item.id)
      setProcedureName(item.testname)
      deleteprocedureprice.current.openModal();
    };
    const deleteProcedure = async() => {
      showLoader();
            let input = {
                "doctorid":"",
                "id": LabId,
                "type": "procedure",
            }
            try {
              const response = await DeleteDoctorFavLab(input);
              // console.log(response.output.result == "success", " deleted respose ")
              if(response.output.result == "success"){
                showSuccessToast("Procedure Deleted Successfully!")
                deleteprocedureprice.current.closeModal();
                fetchProcedureList();
                    dismissLoader();
              }else{
                console.log("someting went wrong")
              }
              } catch (error) {
                console.log(error , " error in updating fee")
              }
              dismissLoader();
    }

    const searchanythingprocedure = async (e) => {
         if (e.key === "Enter") {
          showLoader();
          try {
            setPageno(1);
             setPagesize(itemPerPageCommonValue);
             setCountFrom(1);
             setCountTo(itemPerPageCommonValue);
             setCurrentPage(1)

            const result = await GetDoctorFavLab({
              "doctorid":"",
              "type": "procedure",
              searchtext: searchtext,
              "pageno":"1",
              pagesize,
            });
            if (result != null) {
              setProcedureList(result.data);
              if (result && result.count === 0 && result.pagesize === 0) {
                setTotalPages(1);
              } else {
                setTotalPages(Math.ceil(result.count / result.pagesize));
              }
              //here
              
              setTotalItemCount(result.count)
              if (result.count < itemPerPageCommonValue) {
                setCountTo(result.count);
                setTotalExceedsPageCount(true);
              }else if(result.count > itemPerPageCommonValue && pageno == 1) {
                setCountTo(itemPerPageCommonValue);
                setTotalExceedsPageCount(false);
              }
            }else{
              setProcedureList(null)
              setTotalPages(1);
              dismissLoader();
            }
            dismissLoader();
          } catch (error) {
            console.error("Error in home:", error);
          }
         } 
      };
      const Filteranythingprocedure = async (e) => {
          showLoader();
          try {
             setPageno(1);
             setPagesize(itemPerPageCommonValue);
             setCountFrom(1);
             setCountTo(itemPerPageCommonValue);
             setCurrentPage(1)

            const result = await GetDoctorFavLab({
              "doctorid":"",
              "type": "procedure",
              searchtext: searchtext,
              "pageno":"1",
               pagesize,
            });
            if (result != null) {
              setProcedureList(result.data);
              if (result && result.count === 0 && result.pagesize === 0) {
                setTotalPages(1);
              } else {
                setTotalPages(Math.ceil(result.count / result.pagesize));
              }
              //here
              setTotalItemCount(result.count)
              if (result.count < itemPerPageCommonValue) {
                setCountTo(result.count);
                setTotalExceedsPageCount(true);
              }else if(result.count > itemPerPageCommonValue && pageno == 1) {
                setCountTo(itemPerPageCommonValue);
                setTotalExceedsPageCount(false);
              }
            }else{
              setProcedureList(null)
              setTotalPages(1);
              dismissLoader();
            }
            dismissLoader();
          } catch (error) {
            console.error("Error in home:", error);
          }
      };
      // const gobackfunction = ()=>{
      //   window.history.back();
      //  }
      const gobackfunctionprocedure = () => {
        if (window.history.length > 2 && location.key !== "default") {
          window.history.back();
      
          // Fallback if the page does not navigate
          setTimeout(() => {
            if (document.referrer === "" || window.history.length <= 1) {
              navigate("/home");
            }
          }, 500);
        } else {
          navigate("/home");
        }
      };
       const openaddmodalprocedure = (event)=>{
        event.stopPropagation();
      // openAddOrder("lab");
      if (addProcedure.current) {
          addProcedure.current.openRight();
        } 
        // setImagingName("");
        // addimagingprice.current.openRight()
       }

       const procedureresetFields = () => {
        setCurrentPage(1);
        setPageno(1);

        //clear states for correct item count
        setPagesize(itemPerPageCommonValue);
        setCountFrom(1)
        setCountTo(itemPerPageCommonValue)
        
        fetchProcedureList(1)
      };


      // ------------------------- vaccine setup start ---------------------------
  const [Vaccinelist, setVaccineList] = useState(null);
const [Vaccinename, setVaccineName] = useState("");
const [selectedConditions, setSelectedConditions] = useState([]);
const [VaccineId, setVaccineID] = useState(""); // Fixed: Added missing VaccineId state

const AddVaccineModal = useRef();
const EditVaccineModal = useRef();
const DeleteVaccineModal = useRef();

const [conditionsList, setConditionsList] = useState(null);
const [searchValue, setSearchValue] = useState('');

// Add these states with other vaccine states
const [vaccineCurrentPage, setVaccineCurrentPage] = useState(1);
const [vaccineTotalPages, setVaccineTotalPages] = useState(1);
const [vaccineTotalItemCount, setVaccineTotalItemCount] = useState(0);
const [vaccineCountFrom, setVaccineCountFrom] = useState(1);
const [vaccineCountTo, setVaccineCountTo] = useState(30);
const [vaccineTotalExceedsPageCount, setVaccineTotalExceedsPageCount] = useState(false);
const [vaccinePageSize, setVaccinePageSize] = useState(30);
const [vaccineSearchText, setVaccineSearchText] = useState(""); // Separate search state for vaccine

// Update these vaccine states to match lab pattern
const [orderInputFieldsVaccine, setOrderInputFieldsVaccine] = useState([{ id: 1 }]);
const [currentOrderNamesVaccine, setCurrentOrderNamesVaccine] = useState([
  { id: 1, name: "" },
]);
const [isSaveButtonDisabledVaccine, setIsSaveButtonDisabledVaccine] = useState(false);
const [specificSearchVaccineData, setSpecificSearchVaccineData] = useState([]);
const [selectedVaccineItems, setSelectedVaccineItems] = useState([]);
const [searchValueVaccine, setSearchValueVaccine] = useState('');

// Add refs for vaccine modals
const addOrderVaccine = useRef();
const openSearchSpecificVaccineOrder = useRef();

// Add order input field for vaccine
const addOrderInputFieldVaccine = () => {
  const newId = orderInputFieldsVaccine.length + 1;
  setOrderInputFieldsVaccine([...orderInputFieldsVaccine, { id: newId }]);
  setCurrentOrderNamesVaccine([...currentOrderNamesVaccine, { id: newId, name: "" }]);
};

// Delete order input field for vaccine
const deleteOrderInputFieldVaccine = (id) => {
  setOrderInputFieldsVaccine(orderInputFieldsVaccine.filter((field) => field.id !== id));
  setCurrentOrderNamesVaccine(
    currentOrderNamesVaccine.filter((order) => order.id !== id)
  );
};

// Handle add order name for vaccine
const handleAddOrderNameVaccine = (id, value) => {
  setCurrentOrderNamesVaccine(prevNames => 
    prevNames.map(order => 
      order.id === id ? { ...order, name: value } : order
    )
  );
};

// Checkbox change handler for vaccine - MODIFIED TO INCLUDE vaccine_cd
// FIXED: Checkbox change handler for vaccine
const handleCheckboxVaccineChange = (vaccine) => {
  // console.log('Handling checkbox for:', vaccine);
  
  const isSelected = selectedVaccineItems.some(
    (item) => item.condition_cd === vaccine.condition_cd
  );

  if (isSelected) {
    // Remove from selected items
    setSelectedVaccineItems((prevItems) =>
      prevItems.filter((item) => item.condition_cd !== vaccine.condition_cd)
    );
  } else {
    // Add to selected items
    setSelectedVaccineItems([...selectedVaccineItems, {
      ...vaccine,
      id: vaccine.condition_cd, // Ensure id is set
      vaccine_cd: vaccine.condition_cd,
      vaccinename: vaccine.condition
    }]);
  }
};

// FIXED: Check if vaccine is selected - pass the vaccine object
const isVaccineChecked = (vaccine) => {
  return selectedVaccineItems.some((selectedItem) => 
    selectedItem.condition_cd === vaccine.condition_cd
  );
};
// Fetch master data for vaccine modal
// FIXED: Fetch master data for vaccine modal
const fetchMasterVaccineData = async () => {
  try {
    const inputData = {
      input: {
        type: "vaccine",
        doctorid: getLoginID()
      },
    };
    
    // console.log('Fetching master vaccine data...');
    
    const result = await GetDoctorMasterData(inputData.input);
    // console.log('Master vaccine API result:', result);

    if(result && Array.isArray(result)) {
      // console.log('Result is an array, looking for vaccine data...');
      
      // Find the vaccine section in the array
      const vaccineSection = result.find(item => 
        item && item.conditiontype === "vaccine"
      );
      
      if(vaccineSection && vaccineSection.data && Array.isArray(vaccineSection.data)) {
        const vaccineData = vaccineSection.data;
        // console.log('Vaccine data found:', vaccineData.length, 'items');
        
        // Set the vaccine data
        setSpecificSearchVaccineData(vaccineData);
        setSearchValueVaccine('');
        
        // Close the first modal and open the second one
        if (addOrderVaccine.current) {
          addOrderVaccine.current.closeRight();
        }
        
        // Small delay to ensure modal transition
        setTimeout(() => {
          if (openSearchSpecificVaccineOrder.current) {
            openSearchSpecificVaccineOrder.current.openRight();
          }
        }, 100);
      } else {
        console.log('No vaccine data found in the response');
        showErrorToast("No vaccine data available");
      }
    } else {
      console.log('Result is not an array or is empty');
      showErrorToast("Failed to fetch vaccine data");
    }
  } catch (error) {
    console.error("Error fetching vaccine data:", error);
    showErrorToast("Error fetching vaccine data");
  }
};

// Add order for vaccine (manual entry) - MODIFIED
const AddOrderVaccine = async () => {
  const hasEmptyOrderName = currentOrderNamesVaccine.some(
    (order) => order.name.trim() === ""
  );
  
  if (hasEmptyOrderName) {
    showErrorToast("Vaccine name cannot be empty.");
    return;
  }
  
  const vaccineOrders = currentOrderNamesVaccine
    .filter(order => order.name.trim() !== "")
    .map(order => ({
      vaccine_cd: null, // Manual entries might not have vaccine_cd
      vaccinename: order.name.trim(),
      admindate: null,
      duedate: null
    }));

  if (vaccineOrders.length === 0) {
    showErrorToast("Vaccine name cannot be empty.");
    return;
  }

  const input = {
    doctorid: "",
    // vaccineappointmentid: "71117", 
    vaccine: vaccineOrders, 
  };

  // Wrap in input object as per requirement
  // const finalInput = {
  //   input: input
  // };

  // console.log('Saving manual vaccines:', input);

  try {
    setIsSaveButtonDisabledVaccine(true);
    const result = await AddDoctorFavVaccine(input);
    
    if (result && result.output && result.output.result === "success") {
      showSuccessToast("Vaccine Saved successfully");
      
      // Reset states
      setCurrentOrderNamesVaccine([{ id: 1, name: "" }]);
      setOrderInputFieldsVaccine([{ id: 1 }]);
      
      addOrderVaccine.current.closeRight();
      
      // Refresh vaccine list
      fetchVaccineList(vaccineCurrentPage);
    } else if (result.output && result.output.message === "A Vaccine with the same name already exists") {
      showErrorToast("Vaccine name already exists");
    } else {
      showErrorToast("Failed to save vaccine");
    }
  } catch (error) {
    console.error("Error in Add Doctor Fav Vaccine:", error);
    showErrorToast("Error Happened While Saving.");
  } finally {
    setIsSaveButtonDisabledVaccine(false);
  }
};

// Add this function to reset selected items when needed
const resetSelectedVaccineItems = () => {
  setSelectedVaccineItems([]);
};

// Update your handleSpecificVaccineSearchSaveButtonClick to reset after saving
const handleSpecificVaccineSearchSaveButtonClick = async () => {
  const vaccineOrders = selectedVaccineItems.map(item => ({
    vaccine_cd: item.condition_cd || item.vaccine_cd, 
    vaccinename: item.condition || item.vaccinename,
    admindate: null,
    duedate: null 
  }));
  
  const input = {
    doctorid: "",
    vaccine: vaccineOrders, 
  };
  
  // console.log('Saving vaccine data:', input);
  
  try {
    const result = await AddDoctorFavVaccine(input);
    if (result && result.output && result.output.result === "success") {
      showSuccessToast("Vaccine Saved successfully");

      // Reset selected items
      setSelectedVaccineItems([]);
      setSearchValueVaccine("");

      openSearchSpecificVaccineOrder.current.closeRight();
      
      // Refresh vaccine list
      fetchVaccineList(vaccineCurrentPage);
    } else if (result.output && result.output.message === "A Vaccine with the same name already exists") {
      showErrorToast("Vaccine name already exists");
    } else {
      showErrorToast(result.output?.message || "Failed to save vaccine");
    }
  } catch (error) {
    console.error("Error in saving vaccine:", error);
    showErrorToast("Error Happened While Saving.");
  }
};
// Handle specific vaccine search save button click
const openaddmodalvaccine = async (event) => {
  if (event) event.stopPropagation();
  
  // Reset states before opening
  setCurrentOrderNamesVaccine([{ id: 1, name: "" }]);
  setOrderInputFieldsVaccine([{ id: 1 }]);
  setSelectedVaccineItems([]);
  setSearchValueVaccine("");
  
  // Open the vaccine order modal
  if (addOrderVaccine.current) {
    addOrderVaccine.current.openRight();
  }
};

// Fix: Reset states when edit modal opens
const openEditVaccineModal = (item) => {
  // console.log(item, " edit vaccine modal open, data send");
  editVaccineDetailsSetState(item);
  EditVaccineModal.current.openRight();
};

// Fix: Properly set state for editing
const editVaccineDetailsSetState = (item) => {
  setVaccineID(item.id);
  setVaccineName(item.vaccinename || ""); // Use vaccinename from API
};

const fetchVaccineList = async (page) => {
  setVaccineSearchText(""); // Use vaccine-specific search text
  showLoader();
  try {
    const result = await GetDoctorFavVaccine({ 
      "doctorid": "",
      "pageno": page,
      "pagesize": vaccinePageSize
    });
    
    // console.log(result, "result of get vaccine");
    
    if (result && result.data) {
      setVaccineList(result.data);
      const count = result.count || 0;
      
      // Calculate total pages
      const calculatedTotalPages = count > 0 ? Math.ceil(count / vaccinePageSize) : 1;
      setVaccineTotalPages(calculatedTotalPages);
      setVaccineTotalItemCount(count);
      
      // Calculate from and to counts
      const from = count > 0 ? ((page - 1) * vaccinePageSize) + 1 : 0;
      const to = Math.min(page * vaccinePageSize, count);
      
      setVaccineCountFrom(from);
      setVaccineCountTo(to);
      
      // Check if total exceeds page count
      setVaccineTotalExceedsPageCount(count > vaccinePageSize);
      
      // Also fetch for the add modal if it's page 1
      if (page === 1) {
        fetchMasterVaccineDataForModal();
      }
    } else {
      setVaccineList([]);
      setVaccineTotalPages(1);
      setVaccineTotalItemCount(0);
      setVaccineCountFrom(0);
      setVaccineCountTo(0);
      setVaccineTotalExceedsPageCount(false);
    }
  } catch (error) {
    console.error("Error fetching vaccine list:", error);
    setVaccineList([]);
    setVaccineTotalPages(1);
    setVaccineTotalItemCount(0);
    setVaccineCountFrom(0);
    setVaccineCountTo(0);
    setVaccineTotalExceedsPageCount(false);
  } finally {
    dismissLoader();
  }
};

const handleVaccineNextClick = () => {
  if (vaccineCurrentPage < vaccineTotalPages) {
    const nextPage = vaccineCurrentPage + 1;
    setVaccineCurrentPage(nextPage);
    fetchVaccineList(nextPage);
  }
};

const handleVaccinePreviousClick = () => {
  if (vaccineCurrentPage > 1) {
    const prevPage = vaccineCurrentPage - 1;
    setVaccineCurrentPage(prevPage);
    fetchVaccineList(prevPage);
  }
};

// Fetch master vaccine data for modal
const fetchMasterVaccineDataForModal = async () => {
  try {
    const result = await GetDoctorFavVaccine({
      type: "vaccine",
      pageno: 1,
      pagesize: 100
    });
    
    if (result && result.data) {
      console.log('Modal vaccine data: ', result.data);
      setSpecificSearchVaccineData(result.data);
    } else {
      console.log('No vaccine data found for modal');
      setSpecificSearchVaccineData([]);
    }
  } catch (error) {
    console.error("Error fetching modal vaccine data:", error);
    setSpecificSearchVaccineData([]);
  }
};

const addVaccine = async () => {
  if (selectedVaccineItems.length === 0) {
    showErrorToast("Please select at least one vaccine");
    return false;
  }

  const vaccineArray = selectedVaccineItems.map(item => ({
    vaccinename: item.vaccinename
  }));

  let input = {
    "doctorid": "",
    "vaccine": vaccineArray
  };

  // console.log('Saving vaccines:', input);

  showLoader();
  try {
    const response = await AddDoctorFavVaccine(input);
    
    if (response.output && response.output.message === "A Vaccine with the same name already exists") {
      showErrorToast("Vaccine name already exists");
    } else if (response.output && response.output.result === "success") {
      showSuccessToast("Vaccine added successfully!");
      AddVaccineModal.current.closeRight();
      
      // Reset states after successful save
      setSelectedVaccineItems([]);
      setSearchValue("");
      
      // Refresh the vaccine list
      if (vaccineSearchText) {
        await searchVaccineTests();
      } else {
        fetchVaccineList(vaccineCurrentPage);
      }
    } else {
      showErrorToast(response.output?.message || "Something went wrong!");
    }
  } catch (error) {
    console.log(error, " error in adding vaccine");
    showErrorToast("Error adding vaccine");
  } finally {
    dismissLoader();
  }
};

const editVaccinetest = async () => {
  if (Vaccinename === "") {
    showErrorToast("Please specify the name");
    return false;
  }
  
  showLoader();
  try {
    let input = {
      "doctorid": "",
      "name": Vaccinename,
      "id": VaccineId,
    };
    
    const response = await UpdateDoctorFavVaccine(input);
    
    if (response.output && response.output.isexists == 1) {
      showErrorToast('Vaccine name already exists for the same doctor!');
    } else if (response.output && response.output.result === "success") {
      showSuccessToast('Vaccine Updated Successfully!');
      EditVaccineModal.current.closeRight();
      
      // Reset states
      setVaccineName("");
      setVaccineID("");
      
      // Refresh the vaccine list
      if (vaccineSearchText) {
        await searchVaccineTests();
      } else {
        fetchVaccineList(vaccineCurrentPage);
      }
    } else {
      showErrorToast(response.output?.message || "Something went wrong!");
    }
  } catch (error) {
    console.log(error, " error in updating vaccine");
    showErrorToast("Error updating vaccine");
  } finally {
    dismissLoader();
  }
};

const openDeleteVaccineModal = (item) => {
  setVaccineID(item.id);
  setVaccineName(item.name || item.testname || ""); // Fixed: Handle both name and testname
  DeleteVaccineModal.current.openModal();
};

const deleteVaccine = async () => {
  showLoader();
  try {
    let input = {
      "doctorid": "",
      "id": VaccineId,
    };
    
    const response = await DeleteDoctorFavVaccine(input);
    
    if (response.output && response.output.result === "success") {
      showSuccessToast("Vaccine Deleted Successfully!");
      DeleteVaccineModal.current.closeModal();
      
      // Reset states
      setVaccineName("");
      setVaccineID("");
      
      // Check if we need to go to previous page after deletion
      if (Vaccinelist.length === 1 && vaccineCurrentPage > 1) {
        const prevPage = vaccineCurrentPage - 1;
        setVaccineCurrentPage(prevPage);
        fetchVaccineList(prevPage);
      } else {
        // Refresh current page
        if (vaccineSearchText) {
          await searchVaccineTests();
        } else {
          fetchVaccineList(vaccineCurrentPage);
        }
      }
    } else {
      showErrorToast(response.output?.message || "Something went wrong!");
    }
  } catch (error) {
    console.log(error, " error in deleting vaccine");
    showErrorToast("Error deleting vaccine");
  } finally {
    dismissLoader();
  }
};

// useEffect(()=>{
//     console.log(selectedConditions, " selectedConditions")
//   },[selectedConditions])
  
  const VaccineTableHeader = [
    { key: "name", label: "Name" },
    { key: "actions", label: "Actions" },

  ];

const searchanythingVaccine = async (e) => {
  if (e.key === "Enter") {
    searchVaccineTests();
  }
};

const searchVaccineTests = async () => {
  showLoader();
  try {
    setVaccineCurrentPage(1);
    setVaccineCountFrom(1);
    
    const result = await GetDoctorFavVaccine({
      "doctorid": "",
      "searchtext": vaccineSearchText,
      "pageno": 1,
      "pagesize": vaccinePageSize
    });
    
    if (result && result.data) {
      setVaccineList(result.data);
      const count = result.count || 0;
      
      const calculatedTotalPages = count > 0 ? Math.ceil(count / vaccinePageSize) : 1;
      setVaccineTotalPages(calculatedTotalPages);
      setVaccineTotalItemCount(count);
      
      const from = count > 0 ? 1 : 0;
      const to = Math.min(vaccinePageSize, count);
      
      setVaccineCountFrom(from);
      setVaccineCountTo(to);
      setVaccineTotalExceedsPageCount(count > vaccinePageSize);
    } else {
      setVaccineList([]);
      setVaccineTotalPages(1);
      setVaccineTotalItemCount(0);
      setVaccineCountFrom(0);
      setVaccineCountTo(0);
      setVaccineTotalExceedsPageCount(false);
    }
  } catch (error) {
    console.error("Error searching vaccines:", error);
    setVaccineList([]);
    setVaccineTotalPages(1);
    setVaccineTotalItemCount(0);
    setVaccineCountFrom(0);
    setVaccineCountTo(0);
    setVaccineTotalExceedsPageCount(false);
  } finally {
    dismissLoader();
  }
};

const FilteranythingVaccine = async () => {
  await searchVaccineTests();
};
const vaccinneresetFields = () => {
  setVaccineSearchText("");
  setVaccineCurrentPage(1);
  setVaccineCountFrom(1);
  setVaccineCountTo(vaccinePageSize);
  fetchVaccineList(1);
};

// ------------------------- Medicine start ---------------------------
var [medicineViewData, setMedicineViewData] = useState(null);
const addmedications = useRef();
  const fileInputRef = useRef(null);
  const AIChatModel = useRef();
  const chatContainerRef = useRef(null);
  const learnMoreModal = React.useRef();
  const editmedications = React.useRef();
  const detailsmodel = React.useRef();
  const fileInputRefUpdate = useRef(null);
  const dynamicModal = React.useRef();
  const administration = React.useRef();

  // Pagination 
  const [name, setName] = useState("");
  // const [lastUsedDate, setLastUsedDate] = useState(null);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  // const [currentPage, setCurrentPage] = useState(1);
  // const [totalPages, setTotalPages] = useState(1);
  // const [refresh, setRefresh] = useState(false);
  // const [totalItemCount, setTotalItemCount] = useState(0);
  const [modalData, setModalData] = useState({
    duration: '',
    frequency: '',
    frequencytime: '',
    frequencyvalue: '',
    morning: 0,
    afternoon: 0,
    evening: 0,
    beforefood: 0,
    afterfood: 0,
    instructions: '',
  });
  
  // let itemPerPageCommonValue = 50;

  // let [pagesize, setPagesize] = useState(itemPerPageCommonValue);
  // let [pageno, setPageno] = useState(1);


  // // states for item count display
  // let [countTo, setCountTo] = useState(itemPerPageCommonValue);
  // let [countFrom, setCountFrom] = useState(1);
  // let [totalExceedsPageCount, setTotalExceedsPageCount] = useState(false);

  // const [showFilterCount, setShowFilterCount] = useState(false);
  const [noData, setNoData] = useState(false);


  // add medicine
  const [Composition, setComposition] = useState("");
  const [dosage, setMedicineDosage] = useState(null);
  const [hospitalname, setHospitalname] = useState(null);
  const [medicinename, setMedicineName] = useState("");
  const [selectedImage, setSelectedImage] = useState(null);
  const [medicineexpirydate, setMedicineExpiryDate] = useState('');
  const [benifit, setBenifit] = useState('')
  const [sideEffects, setSideEffects] = useState('')
  const [dosageunit, setMedicineDosageUnit] = useState("mg");
  const [frequency, setMedicineDosageFrequency] = useState("");
  const [medicinetype, setMedicineType] = useState("Tablet");
  const [filterMedicinetype, setFilterMedicinetype] = useState("");
  const [morning, setMorning] = useState("0");
  const [afternoon, setAfternoon] = useState("0");
  const [setevening, setEvening] = useState("0");
  const [setnight, setNight] = useState("0");
  const [beforefood, setBeforefood] = useState("0");
  const [afterfood, setAfterfood] = useState("0");
  const [prescribedby, setPrescribedBy] = useState(null);
  const [suggestions, setSuggestions] = useState({});
  const [treatmentteamdata, setTreatmentTeamData] = useState("");
  const [showDocNamesDropdown , setShowDocNamesDropdown] = useState(true)
  const [showAIModal , setShowAIModal] = useState(true)
  const [IsChecked , setIsChecked] = useState(0)
  const [filenameArray, setFilenameArray] = useState([]);
  // const [activeTab, setActiveTab] = useState(0);
  const [boolValForSuggestions , setBoolValForSuggestions] = useState(true)
  const [medicineTypeRadio, setMedicineTypeRadio] = useState(null)
  const [medicinetypeFilter, setMedicineTypeFilter] = useState("All")
  const [aianswers, setAIAnswers] = useState([]);
  const [remainingquestions, setRemainingQuestions] = useState([]);
  const [aiquestion, setAIAnalysis] = useState(null);
  const [AiInput, setAiInput] = useState(null);
  const [initialRender, setInitialRender] = useState(true);
  const [animate, setAnimate] = useState(false);

  // Edit Medicine States
  var [id, setID] = useState("");
  const [minDateStateEdit , setMinDateStateEdit] = useState('')
  const [maxDateStateEdit , setMaxDateStateEdit] = useState('')
  const [filenameforUpload, setFilenameforUpload] = useState([])
  const today = moment().format("YYYY-MM-DD HH:mm:ss.SSS");
  const [medicinedata, setMedicinedata] = useState(null);
  const [documentURLForEdit, setDocumentURLForEdit] = useState([]);
  var [title, setTitle] = useState();
  var [data, setData] = useState(null);

  const [ toDateMinMax , setToDateMinMax] = useState("")
  const [ fromDateMinMax , setFromDateMinMax] = useState("")

  // const TableHeader = [
  //   { key: "medicine", label: "Medicine Name" },
  //   { key: "composition", label: "Composition" },
  //   { key: "dosage", label: "strength" },
  //   { key: "consumption", label: "Consumption" },
  //   { key: "lastused", label: "Last Used" },
  //   { key: "actions", label: "Actions" },
  // ];

  // const [actionAccess, setActionAccess] = useState(null);
  // const { isOpen, onToggle } = useDisclosure()

  // states of new inputs of medication ---
  const [routeOfAdministration, setRouteOfAdministration] = useState(null);
  const [timing, setTiming] = useState(null);
  const [quantity, setQuantity] = useState(null);
  const [areaOfApplication, setAreaOfApplication] = useState(null);
  const [drugClass, setDrugClass] = useState(null);
  const [therapeutic, setTherapeutic] = useState(null);
  const [manufacturer, setManufacturer] = useState(null);
  const [instructions, setInstructions] = useState(null);
  const [editInstructions, setEditInstructions] = useState(null);
  const [diluent, setDiluent] = useState(null);
  const [infusionDuration, setInfusionDuration] = useState(null);
  const [infusionFrequency, setInfusionFrequency] = useState(null);
  const [additives, setAdditives] = useState(null);
  const [duration, setDuration] = useState(null);

  const [medicineFreqValue, setMedicineFreqValue] = useState("")
  const [medicineFreqUnit, setMedicineFreqUnit] = useState("")
  //   const [ durationValue , setDurationValue] = useState("")
  //   const [ durationUnit , setDurationUnit] = useState("")

  const [rateOfInfusionValue, setRateOfInfusionValue] = useState(null);
  const [rateOfInfusionUnit , setRateOfInfusionUnit] = useState("ml/hr")
  const [durationValue, setDurationValue] = useState("3");
  const [durationUnit, setDurationUnit] = useState("Days");
  const [frequencyUnit, setFrequencyUnit] = useState(null);

  const [sos, setSOS] = useState(null);
  const [customMessage, setCustomMessage] = useState(null);

  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    // Add this state to track if filters are applied
const [isMedicineFilterApplied, setIsMedicineFilterApplied] = useState(false);

  // const handleApplyFilters = () => {
  //   // if(!patientName && !email && !mobile && (!plan || plan== '')){
  //   //   showErrorToast('Please enter the inputs to filter.')
  //   //   return;
  //   // }
  //   setShowFilterCount(true);
  //   setPageno(1)
  //   setCurrentPage(1)
  //   getFilteredResults();
  // };

  // const resetFields = () => {
  //   setName('')
  //   setFromDate('')
  //   setToDate('')
  //   setFromDateMinMax(null)
  //   setToDateMinMax(null)
  //   setPageno(1);
  //   //clear states for correct item count
  //   setPagesize(itemPerPageCommonValue);
  //   setCountFrom(1)
  //   setCountTo(itemPerPageCommonValue)
  //   setCurrentPage(1)
  //   setShowFilterCount(false);
  //   setSearch({
  //     composition: '',
  //     dosage: '',
  //     type: '',
  //     drugClass: '',
  //     medicine: '',
  //     manufacturer: '',
  //     therapeutic: ''
  //   })
  //   setMedicineType("")
  //   setFilterMedicinetype("")
  //   setRefresh(!refresh);
  // };

  // ========== MEAL TIMING HELPER FUNCTIONS ==========
  const getMealTimingLabel = (morning, afternoon, night) => {
    return `${morning ? 1 : 0}-${afternoon ? 1 : 0}-${night ? 1 : 0}`;
  };

  const parseMealTiming = (optionValue) => {
    const [m, a, n] = optionValue.split('-').map(v => v === '1');
    return { morning: m, afternoon: a, night: n };
  };
  // ========== END MEAL TIMING HELPERS ==========

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      // console.log('Enter key pressed');
      setPageno(1);
      setPagesize(itemPerPageCommonValue);
      setCountFrom(1);
      setCountTo(itemPerPageCommonValue);
      setCurrentPage(1)

      handleApplyFilters();
    }
  };

  const handleChangeName = (event) => {
    let inputValue = event.target.value;
    inputValue = inputValue.replace(/[^A-Za-z0-9\s@.]/g, '').slice(0, 50);
    event.target.value = inputValue;
    setName(event.target.value);
  };

  const [search, setSearch] = useState({
    composition: '',
    dosage: '',
    type: '',
    drugClass: '',
    medicine: '',
    manufacturer: '',
    therapeutic: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setSearch((prev) => ({ ...prev, [name]: value }));
  };

  const handlemedicinename = (event) => {
    setMedicineName(event.target.value);
  };

  const handleimageselection = async (e) => {
    e.preventDefault();
    setMedicineName("")
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.onloadend = () => {
      setSelectedImage(reader.result);
    };
    reader.readAsDataURL(file);
    const allowedTypes = ["image/png", "image/jpeg", "image/jpg", "image/webp"];
    if (!allowedTypes.includes(file.type)) {
      showErrorToast("Invalid file type. Please select a PNG, JPG or JPEG file.");
    dismissLoader();
      return false;
    }
    showLoader();
    const result = await GetMedicineName(file, file.name, file.type);
    if(result?.output?.message  == "No credits are available"){
      showErrorToast("No sufficient tokens available")
    }else{
    setMedicineName(result.medicine_name);
    setComposition(result.chemical_composition)

     if(result.expiry_date !== "00-0000"){
      //const formatteddate = moment(result.expiry_date).format("DD-MM-yyyy")
      setMedicineExpiryDate(result.expiry_date);
     }
    setBenifit(result.benefit);
    setSideEffects(result.side_effects);
    // showmedicinename.current.openRight();
    }
    
    
  e.target.value = '';
    dismissLoader();
  };

  // existing code function
  // const handlemedicinetypechange = (event, type) => {

  //   setMedicineType(event);
  //   if(type == "filter"){
  //     setFilterMedicinetype(event);
  //   }
  //   if(event == "Tablet" || event == "Capsule"){
  //     setMedicineDosageUnit("mg");
  //   }else if (event == "Syrup" || event == "Injection" ||  event == "Nebulization" ||  event == "IVFluids" || event == "Drops"){
      
  //     setMedicineDosageUnit("ml");
  //   }else if (event == "Ointment"){
      
  //     setMedicineDosageUnit("grms");
  //   }else if (event == "Inhaler"){
  //     setMedicineDosageUnit("puffs")
  //   }
  // };

  // newly added function
  const [showMoreTypes, setShowMoreTypes] = useState(false);
const [dropdownMedType, setDropdownMedType] = useState("");
const [selectedValue, setSelectedValue] = useState("");

const additionalMedicineTypes = [
  "Respules",
  "Suspension",
  "Foam",
  "Suppository",
  "EA",
  "Device",
  "Box",
  "Spray",
  "Lotion",
  "Tube",
  "Gargle",
  "Powder",
  "Soap",
  "Aerosol",
  "Shampoo",
  "Topical Cleanser",
  "Custom"
];

const handleDropdownMedTypeChange = (value) => {
  setMedicineType("");
  setDropdownMedType(value);
  setSelectedValue(value);
  handlemedicinetypechange(value, "dropdown");
};
const handlemedicinetypechange = (value, source = "") => {
  console.log("Changing medicine type:", value, "from source:", source);
  
  // ALWAYS clear the opposite input
  if (source === "radio") {
    // Radio selected → clear dropdown
    setDropdownMedType(""); // THIS IS THE KEY FIX
    setMedicineType(value);
  } 
  else if (source === "dropdown") {
    // Dropdown selected → clear radio
    setMedicineType(""); // Clear radio selection
    setDropdownMedType(value);
  }
  
  // Set selected value for whatever else you need
  setSelectedValue(value);
  
  // Handle dosage units based on type
  if(value === "Tablet" || value === "Capsule" || value === "Suppository" || value === "Sachet" || value === "Powder"){
    setMedicineDosageUnit("mg");
  }
  else if (value === "Syrup" || value === "Injection" || value === "Nebulization" || value === "IV Fluids" || value === "Drops" || value === "Suspension" || value === "Respules" || value === "Gargle" || value === "Shampoo" || value === "Topical Cleanser"){
    setMedicineDosageUnit("ml");
  }
  else if (value === "Ointment" || value === "Cream" || value === "Gel" || value === "Foam" || value === "Lotion" || value === "Tube" || value === "Soap"){
    setMedicineDosageUnit("grms");
  }
  else if (value === "Inhaler" || value === "Spray" || value === "Aerosol"){
    setMedicineDosageUnit("puffs");
  }
  else if (value === "EA" || value === "Device" || value === "Box"){
    setMedicineDosageUnit("each");
  }
  else if (value === "Custom"){
    setMedicineDosageUnit("");
  }
};

const setDosageUnitBasedOnType = (type) => {
  if(type === "Tablet" || type === "Capsule" || type === "Suppository" || type === "Sachet" || type === "Powder"){
    setMedicineDosageUnit("mg");
  }
  else if (type === "Syrup" || type === "Injection" || type === "Nebulization" || type === "IV Fluids" || type === "Drops" || type === "Suspension" || type === "Respules" || type === "Gargle" || type === "Shampoo" || type === "Topical Cleanser"){
    setMedicineDosageUnit("ml");
  }
  else if (type === "Ointment" || type === "Cream" || type === "Gel" || type === "Foam" || type === "Lotion" || type === "Tube" || type === "Soap"){
    setMedicineDosageUnit("grms");
  }
  else if (type === "Inhaler" || type === "Spray" || type === "Aerosol"){
    setMedicineDosageUnit("puffs");
  }
  else if (type === "EA" || type === "Device" || type === "Box"){
    setMedicineDosageUnit("each");
  }
  else if (type === "Custom"){
    setMedicineDosageUnit("");
  }
};
//   const handlemedicinetypechange = (event, type = "") => {
//     setMedicineType(event);
//     setDropdownMedType("");
//     setSelectedValue(event);
//     if(type == "filter"){
//       setFilterMedicinetype(event);
//     }
//     if(event == "Tablet" || event == "Capsule" || event == "Suppository" || event == "Sachet" || event == "Powder"){
//       setMedicineDosageUnit("mg");
//     }
//     else if (event == "Syrup" || event == "Injection" ||  event == "Nebulization" ||  event == "IVFluids" || event == "Drops" || event == "Suspension" || event == "Respules" || event == "Gargle" || event == "Shampoo" || event == "Topical Cleanser"){
//       setMedicineDosageUnit("ml");
//     }
//     else if (event == "Ointment" || event == "Cream" || event == "Gel" || event == "Foam" || event == "Lotion" || event == "Tube" || event == "Soap"){
//       setMedicineDosageUnit("grms");
//     }
//     else if (event == "Inhaler" || event == "Spray" || event == "Aerosol"){
//       setMedicineDosageUnit("puffs");
//     }
//     else if (event == "EA" || event == "Device" || event == "Box"){
//       setMedicineDosageUnit("each");
//     }
//     else if (event == "Custom"){
//       // For custom, you might want to set a default or leave it empty
//       setMedicineDosageUnit("");
//     }
// };

  const handleChangeDosageUnit = (selectedOption) => {
    setMedicineDosageUnit(selectedOption.label);
  };

  const fetchComposition = async (medicineName) => {
    const inputData = {
      input: {
        name: medicineName,
      },
    };
    if(medicineName){
    try {
       showLoader();
      const result = await GetAIMedicineComposition(inputData.input);
      // console.log(result);
      if (result) {
        showSuccessToast("Medicine composition fetched successfully");
        setComposition(result.chemical_composition);
        setMedicineExpiryDate(result.expiry_date);
        setBenifit(result.benefit);
        setSideEffects(result.side_effects);
        if (Array.isArray(result.Manufacturer)) {
          setManufacturer(result.Manufacturer.join(", "));
        } else {
          setManufacturer(result.Manufacturer || ""); 
        }
        if (Array.isArray(result.TherapeuticCategory)) {
          setTherapeutic(result.TherapeuticCategory.join(", "));
        } else {
          setTherapeutic(result.TherapeuticCategory || "");
        }
        if (Array.isArray(result.DrugClass)) {
          setDrugClass(result.DrugClass.join(", "));
        } else {
          setDrugClass(result.DrugClass || ""); 
        }
        setInstructions(result.InstructionsOfAdministration);
      }
      dismissLoader()
    } catch (error) {
      console.error("Error Fetching Medicine composition:", error);
      showErrorToast("An error occurred while Fetching Medicine composition");
    } 
      
  }else{
    showErrorToast("Please provide medicine name or upload medicine photo")
  }
  };
  const fetchEditComposition = async (medicineName) => {
    const inputData = {
      input: {
        name: medicineName,
      },
    };
    if(medicineName){
    try {
       showLoader();
      const result = await GetAIMedicineComposition(inputData.input);
      // console.log(result);
      if (result) {
        showSuccessToast("Medicine composition fetched successfully");
        setComposition(result.chemical_composition);
        setMedicineExpiryDate(result.expiry_date);
        setBenifit(result.benefit);
        setSideEffects(result.side_effects);
        if (Array.isArray(result.Manufacturer)) {
          setManufacturer(result.Manufacturer.join(", "));
        } else {
          setManufacturer(result.Manufacturer || ""); 
        }
        if (Array.isArray(result.TherapeuticCategory)) {
          setTherapeutic(result.TherapeuticCategory.join(", "));
        } else {
          setTherapeutic(result.TherapeuticCategory || "");
        }
        if (Array.isArray(result.DrugClass)) {
          setDrugClass(result.DrugClass.join(", "));
        } else {
          setDrugClass(result.DrugClass || ""); 
        }
        setEditInstructions(result.InstructionsOfAdministration);
      }
      dismissLoader()
    } catch (error) {
      console.error("Error Fetching Medicine composition:", error);
      showErrorToast("An error occurred while Fetching Medicine composition");
    } 
      
  }else{
    showErrorToast("Please provide medicine name or upload medicine photo")
  }
  };

  // const handleFrequencyValue = (selectedOption) => {
  //   setMedicineDosageFrequency(selectedOption)
  //   // if(selectedOption == "1"){
  //   //   setMedicineDosageFrequency("1");
  //   // }else  if(selectedOption == "2"){
  //   //   setMedicineDosageFrequency("2");
  //   // }else  if(selectedOption == "3"){
  //   //   setMedicineDosageFrequency("3");
  //   // }else  if(selectedOption == "4"){
  //   //   setMedicineDosageFrequency("4");
  //   // }
  // };

  const handleExpiryDateChange = (event) => {
    //const formattedDate = moment(selecteddate).format('YYYY-MM-DD');
    setMedicineExpiryDate(event);
  };

  // const handlemedicinetime = (values) => {
  //   if (values.includes("morning")) {
  //     setMorning(1);
  //   } else {
  //     setMorning(0);
  //   }

  //   if (values.includes("afternoon")) {
  //     setAfternoon(1);
  //   } else {
  //     setAfternoon(0);
  //   }
  //   if (values.includes("evening")) {
  //     setEvening(1);
  //   } else {
  //     setEvening(0);
  //   }
  
  //   if (values.includes("night")) {
  //     setNight(1);
  //   } else {
  //     setNight(0);
  //   }
  // };

  // const handlemedicinetimebeforeafter = (values) => {
  //   if (values.includes("beforefood")) {
  //     setBeforefood(1);
  //   } else {
  //     setBeforefood(0);
  //   }
  
  //   if (values.includes("afterfood")) {
  //     setAfterfood(1);
  //   } else {
  //     setAfterfood(0);
  //   }
  // };

  // const [timeValues, setTimeValues] = useState([]);
              // const [foodTiming, setFoodTiming] = useState(""); 
  
              const handlemedicinetime = (values) => {
                
                // If any time checkbox is selected, clear frequency inputs
                if (values.length > timeValues.length) {
                  // if (values.length > 0) {
                    setMedicineFreqUnit("");
                    setMedicineFreqValue("");
                    // setMedicineFreqValue(null);
                  }
                  setTimeValues(values);
                
                // Update individual time states if needed
                setMorning(values.includes("morning") ? 1 : 0);
                setAfternoon(values.includes("afternoon") ? 1 : 0);
                setNight(values.includes("night") ? 1 : 0);
              };
              
  const handlemedicinetimebeforeafter = (value) => {
    setFoodTiming(value);
    if (value === "beforefood") {
      setBeforefood(1);
      setAfterfood(0);
    } else {
      setBeforefood(0);
      setAfterfood(1);
    }
  };

  const filterSurgeonNames = (surgeonName) => {
    const filtered = treatmentteamdata && treatmentteamdata.filter((surgeon) =>
      surgeon.doctorname?.toLowerCase().includes(surgeonName.toLowerCase())
    );
    setSuggestions(filtered);
  };

  const handleSelect = (suggestion) => {
    setPrescribedBy(suggestion.doctorname);
    setSuggestions([]);
  };

  const handleMedicationUpload = async (e) => {
    e.preventDefault();
    showLoader();

    const file2 = e.target.files[0];
    const allowedTypes = ["image/png", "image/jpeg", "image/jpg", "image/webp"];
    if (!allowedTypes.includes(file2.type)) {
      showErrorToast("Invalid file type. Please select a PNG, JPG or JPEG file.");
      setTimeout(() => {
        
        dismissLoader();
      }, 1000);
      return false;
    }
    const reader = new FileReader();
    reader.readAsDataURL(file2);
    //console.log(file2 , "File")
    const result = await uploadImageInProfile(file2, file2.name);
    //console.log(result , "result.name ");
    const filename = result.name;
    setFilenameArray(prev => [...prev, filename]);
    
    e.target.value = ''; 
    dismissLoader();

  };


function clearState (){
  setRouteOfAdministration(null);
  setTiming(null);
  setQuantity(null);
  setAreaOfApplication(null);
  setDiluent(null);
  setInfusionDuration(null);
  setAdditives(null);
  setDuration(null)
  setMedicineFreqValue(null); 
  setMedicineFreqUnit(null); 
  setRateOfInfusionValue(null);
  setRateOfInfusionUnit("ml/hr")
  
  setDurationValue("3"); 
  setDurationUnit("Days"); 

  setCustomMessage(null);
  setSOS(null);
}
const addData = () => {
  setFilenameArray([]);
  setMedicineName("") 
  setComposition("") 
  // setFromDate(moment().format("DD-MM-yyyy"))
  // setToDate(moment().format("DD-MM-yyyy"))
  setHospitalname(null)
  setPrescribedBy(null)
  setMedicineType("Tablet")
  setDropdownMedType("")
  setMedicineDosageUnit("mg")
  setMedicineDosage(null)
  setMedicineDosageFrequency("1")
  setMorning("1")
  setEvening("0")
  setAfternoon("0")
  setNight("0")
  // Default to AFTER food now
  setBeforefood('0')
  setAfterfood('1')
  setMedicineFreqUnit("")
  setMedicineFreqValue(null)
  setComposition("")
  setTimeValues(["morning"]);
  // Clear Application Timing for Add modal; user must choose explicitly
  setFoodTiming("");
  setMedicineExpiryDate("")
  setDrugClass("");
  setManufacturer("");
  setTherapeutic("");
  setInstructions("");
  setShowAIModal(true)

  clearState();
  // addmedications.current.openRight()
  setIsAddModalOpen(true);
  addmedications.current.openModal()
  setShowDocNamesDropdown(false)
 
}
// const addData = () => {
//   setFilenameArray([]);
//   setMedicineName("") 
//   setComposition("") 
//   // setFromDate(moment().format("DD-MM-yyyy"))
//   // setToDate(moment().format("DD-MM-yyyy"))
//   setHospitalname(null)
//   setPrescribedBy(null)
//   setMedicineType("Tablet")
//   setDropdownMedType("")
//   setMedicineDosageUnit("mg")
//   setMedicineDosage(null)
//   setMedicineDosageFrequency("1")
//   setMorning("1")
//   setEvening("0")
//   setAfternoon("0")
//   setNight("0")
//   setBeforefood('1')
//     setAfterfood('0')
//     setMedicineFreqUnit("")
//     setMedicineFreqValue(null)
//   setComposition("")
//   setTimeValues(["morning"]);
//   setFoodTiming("beforefood");
//   setMedicineExpiryDate("")
//   setDrugClass("");
//   setManufacturer("");
//   setTherapeutic("");
//   setInstructions("");
//   setShowAIModal(true)

//   clearState();
//   // addmedications.current.openRight()
//   setIsAddModalOpen(true);
//   addmedications.current.openModal()
//   setShowDocNamesDropdown(false)
 
// }

// ------------------------------------------------------------
  // Edit medication

  const handleeditmedication = (item)=>{
    // include new fields in log for debugging
    console.log({
      ...item,
      wheretoapply: item.wheretoapply,
      applicationtiming: item.applicationtiming,
      quantitytobeapplied: item.quantitytobeapplied,
      quantity: item.quantity
    }, " edit modal item ")
    setID(item.id);
    setMedicineName(item.medicinename);
    setComposition(item.chemicalcomposition);
    setEditInstructions(item.instructions);
    // setMedicineType(item.medicinetype);
    // setDropdownMedType(item.medicinetype);
    // Set the initial selection
  if (additionalMedicineTypes.includes(item.medicinetype)) {
    setDropdownMedType(item.medicinetype);
    setSelectedValue(item.medicinetype);
    setMedicineType("");
  } else {
    setMedicineType(item.medicinetype);
    setDropdownMedType("");
    setSelectedValue("");
    // setSelectedValue(item.medicinetype);
  }
    setMedicineDosage(item.dosage);
    setMedicineDosageUnit(item.dosageunit);
    setMedicineDosageFrequency(item.frequency);
    setMedicineFreqUnit(item.frequencytime)
    setMedicineFreqValue(item.frequencyvalue)
    // const stratdate =  moment(item.medicationstartdate, 'YYYY-MM-DD').format('DD-MM-yyyy');
    // const enddate =  moment(item.medicationenddate, 'YYYY-MM-DD').format('DD-MM-yyyy');
    // setFromDate(stratdate)
    // setToDate(enddate);
    setMorning(item.morning);
    setEvening(item.evening);
    setAfternoon(item.afternoon);
    setNight(item.night);
    setBeforefood(item.beforefood);
    setAfterfood(item.afterfood);
    setPrescribedBy(item.prescribedby)
    setHospitalname(item.prescribedhospitalname)
    // setIsChecked(item.iscurrentmedicine)
    setIsChecked(item.iscurrentmedicine === "Current" ? 1 : 0);
    setMaxDateStateEdit("")
    setMinDateStateEdit("")
    setMedicineExpiryDate(item.medicineexpirydate)
    setShowDocNamesDropdown(false)
    setShowAIModal(true)

    // new Input states set on Edit modal open - Start ||----
    setRouteOfAdministration(item.routeofadministration);
    setTiming(item.timingofinjection);
    setQuantity(item.quantitytobeapplied ?? item.quantity ?? null);
    setAreaOfApplication(item.wheretoapply || item.areaofapplication);
    setDiluent(item.diluent);
    setInfusionDuration(item.infusionDuration);
    setAdditives(item.additives);
    
    setRateOfInfusionUnit(item.rateofinfusionunit)
    setRateOfInfusionValue(item.rateofinfusionvalue)

    setDuration(item.duration);
    setDrugClass(item.drugclass);
    setManufacturer(item.manufacturer);
    setTherapeutic(item.therapeutic);
    // setInstructions(item.instructions);
    setTimeValues([
      item.morning ? "morning" : null,
      item.afternoon ? "afternoon" : null,
      item.night ? "night" : null,
    ])
    setMedicineTypeRadio(item.medicinetype)
    setFoodTiming(item.applicationtiming || (item.beforefood ? "beforefood" : "afterfood"))
    // setMedicineDosageFrequency(item.frequency);

    if (item.duration) {
      const parts = item.duration.split(" "); 
      const value = parts[0]; 
      const unit = parts[1];  
      // setMedicineFreqValue(value); 
      // setMedicineFreqUnit(unit);  
      setDurationValue(value); 
      setDurationUnit(unit);  
    }

    // if (item.frequency) {
    //   const parts = item.frequency.split(" "); 
    //   const value = parts[0]; 
    //   const unit = parts[1];  
    //   setMedicineDosageFrequency(value); 
    //   setMedicineFreqUnit(unit);  
    // }

    // if (item.duration) {
    //     const parts = item.duration.split(" "); 
    //     const value = parts[0]; 
    //     const unit = parts[1];  
    //     setDurationValue(value); 
    //     setDurationUnit(unit);  
    //   }

      // setSOS(item.sos)
      // setCustomMessage(item.custommessage)
    // new Input states set on Edit modal open - End ----||

  setIsEditModalOpen(true)
    editmedications.current.openModal();
  }

  const fetchData = async (type, tab) => {
    showLoader();
    setData("");
    try {
      const result = await FetchMedicationsData({
        // patientid,
        doctorid: getLoginID(),
        medicinetype: type,
        // iscurrent: tab,
      });
      //console.log(result, "modified medications res");
      if (result != null) {
        setData(result);
      } else {
        //alert("No data");
      }
      dismissLoader();
    } catch (error) {
      console.error("Error in DashboardIndex:", error);
    }
  };

  useEffect(()=>{
    if(!medicinename){
      setComposition("")
    }
  },[medicinename])

  // new input fields added functionality || start 

  const handleRateOfInfusionUnit = (selectedOption) => {
    setRateOfInfusionUnit(selectedOption.label);
  };

  // function handleFrequencyUnit(selectedOption) {
  //     setMedicineFreqUnit(selectedOption)
  // }
  function handleFrequencyUnit(selectedOption) {
                 
    if (selectedOption) {
      setTimeValues([]);
      setMorning(0);
      setAfternoon(0);
      setNight(0);
     }
     setMedicineFreqUnit(selectedOption)
 }
  function handleFrequencyValue(selectedOption) {
    
    // If frequency value is selected, clear time checkboxes
    if (selectedOption) {
      setTimeValues([]);
      setMorning(0);
      setAfternoon(0);
      setNight(0);
     }
     setMedicineFreqValue(selectedOption)
 }

 const handleEditFrequencyUnit = (selectedOption) => {
  // Clear time checkboxes when frequency unit is selected
  setTimeValues([]);
  setMorning(0);
  setAfternoon(0);
  setNight(0);
  setMedicineFreqUnit(selectedOption);
};
const handleEditFrequencyValue = (selectedOption) => {
  // Clear time checkboxes when frequency value is selected
  setTimeValues([]);
  setMorning(0);
  setAfternoon(0);
  setNight(0);
  setMedicineFreqValue(selectedOption);
};

  function handleDurationValue(selectedOption) {
      setDurationValue(selectedOption)
  }
  function handleDurationUnit(selectedOption) {
    // if(selectedOption != "Until symptoms resolve"){
      setDurationUnit(selectedOption)
    // }
  }

  function handleRouteOfAdministration(selectedOption) {
    setRouteOfAdministration(selectedOption)
  }
  
  function handleTiming(e) {
    setTiming(e.target.value)
  }
  
  function handleQuantity(selectedOption) {
    setQuantity(selectedOption)
  }
  
  function handleAreaOfApplication(e) {
    setAreaOfApplication(e.target.value)
  }
  function handleDrugClass(e) {
    setDrugClass(e.target.value)
  }
  function handleTherapeuticCategory(e) {
    setTherapeutic(e.target.value)
  }
  function handleManufacturer(e) {
    setManufacturer(e.target.value)
  }
  function handleInstructions(value) {
    // console.log('e: ', e.target.value)
    setInstructions(value)
  }
  function handleEditInstructions(value) {
    // console.log('e: ', e.target.value)
    setEditInstructions(value)
  }
  
  function handleDiluent(selectedOption) {
    setDiluent(selectedOption)
  }
  
  function handleInfusionDuration(selectedOption) {
    setInfusionDuration(selectedOption)
  }
  function handleInfusionFrequency(selectedOption) {
    setInfusionFrequency(selectedOption)
  }
  
  function handleAdditives(e) {
    setAdditives(e.target.value)
  }

  function handleSOS(e) {
    setSOS(e.target.value)
  } 
  function handleCustomMessage(e) {
    setCustomMessage(e.target.value)
  }
  
  // new input fields added functionality End ||

  // --------------------------------------------------------------------
// Delete functionality
const [medicineId, setMedicineId] = useState(null);
const [medName, setMedName] = useState(null);

const [timeValues, setTimeValues] = useState([]);
            const [foodTiming, setFoodTiming] = useState(""); 
const [productQuantity, setProductQuantity] = useState("1");


const handleconsumptionfrequencychange = (selectedOption) => {
  setMedicineDosageFrequency(selectedOption)
};
const handleMonthYearChange = (date) => {
                setMedicineExpiryDate(moment(date).format('MM-yyyy'));
              };

              const handleTimeChange = (time) => {
                // Clear frequency inputs when checking a time
                if (time === "morning" && morning !== 1) {
                  setMedicineFreqUnit("");
                  setMedicineFreqValue("");
                } else if (time === "afternoon" && afternoon !== 1) {
                  setMedicineFreqUnit("");
                  setMedicineFreqValue("");
                } else if (time === "night" && setnight !== 1) {
                  setMedicineFreqUnit("");
                  setMedicineFreqValue("");
                }
              
                // Update the specific time state
                switch(time) {
                  case "morning":
                    setMorning(morning === 1 ? 0 : 1);
                    break;
                  case "afternoon":
                    setAfternoon(afternoon === 1 ? 0 : 1);
                    break;
                  case "night":
                    setNight(setnight === 1 ? 0 : 1);
                    break;
                }
              };

              const handleFoodTimingChange = (value) => {
                setFoodTiming(value);
                setBeforefood(value === "before" ? 1 : 0);
                setAfterfood(value === "after" ? 1 : 0);
              };
              // const [night, setNight] = useState(0);
  function handleAdministration(data) {
    // console.log('modal Data data: ', data)
    setModalData({
      duration: data.duration,
      frequency: data.frequency,
      frequencytime: data.frequencytime,
      frequencyvalue: data.frequencyvalue,
      morning: data.morning,
      afternoon: data.afternoon,
      evening: data.evening,
      beforefood: data.beforefood,
      afterfood: data.afterfood,
      instructions: data.instructions,

      medicinename: data.medicinename,
      medicinetype: data.medicinetype,
      dosage: data.dosage,
      dosageunit: data.dosageunit,
      chemicalcomposition: data.chemicalcomposition,
      therapeutic: data.therapeutic,
      manufacturer: data.manufacturer,
      drugclass: data.drugclass,
    })
    administration.current.openModal()
  }

  const medicineTypes = [
    "Tablet",
    "Capsule",
    "Syrup",
    "Injection",
    "Ointments / Creams / Gels",
    "Drops",
    "Nebulization",
    "IVFluids",
    "Inhaler",
  ];
  const adminData = {
    "doctorid": "user123",
    "id": "MED456", 
    "documenttype_cd": "PRESCRIPTION",
    "documentcategory_cd": "MED_ORDER",
    "documentname": "Prescription for Paracetamol",
    "documenturl": "/documents/prescription_456.pdf",
    "prescribedby": "Dr. Smith",
    "hospitalname": "City General Hospital",
    "documentdate": "2025-05-05",
    "medicinename": "Paracetamol",
    "chemical_composition": "Paracetamol 500mg",
    "medicinetype": "Tablet",
    "dosage": "500",
    "dosageunit": "mg",
    "frequency": "2",
    "morning": true,
    "afternoon": false,
    "evening": false,
    "night": true,
    "beforefood": false,
    "afterfood": true,
    "medicineexpirydate": "2026-12-31",
    "iscurrentmedicine": true,
    "longtext": "Take as needed for pain or fever.",
    "documents": [
      { "filename": "prescription_scan_1.jpg" }
    ],
    "routeofadministration": "Oral",
    "timingofinjection": null,
    "quantitytobeapplied": null,
    "areaofapplication": null,
    "diluent": null,
    "additives": null,
    "rateofinfusionvalue": null,
    "rateofinfusionunit": null,
    "duration": "7 Days", // Example duration
    "drugclass": "Analgesic, Antipyretic",
    "therapeutic": "Pain Relief, Fever Reduction",
    "manufacturer": "ABC Pharmaceuticals",
    "instructions": "Take one tablet after meals, twice daily for 7 days.",
    "timingDetails": {
      "morning": true,
      "afternoon": false,
      "night": true,
      "relationToFood": "After Food"
    },
    "frequencyDetails": {
      "type": "Interval",
      "intervalValue": "2",
      "intervalUnit": "Times per day"
    }
  }

  const isChatbotAllowed = () => {
  const subscriptionName = localStorage.getItem("subscriptionName");
  const subscriptionEndDate = localStorage.getItem("subscriptionEndDate");
  
  // If either value is missing, assume chatbot is allowed (or you can handle differently)
  if (!subscriptionName || !subscriptionEndDate) return true;
  
  // Check if subscription is Basic and end date has passed
  const currentDate = new Date();
  const endDate = new Date(subscriptionEndDate);
  
  // return !(subscriptionName === "Basic");
  return !(subscriptionName === "Basic" && currentDate > endDate);
};
// ----------------------- multilingual -----------------------------
// waves 
   const recorderRef = useRef(null);
     const [chunks, setChunks] = useState([]);
       const [recording, setRecording] = useState(false);
     
    const [stream, setStream] = useState(null);

    useEffect(() => {
        if (recorderRef.current) return;
    
        if (navigator.mediaDevices.getUserMedia) {
          navigator.mediaDevices
            .getUserMedia({ audio: true })
            .then((stream) => {
              setStream(stream);
    
              recorderRef.current = new MediaRecorder(stream);
              // audioContextRef.current = new AudioContext({
              //   sampleRate: WHISPER_SAMPLING_RATE,
              // });
    
              recorderRef.current.onstart = () => {
                setRecording(true);
                setChunks([]);
              };
              recorderRef.current.ondataavailable = (e) => {
                if (e.data.size > 0) {
                  setChunks((prev) => [...prev, e.data]);
                } else {
                  setTimeout(() => {
                    recorderRef.current.requestData();
                  }, 25);
                }
              };
    
              recorderRef.current.onstop = () => {
                setRecording(false);
              };
            })
            .catch((err) => console.error("The following error occurred: ", err));
        } else {
          console.error("getUserMedia not supported on your browser!");
        }
    
        return () => {
          recorderRef.current?.stop();
          recorderRef.current = null;
        };
      }, []);
    

  // ------------------------------------
  //Remove speech and keep Null to toggle between GPU and Speech
  const [SelectedLanguage, setSelectedLanguage] = useState("en-US");
  const [inpLang, setInpLang] = useState("English");
  
  const handleChangeLanguage = (selectedOption) => {
    const selectedLanguage = selectedOption.value; // Get the selected language
    setInpLang(selectedLanguage)
    const languageCode = languageCodeMap[selectedLanguage] || "en-US"; // Default to English (US) if not found

    // Update the language in the transcriber
    setSelectedLanguage(languageCode);
    // console.log("Selected Language: ", selectedLanguage);
    // console.log("Language Code: ", languageCode);
  };

  const [outLang, setOutputLang] = useState("English")
  const handleChangeOutputLanguage = (selectedOption) => {
    const selectedLanguage = selectedOption.value; 
    // const languageCode = languageCodeMap[selectedLanguage] || "en-US"; 

    // Update the language in the transcriber
    setOutputLang(selectedLanguage);
    // console.log("Selected Language OUTPUT: ", selectedLanguage);
    // console.log("Language Code OUTPUT: ", languageCode);
  };
  // const handleChangeLanguage = (e) => {
  //   setSelectedLanguage("English")
  //   const selectedLanguage = e.value;
  //   setSelectedLanguage(selectedLanguage);
  //   console.log("SelectedLanguage: ", SelectedLanguage )

  //   const languageCode = languageCodeMap[selectedLanguage] || "en-US"; // Default to English (US) if not found
  //   setLanguageCode(languageCode);
  //   console.log("languageCode: ", LanguageCode )
  // };
  const language = 'hi-IN';
const { transcriber: activeTranscriber, mode } =
  useHybridTranscriber("speech", (text) => {
    // called when speech recognition finishes
    setPlaceholder(text || "");
    setTyping(false);
},
SelectedLanguage
);
// Add this state to your parent component
const [isRecording, setIsRecording] = useState(false);

// Add this function to handle recording state changes
const handleRecordingStateChange = (recording) => {
  setIsRecording(recording);
};
// ----------------------- Add/Edit REcorder------------------------------
// const activeTranscriber = useGPUTranscriber();

  const [typing, setTyping] = useState(false); // Typing indicator state
  const [HPITextBox, SetHPITextBox] = useState("");

  const [placeholder, setPlaceholder] = useState(
    // "Click anywhere to start typing...."
    "Instructions"
  );

  useEffect(() => {
    // console.log("triggered");
    if (activeTranscriber?.output?.text) {
      setValue("textField", activeTranscriber.output.text);

      handleInstructions(activeTranscriber.output.text);
      // setPlaceholder("Click anywhere to start typing....");
      setPlaceholder("Instructions");
      setTyping(false);
    }
  }, [activeTranscriber?.output, isAddModalOpen]);
  useEffect(() => {
    // console.log("triggered");
    if (activeTranscriber?.output?.text) {
      setValue("textField", activeTranscriber.output.text);

      handleEditInstructions(activeTranscriber.output.text);
      // setPlaceholder("Click anywhere to start typing....");
      setPlaceholder("Instructions");
      setTyping(false);
    }
  }, [activeTranscriber?.output, isEditModalOpen]);

  // newly added
//   useEffect(() => {
//   if (activeTranscriber?.output?.text) {
//     const text = activeTranscriber.output.text;
//     setPlaceholder("Instructions");
//     setTyping(false);

//     if (instructions) {
//       handleInstructions(text);
//       setValue("textField", text, {
//         shouldDirty: true,
//         shouldTouch: true,
//         shouldValidate: true,
//       });
//     } else if (editCurrentMedicine) {
//       handleInstructions(text);
//       setValue("textField", text, {
//         shouldDirty: true,
//         shouldTouch: true,
//         shouldValidate: true,
//       });
//     }
//   }
// }, [activeTranscriber?.output?.text]);

  const { register, handleSubmit, watch, setValue } = useForm();
  const textFieldValue = watch("textField", "");
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const [initialText, setInitialText] = useState("");

  const onSubmit = (data) => {
      setIsButtonDisabled(true); // Disable button on submit
      // UpdateHpiTextBox(data);
      SetHPITextBox(data);
      // fetchDoctorNotesEmptyIndication();
    };
  
     // submit on tab switch and submit button is enalbed
      useEffect(()=>{
          if(!isButtonDisabled){
          handleSubmit(onSubmit)();
          }
      },[])
  
    useEffect(() => {
      if (textFieldValue !== initialText) {
        setIsButtonDisabled(false); // Enable button if text field value changes
      } else {
        setIsButtonDisabled(true); // Disable button if text field value is unchanged
      }
    }, [textFieldValue, initialText]);

const correctOrders = async (formType) => {
    // const currentText = watch("textField");
    let currentText = "";
  if (formType === "add") {
    currentText = instructions || "";
  } else if(formType === "edit") {
    currentText = editInstructions || "";
  }

  const getDoctorSpecialti = localStorage.getItem('doctorSpecialities')
  const getDoctorExp = localStorage.getItem('doctorExperience')
    
    if (!currentText) {
      showErrorToast("No text available to correct");
      return;
    }

    const inputToSave = {
      input: {
        text: currentText,
        type: `medicine_instructions#${getDoctorSpecialti}#${getDoctorExp}#ConsultationNote#${inpLang}#${outLang}`,
      },
    };

    showLoader();
    try {
      // const result = await CorrectInstructionsUsingAI(inputToSave.input);
      const result = await CorrectMedicalTermsUsingAI(inputToSave);
      if (result) {
        showSuccessToast("Updated Text");
        const updatedText = result?.text;

        if (formType === "add") {
        handleInstructions(updatedText);
        setValue("textField", updatedText, {
          shouldDirty: true,
          shouldTouch: true,
          shouldValidate: true,
        });
      } else if (formType === "edit") {
        handleEditInstructions(updatedText);
        setValue("textField", updatedText, {
          shouldDirty: true,
          shouldTouch: true,
          shouldValidate: true,
        });
      }      
        setIsButtonDisabled(false);
      }
    } catch (error) {
      console.error("Error in Correct AI call:", error);
      showErrorToast("Error Happened While Correcting.");
    } finally {
      dismissLoader();
    }
};


// ------------------- New Medicines functions 

// =========
// ======== MEDICINE TAB FUNCTIONS =================

// In your useEffect or component initialization
useEffect(() => {
  if (activeTab === "MedicineSetup") {
    fetchMedicinesList(1);
  }
  
  // ... other initialization code
}, []); // Empty dependency array for initial load
const fetchMedicinesList = async (page) => {
  showLoader();
  try {
    const input = {
      // type: 'catalog',
      type: 'favourite',
      pageno: page,
      pagesize: pagesize
    };
    
    const result = await FetchMedicineViewDetails(input);
    
    if (result && result.data) {
      setMedicineViewData(result.data);
      const count = result.count || 0;
      const calculatedTotalPages = count > 0 ? Math.ceil(count / pagesize) : 1;
      
      setMedicineTotalPages(calculatedTotalPages);
      setMedicineTotalItemCount(count);
      
      // Calculate from and to counts
      const from = count > 0 ? ((page - 1) * pagesize) + 1 : 0;
      const to = Math.min(page * pagesize, count);
      
      setMedicineCountFrom(from);
      setMedicineCountTo(to);
      
      // console.log('Medicine fetch complete:', {
      //   count,
      //   calculatedTotalPages,
      //   from,
      //   to,
      //   page,
      //   pagesize
      // });
    } else {
      setMedicineViewData([]);
      setMedicineTotalPages(1);
      setMedicineTotalItemCount(0);
      setMedicineCountFrom(0);
      setMedicineCountTo(0);
    }
  } catch (error) {
    console.error("Error fetching medicines:", error);
    setMedicineViewData([]);
    setMedicineTotalPages(1);
    setMedicineTotalItemCount(0);
    setMedicineCountFrom(0);
    setMedicineCountTo(0);
  } finally {
    dismissLoader();
  }
};
// const fetchMedicinesList = async (page) => {
//   showLoader();
//   try {
//     const input = {
//       type: 'catalog',
//       pageno: page,
//       pagesize: pagesize
//     };
    
//     const result = await FetchMedicineViewDetails(input);
    
//     if (result && result.data) {
//       setMedicineViewData(result.data);
//       const count = result.count || 0;
//       const calculatedTotalPages = count > 0 ? Math.ceil(count / pagesize) : 1;
      
//       setMedicineTotalPages(calculatedTotalPages);
//       setMedicineTotalItemCount(count);
      
//       const from = count > 0 ? ((page - 1) * pagesize) + 1 : 0;
//       const to = Math.min(page * pagesize, count);
      
//       setMedicineCountFrom(from);
//       setMedicineCountTo(to);
//     } else {
//       setMedicineViewData([]);
//       setMedicineTotalPages(1);
//       setMedicineTotalItemCount(0);
//       setMedicineCountFrom(0);
//       setMedicineCountTo(0);
//     }
//   } catch (error) {
//     console.error("Error fetching medicines:", error);
//     setMedicineViewData([]);
//     setMedicineTotalPages(1);
//     setMedicineTotalItemCount(0);
//     setMedicineCountFrom(0);
//     setMedicineCountTo(0);
//   }
//   dismissLoader();
// };

// const handleMedicineNextClick = () => {
//   if (medicineCurrentPage < medicineTotalPages) {
//     const nextPage = medicineCurrentPage + 1;
//     setMedicineCurrentPage(nextPage);
//     fetchMedicinesList(nextPage);
//   }
// };

// const handleMedicinePrevClick = () => {
//   if (medicineCurrentPage > 1) {
//     const prevPage = medicineCurrentPage - 1;
//     setMedicineCurrentPage(prevPage);
//     fetchMedicinesList(prevPage);
//   }
// };

const handleMedicineNextClick = () => {
  if (medicineCurrentPage < medicineTotalPages) {
    const nextPage = medicineCurrentPage + 1;
    setMedicineCurrentPage(nextPage);
    if (isFilterApplied()) {
      getFilteredMedicineResults(nextPage);
    } else {
      fetchMedicinesList(nextPage);
    }
  }
};

const handleMedicinePrevClick = () => {
  if (medicineCurrentPage > 1) {
    const prevPage = medicineCurrentPage - 1;
    setMedicineCurrentPage(prevPage);
    if (isFilterApplied()) {
      getFilteredMedicineResults(prevPage);
    } else {
      fetchMedicinesList(prevPage);
    }
  }
};
// Helper function to check if filters are applied
const isFilterApplied = () => {
  return search.composition || 
         search.medicine || 
         search.drugClass || 
         search.therapeutic || 
         filterMedicinetype || 
         fromDate || 
         toDate;
};

const handleApplyFilters = () => {
  setMedicineCurrentPage(1);
  setIsMedicineFilterApplied(true); // Set filter flag
  getFilteredMedicineResults(1);
  // setMedicineCurrentPage(1);
  // getFilteredMedicineResults(1);
};

const getFilteredMedicineResults = async (page) => {
  showLoader();
  try {
    // const input = {
    //   composition: search.composition?.trim() || null,
    //   medicinetype: filterMedicinetype || null,        
    //   drugclass: search.drugClass?.trim() || null,
    //   // type: 'catalog',
    //   type: 'favourite',
    //   therapeutic: search.therapeutic?.trim() || null,
    //   medicinename: search.medicine?.trim() || null,
    //   startdate: formatDate_YYYY_MM_DD(fromDate) || null,
    //   enddate: formatDate_YYYY_MM_DD(toDate) || null,
    //   pageno: page,
    //   pagesize: pagesize
    // };
    const input = {
      type: 'favourite',
      searchtext: search.medicine?.trim() || null,
      pageno: page,
      pagesize: pagesize
    };
    
    const result = await FetchFilteredMedicinesList(input);
    
    if (result && result.data) {
      setMedicineViewData(result.data);
      const count = result.count || 0;
      const calculatedTotalPages = count > 0 ? Math.ceil(count / pagesize) : 1;
      
      setMedicineTotalPages(calculatedTotalPages);
      setMedicineTotalItemCount(count);
      
      const from = count > 0 ? ((page - 1) * pagesize) + 1 : 0;
      const to = Math.min(page * pagesize, count);
      
      setMedicineCountFrom(from);
      setMedicineCountTo(to);
    } else {
      setMedicineViewData([]);
      setMedicineTotalPages(1);
      setMedicineTotalItemCount(0);
      setMedicineCountFrom(0);
      setMedicineCountTo(0);
    }
  } catch (error) {
    console.error("Error filtering medicines:", error);
    setMedicineViewData([]);
    setMedicineTotalPages(1);
    setMedicineTotalItemCount(0);
    setMedicineCountFrom(0);
    setMedicineCountTo(0);
  }
  dismissLoader();
};

const addmedicine = async () => {
  if (!medicinename) {
    showErrorToast("Please specify medicine name");
    return false;
  }
  
  showLoader();
  try {
    const input = {
      doctorid: "",
          'type': 'favourite',
      medicinedetail: [{
        medicinename: medicinename,
        chemical_composition: Composition,
        medicinetype: medicinetype || dropdownMedType || "Tablet",
        dosage: dosage,
        dosageunit: dosageunit,
        frequency: frequency || "1",
        frequencytime: medicineFreqUnit,
        frequencyvalue: medicineFreqValue || null,
        morning: morning,
        afternoon: afternoon,
        evening: setevening,
        night: setnight,
        beforefood: beforefood,
        afterfood: afterfood,
        medicineexpirydate: medicineexpirydate,
        iscurrentmedicine: IsChecked,
        documents: filenameArray.map(filename => ({ filename })),
        routeofadministration: routeOfAdministration,
        timingofinjection: timing,
        quantitytobeapplied: quantity,
        areaofapplication: areaOfApplication,
        productQuantity: productQuantity || "1",
        applicationtiming: foodTiming || null,
        wheretoapply: areaOfApplication || null,
        diluent: diluent,
        additives: additives,
        rateofinfusionvalue: rateOfInfusionValue,
        rateofinfusionunit: rateOfInfusionUnit,
        duration: durationValue && durationUnit ? (durationValue + " " + durationUnit) : durationValue || "5 Days",
        drugclass: drugClass,
        therapeutic: therapeutic,
        manufacturer: manufacturer,
        instructions: instructions,
      }],
    };
    
    const result = await AddMedicine(input);
    
    if (result && result.output.result === 'success') {
      showSuccessToast("Medicine created successfully");
      addmedications.current.closeModal();
      setIsAddModalOpen(false);
      fetchMedicinesList(medicineCurrentPage);
    } else if (result.output.result === "failure") {
      showErrorToast(result.output.message || "Failed to add medicine");
    }
  } catch (error) {
    console.error("Error adding medicine:", error);
    showErrorToast("Error adding medicine");
  }
  dismissLoader();
};

const editmedicine = async () => {
  if (!medicinename) {
    showErrorToast("Please specify medicine name");
    return false;
  }
  
  showLoader();
  try {
    const input = {
      doctorid: "",
    'type': 'favourite',
      id: id,
      medicinename: medicinename,
      chemical_composition: Composition,
      medicinetype: medicinetype || dropdownMedType,
      dosage: dosage,
      dosageunit: dosageunit,
      frequency: frequency,
      frequencytime: medicineFreqUnit,
      frequencyvalue: medicineFreqValue,
      morning: morning,
      afternoon: afternoon,
      evening: setevening,
      night: setnight,
      beforefood: beforefood,
      afterfood: afterfood,
      medicineexpirydate: medicineexpirydate,
      iscurrentmedicine: IsChecked,
      documents: filenameforUpload.map(filename => ({ filename })),
      routeofadministration: routeOfAdministration,
      timingofinjection: timing,
      quantitytobeapplied: quantity,
      areaofapplication: areaOfApplication,
      productQuantity: productQuantity || "1",
      applicationtiming: foodTiming || null,
      wheretoapply: areaOfApplication || null,
      diluent: diluent,
      additives: additives,
      rateofinfusionvalue: rateOfInfusionValue,
      rateofinfusionunit: rateOfInfusionUnit,
      duration: durationValue && durationUnit ? (durationValue + " " + durationUnit) : durationValue,
      drugclass: drugClass,
      therapeutic: therapeutic,
      manufacturer: manufacturer,
      instructions: editInstructions,
    };
    
    const result = await EditMedicine(input);
    
    if (result) {
      showSuccessToast("Medicine updated successfully");
      editmedications.current.closeModal();
      setIsEditModalOpen(false);

       setMedicineName("");
      setComposition("");
      setEditInstructions("");

      if (isMedicineFilterApplied || 
          search.composition || 
          search.medicine || 
          search.drugClass || 
          search.therapeutic || 
          filterMedicinetype || 
          fromDate || 
          toDate) {
        // If filters are applied, refresh filtered results
        getFilteredMedicineResults(medicineCurrentPage);
      } else {
        // Otherwise, refresh normal list
        fetchMedicinesList(medicineCurrentPage);
      }
      // fetchMedicinesList(medicineCurrentPage);
    }
  } catch (error) {
    console.error("Error updating medicine:", error);
    showErrorToast("Error updating medicine");
  }
  dismissLoader();
};

const openDeleteMedicineModal = (id, medicine) => {
  setMedicineId(id);
  setMedName(formatMedicineName(medicine));
  dynamicModal.current.openModal();
};
const deleteMedicine = async () => {
  showLoader();
  try {
    const result = await DeleteMedication({
      // id: medicineId,
      "loginid": getLoginID() ,
      "id": medicineId,
    'type': 'favourite',
    });
    
    if (result && result.output?.result === 'Successfully Deleted') {
      showSuccessToast("Medicine deleted successfully");
      dynamicModal.current.closeModal();
      
      // Check if we need to go to previous page after deletion
      if (medicineViewData.length === 1 && medicineCurrentPage > 1) {
        const prevPage = medicineCurrentPage - 1;
        setMedicineCurrentPage(prevPage);
        if (isFilterApplied()) {
          getFilteredMedicineResults(prevPage);
        } else {
          fetchMedicinesList(prevPage);
        }
      } else {
        // Refresh current page
        if (isFilterApplied()) {
          getFilteredMedicineResults(medicineCurrentPage);
        } else {
          fetchMedicinesList(medicineCurrentPage);
        }
      }
      
      // Reset delete modal state
      setMedicineId(null);
      setMedName('');
    } else {
      showErrorToast(result?.output?.message || "Failed to delete medicine");
    }
  } catch (error) {
    console.error("Error deleting medicine:", error);
    showErrorToast("Error deleting medicine");
  } finally {
    dismissLoader();
  }
};

const resetMedicineFields = () => {
  setSearch({
    composition: '',
    dosage: '',
    type: '',
    drugClass: '',
    medicine: '',
    manufacturer: '',
    therapeutic: ''
  });
  setFilterMedicinetype("");
  setFromDate("");
  setToDate("");
  setIsMedicineFilterApplied(false);
  setMedicineCurrentPage(1);
  fetchMedicinesList(1);
};

// Format medicine display name
const formatMedicineName = (medicine) => {
  if (!medicine) return "";
  
  const type = medicine.medicinetype?.toLowerCase() || "";
  const name = medicine.medicinename || "";
  const dosage = medicine.dosage || "";
  const dosageUnit = medicine.dosageunit || "";
  
  // Capitalize first letter of medicine name
  let formattedName = name.charAt(0).toUpperCase() + name.slice(1);
  
  // Add type prefix - USE formattedName, not name!
  if (type.includes("tab") || type === "tablet") {
    formattedName = `Tab. ${formattedName}`;
  } else if (type.includes("cap") || type === "capsule") {
    formattedName = `Cap. ${formattedName}`;
  } else if (type.includes("syr") || type === "syrup") {
    formattedName = `Syr. ${formattedName}`;
  } else if (type.includes("inj") || type === "injection") {
    formattedName = `Inj. ${formattedName}`;
  } else if (type.includes("cream")) {
    formattedName = `Crm. ${formattedName}`;
  } else if (type === "ointment" || type.includes("oint")) {
    formattedName = `Oint. ${formattedName}`;
  } else if (type.includes("drop") || type === "drops") {
    formattedName = `Drops ${formattedName}`;
  } else if (type.includes("powder")) {
    formattedName = `Powder ${formattedName}`;
  } else if (type.includes("liquid") || type.includes("solution")) {
    formattedName = `Liq. ${formattedName}`;
  } else if (type.includes("gel")) {
    formattedName = `Gel ${formattedName}`;
  }
  
  // Add dosage if available
  if (dosage) {
    formattedName = formattedName.replace(/-$/, '');
    formattedName += `-${dosage}${dosageUnit}`;
  }
  
  return formattedName;
};

  return (
      <>
         <Global
           styles={css`
             .activeTab .whiteBorder::after {
               content: "";
               position: absolute;
               left: 0%;
               transform: translateX(-20%);
               transform: translateY(440%);
               border-radius: 5px 5px 0 0;
               top: 120%;
               background: #0b1f4f;
               height: 3px;
               width: 100%;
               z-index: 1;
             }
   
             .pendingVisits .swiper-container {
               height: 100%;
               max-height: 100vw;
               min-height: 0;
               min-width: 0;
               max-width: 100vw;
               width: 100%;
               overflow: hidden;
             }
   
             .pendingVisits .swiper-slide {
               width: 285px !important;
               flex-shrink: 0;
               display: block;
               height: 100%;
               max-height: 100%;
             }
   
             .pendingVisits .swiper {
               margin: 0 !important;
             }
   
             .pendingVisits .swiper-wrapper {
               max-height: 100%;
               height: 100%t;
               display: flex;
               gap: 20px;
               padding: 0 1rem;
             }
           `}
         />
         <Box w="100%">
           {isLoading && <Loader />}
           {screenType == "web" ? (
             <Flex>
               <Box w="6rem">
                 <MiniSideBar />
               </Box>
               <Box w="calc(100vw - 6.5rem)">
                 {/* <SecondaryNav customHeader="Doctor Favourite" /> */}
                 <SecondaryNav customHeader="Favourites" />
   
                 {/* Main container start */}
                 <Flex w="100%">
                   <Box w="100%">
                     {/* Tab buttons start */}
                     <Box
                       display="flex"
                       gap="1rem"
                       borderBottom="1px solid #E6E7E9"
                       bg="white"
                       p="1.25rem 1.5rem"
                     >
                      
                       <Box
                         as="button"
                         display="flex"
                         justifyContent="center"
                         alignItems="center"
                         pos="relative"
                         className={activeTab == "MedicineSetup" ? "activeTab" : ""}
                         fontSize="0.87rem"
                         fontWeight="600"
                         onClick={() => tabChanged("MedicineSetup")}
                         color={activeTab == "MedicineSetup" ? "#061027" : "#898D97"}
                       >
                         <Text>Medicines </Text>
                         <Box as="span" className="whiteBorder" />
                       </Box>

                       <Box
                         as="button"
                         display="flex"
                         justifyContent="center"
                         alignItems="center"
                         pos="relative"
                         className={activeTab == "labsetup" ? "activeTab" : ""}
                         fontSize="0.87rem"
                         fontWeight="600"
                         onClick={() => tabChanged("labsetup")}
                         color={activeTab == "labsetup" ? "#061027" : "#898D97"}
                       >
                         <Text>Labs </Text>
                         <Box as="span" className="whiteBorder" />
                       </Box>
                       <Box
                         as="button"
                         display="flex"
                         justifyContent="center"
                         alignItems="center"
                         pos="relative"
                         className={activeTab == "imagingsetup" ? "activeTab" : ""}
                         fontSize="0.87rem"
                         fontWeight="600"
                         onClick={() => tabChanged("imagingsetup")}
                         color={activeTab == "imagingsetup" ? "#061027" : "#898D97"}
                       >
                         <Text>Imaging</Text>
                         <Box as="span" className="whiteBorder" />
                       </Box>

                        <Box
                        as="button"
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        pos="relative"
                        className={activeTab == "vaccinationsetup" ? "activeTab" : ""}
                        fontSize="0.87rem"
                        fontWeight="600"
                        onClick={() => tabChanged("vaccinationsetup")}
                        color={activeTab == "vaccinationsetup" ? "#061027" : "#898D97"}
                      >
                        <Text>Vaccinations</Text>
                        <Box as="span" className="whiteBorder" />
                      </Box>

                      <Box
                         as="button"
                         display="flex"
                         justifyContent="center"
                         alignItems="center"
                         pos="relative"
                         className={activeTab == "proceduresetup" ? "activeTab" : ""}
                         fontSize="0.87rem"
                         fontWeight="600"
                         onClick={() => tabChanged("proceduresetup")}
                         color={activeTab == "proceduresetup" ? "#061027" : "#898D97"}
                       >
                         <Text>Procedures </Text>
                         <Box as="span" className="whiteBorder" />
                       </Box>
                     </Box>
                     {/* Tab buttons end */}

                    {/* Medicinesetup setup Tab */}
                    {activeTab == "MedicineSetup" && (
                      <>
                        <Box w="100%">
        {/* <SecondaryNav customHeader="Medicine Catalog" /> */}
        <Box gap='10px' w='calc(100vw - 6rem)' p='1rem' display='flex' flexDirection='row' justifyContent='center' alignItems='center'>
            <PrimaryInput
              variant="fullRound"
              title="Search by Medicine name"
              inputPlace="Medicine name"
              name="medicine"
              onKeyDown={handleKeyDown}
              onChange={handleInputChange}
              inputValue={search.medicine}
            />
            {/* <PrimaryInput
              variant="fullRound"
              title="Search by Composition"
              inputPlace="Composition"
              name="composition"
              onKeyDown={handleKeyDown}
              onChange={handleInputChange}
              inputValue={search.composition}
            />
            <DropdownInput
              variant="fullSide"
              dropDownPlace="Type"
              inputStyleCss={{w: '65%'}}
              options={medicineTypes}
              // options={uniqueMedicineTypes}
              onClick={(selectedOption) =>
                handlemedicinetypechange(selectedOption, "filter")
              }
              value={filterMedicinetype}
            />
            <PrimaryInput
              variant="fullRound"
              title="Search by Drug class"
              inputPlace="Drug class"
              name="drugClass"
              onKeyDown={handleKeyDown}
              onChange={handleInputChange}
              inputValue={search.drugClass}
            />
            <PrimaryInput
              variant="fullRound"
              title="Search by Therapeutic"
              inputPlace="Therapeutic"
              name="therapeutic"
              onKeyDown={handleKeyDown}
              onChange={handleInputChange}
              inputValue={search.therapeutic}
            /> */}
            <Box gap='10px' pl='1rem' w='70vw' display='flex' flexDirection='row' justifyContent='center' alignItems='center'>
              <PrimaryButton buttonText="Filter" id="filterButton" onClick={handleApplyFilters}  btnStyle={{m:'0' }} />
              <PrimaryButton buttonText="Reset" id="resetButton" variant="grayBtnFull" btnStyle={{ color: "#AA2F27", m:'0' }} onClick={resetMedicineFields} />
              <PrimaryButton
                buttonText="Add"
                onClick={addData}
                btnStyle={{ m:0 }}
                isDisabled={ actionAccess && (!actionAccess.create) ? true : false} 
              />
            </Box>

            {/* <Box gap='10px' pl='1rem' w='100%' display='flex' flexDirection='row' justifyContent='center' alignItems='center'>
              <PrimaryButton
              buttonText="Drug Database Management"
              // onClick={addData}
              onClick={() => navigate("/drugdatabasemanagement")}
              btnStyle={{ m:0 }}
              variant="mdBtnFull"
              btnIcon="/assets/svgs/new-tab.svg"
              iconSrc={true}
              iconSrcStyle={{ w: "14px" }}
              isDisabled={ actionAccess && (!actionAccess.create) ? true : false} 
              />
            </Box> */}
            {noData && <p>No data available</p>}
            </Box>
        {medicineViewData && medicineViewData.length > 0 ? (
          <>
                      <SimpleGrid
                        h="calc(100vh - 210px)"
                        overflow="hidden auto"
                        border="1px solid #E6E7E9"
                        w="100%"
                        gap="1rem"
                        p="1rem"
                        columns={{ base: 1, md: 2, lg: 3 }}
                      >
                        {medicineViewData &&
                          medicineViewData.map((medicine, index) => (
                            <Card
                              borderRadius="12px"
                              key={index}
                              w="100%"
                              border="1px solid #E6E7E9"
                              boxShadow="0px 8px 20px 0px #E6E7E966"
                              h="min-content"
                            >
                              <CardBody p={{ base: "0.875rem", lg: "0.875rem", xl: "1.25rem" }}>
                                <Box
                                  display="flex"
                                  alignItems="center"
                                  justifyContent="space-between"
                                  mb="0.75rem"
                                >
                                  <Box
                                    cursor="pointer"
                                    display="flex"
                                    alignItems="center"
                                    flex="1"
                                    minW="0"
                                  >
                                    <Box display="flex" flex="1" minW="0">
                                      <Text
                                        fontSize="15px"
                                        fontWeight="600"
                                        isTruncated
                                        textOverflow="ellipsis"
                                        whiteSpace="nowrap"
                                        overflow="hidden"
                                        // title={`${medicine.medicinename} (${medicine.medicinetype}${" "} ${" "}`}
                                        title={`${formatMedicineName(medicine)}`}
                                        maxW="100%"
                                      >
                                        {/* {medicine.medicinename}  */}
                                        {formatMedicineName(medicine)} 
                                        {/* <Box as="span" bg='#E6E7E966' ml='0.25rem' border='1px solid #E6E7E9' borderRadius='8px' fontSize='10px' p='0.25rem'>
                                          {medicine.medicinetype ? medicine.medicinetype : "-"}
                                        </Box> */}
                                      </Text>
                                    </Box>
                                  </Box>

                                  <Box display="flex" width="auto" minW="1rem" gap="10px">
                                {/* <Box
                                  as="button"
                                  onClick={()=> handleAdministration(medicine)}
                                  border="1px solid #E6E7E9"
                                  borderRadius="full"
                                  w="36px"
                                  h="auto"
                                  p="10px"
                                >
                                  <Image
                                    w="16px"
                                    src="/assets/imgs/show-pass.png"
                                  />
                                </Box> */}

                                <Box
                                  as="button"
                                  onClick={() => handleeditmedication(medicine)}
                                  border="1px solid #E6E7E9"
                                  borderRadius="full"
                                  w="36px"
                                  h="auto"
                                  p="10px"
                                >
                                  <Image
                                    w="13px"
                                    src="/assets/imgs/edit-gray.png"
                                  />
                                </Box>

                                <Box
                                  as="button"
                                  onClick={() => {
                                    openDeleteMedicineModal(medicine.id, medicine);
                                  }}
                                  border="1px solid #E6E7E9"
                                  borderRadius="full"
                                  w="36px"
                                  h="auto"
                                  p="10px"
                                >
                                  <Image
                                    w="13px"
                                    src="/assets/imgs/delete.png"
                                  />
                                </Box>
                              </Box>

                                  {/* <Box display="flex" width="auto" minW="1rem" gap="10px">
                                    <Menu isLazy>
                                      <MenuButton as="button" zIndex={99}>
                                        <Image
                                          w="1rem"
                                          src="/assets/svgs/more-options.svg"
                                          transform="rotate(90deg)"
                                        />
                                      </MenuButton>
                                      <MenuList zIndex={9} pos="relative" right="0px" minW="125px">
                                        <MenuItem
                                          onClick={()=> handleAdministration(medicine)}
                                          isDisabled={
                                            actionAccess && !actionAccess.update ? true : false
                                          }
                                        >
                                          More details
                                        </MenuItem>
                                        <MenuItem
                                          onClick={() => handleeditmedication(medicine)}
                                          isDisabled={
                                            actionAccess && !actionAccess.update ? true : false
                                          }
                                        >
                                          Edit
                                        </MenuItem>
                                        <MenuItem
                                          onClick={() => {
                                            openDeleteModal(medicine.id, medicine.medicinename);
                                          }}
                                        >
                                          Delete
                                        </MenuItem>
                                      </MenuList>
                                    </Menu>
                                  </Box> */}
                                </Box>
                                <Flex w="100%" mb="0.75rem" justifyContent="space-between">
                                  <Box display="flex" flexDir="column" w={"100%"}>
                                    <Text fontSize="10px" color="gray.500">
                                      Composition
                                    </Text>
                                    <Text fontSize="12px" fontWeight="600">
                                      {/* {medicine?.chemicalcomposition ? medicine?.chemicalcomposition : "-"} - ({medicine.dosage}{" "} {medicine.dosageunit}){" "} */}

                                      {medicine?.chemicalcomposition ? medicine?.chemicalcomposition : "-"}
                                      {/* {medicine?.dosage && ` - (${medicine.dosage} ${medicine.dosageunit})`} */}
                                    </Text>
                                  </Box>
                                </Flex>

                                <Flex w="100%" gap='10px'>
                                  <Box display="flex" flexDir="column" w={"100%"}>
                                    <Text fontSize="10px" color="gray.500">
                                      Drug Class
                                    </Text>
                                    <Text fontSize="12px" fontWeight="600">
                                      {medicine.drugclass ? medicine.drugclass : "-"}
                                    </Text>
                                  </Box>
                                  <Box display="flex" flexDir="column"  w="100%">
                                    <Text fontSize="10px" color="gray.500">
                                    Therapeutic
                                    </Text>
                                    <Box as="button" w="100%">
                                      <Text
                                        fontSize="12px"
                                        fontWeight="600"
                                        isTruncated
                                        textAlign="left"
                                      >
                                        {medicine?.therapeutic ? medicine?.therapeutic : "-"}
                                      </Text>
                                    </Box>
                                  </Box>
                                  <Box w="100%" display="flex" flexDir="column">
                                    <Text fontSize="10px" color="gray.500">
                                    Manufacturer
                                    </Text>
                                    <Text fontSize="12px" fontWeight="600">
                                    {medicine?.manufacturer ? medicine?.manufacturer : "-"}
                                    </Text>
                                    
                                  </Box>
                                </Flex>
                              </CardBody>
                            </Card>
                          ))}
                      </SimpleGrid>;


<Box
w="100%"
pos="sticky"
bottom="0"
display="flex"
justifyContent="space-between"
alignItems="center"
p="0.5rem 1.5rem"
bg='white'
boxShadow="rgba(0, 0, 0, 0.35) 0px 5px 15px;"
>
<Box
  visibility={
    medicineTotalItemCount > 0 && medicineCountTo > 0 ? "visible" : "hidden"
    // medicineTotalItemCount > 0 ? "visible" : "hidden"
  }
>
  <Text>
    Showing <b>{medicineCountFrom}</b> to <b>{medicineCountTo}</b> of{" "}
    <b>{medicineTotalItemCount}</b> results
  </Text>
</Box>
<Box
  gap="2.5rem"
  display="flex"
  justifyContent="space-between"
  alignItems="center"
>
  <Box
    as="button"
    onClick={handleMedicinePrevClick}
    disabled={medicineCurrentPage === 1}
    opacity={medicineCurrentPage === 1 ? 0.5 : 1}
    cursor={medicineCurrentPage === 1 ? "not-allowed" : "pointer"}
    p="0.5rem 0.75rem"
    border="0.0625rem solid #E6E7E9"
    borderRadius="0.75rem"
    fontSize="1rem"
    fontWeight="500"
    _hover={medicineCurrentPage === 1 ? {} : { bg: "#f5f5f5" }}
  >
    Previous
  </Box>
  <Box>
    <Text textAlign="center" fontSize=".875rem" fontWeight="600">
      Page {medicineCurrentPage} of {medicineTotalPages}
    </Text>
  </Box>
  <Box
    as="button"
    p="0.5rem 0.75rem"
    border="0.0625rem solid #E6E7E9"
    borderRadius="0.75rem"
    onClick={handleMedicineNextClick}
    disabled={medicineCurrentPage === medicineTotalPages}
    opacity={medicineCurrentPage === medicineTotalPages ? 0.5 : 1}
    cursor={medicineCurrentPage === medicineTotalPages ? "not-allowed" : "pointer"}
    fontSize="1rem"
    fontWeight="500"
    _hover={medicineCurrentPage === medicineTotalPages ? {} : { bg: "#f5f5f5" }}
  >
    Next
  </Box>
</Box>
</Box>
                    {/* <Box
                      w="100%"
                      pos="sticky"
                      bottom="0"
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                      p="0.5rem 1.5rem"
                      bg='white'
                      boxShadow="rgba(0, 0, 0, 0.35) 0px 5px 15px;"
                    >
                      <Box
                        visibility={
                          medicineTotalItemCount < medicineCountTo && !totalExceedsPageCount ? "hidden" : "visible"
                        }
                      >
                        <Text>
                          Showing <b>{medicineCountFrom}</b> to <b>{medicineCountTo}</b> of {totalItemCount} results
                        </Text>
                      </Box>
                      <Box
                        gap="2.5rem"
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                      >
                        <Box
                          as="button"
                          onClick={handleMedicinePrevClick}
                          disabled={medicineCurrentPage === 1}
                          visibility={medicineCurrentPage === 1 ? "hidden" : "visible"}
                          p="0.5rem 0.75rem"
                          border="0.0625rem solid #E6E7E9"
                          borderRadius="0.75rem"
                          fontSize="1rem"
                          fontWeight="500"
                        >
                          Previous
                        </Box>
                        <Box>
                          <Text textAlign="center" fontSize=".875rem" fontWeight="600">
                            Page {medicineCurrentPage} of {medicineTotalPages}
                          </Text>
                        </Box>
                        {totalItemCount >= medicineCountTo && !totalExceedsPageCount && (
                          <Box
                            as="button"
                            p="0.5rem 0.75rem"
                            mr="2.5rem"
                            border="0.0625rem solid #E6E7E9"
                            borderRadius="0.75rem"
                            onClick={handleMedicineNextClick}
                            disabled={medicineCurrentPage === medicineTotalPages}
                            visibility={medicineCurrentPage === medicineTotalPages ? "hidden" : "visible"}
                            fontSize="1rem"
                            fontWeight="500"
                          >
                            Next
                          </Box>
                        )}
                      </Box>
                    </Box> */}

          </>
                  ) : (
                    <Box width='100%'>
                    <SimpleTable
                      headers={TableHeader}
                      // isDataPresent={false}
                    />
                    </Box>
                  )}
                      </Box>
                      </>
                    )}

                    {/* Lab setup Tab */}
                    {activeTab == "labsetup" && (
                      <>
                        <Box w="100%">
            <Box
              gap="10px"
              my="1rem"
              px="1rem"
              w="100%"
              display="flex"
              flexDirection="row"
              justifyContent="center"
              alignItems="center"
            >
            <Box w="100%" display="flex" justifyContent='space-between'>
              <Flex w='100%' gap='1rem'>
              <PrimaryInput
                  variant="fullRound"
                  inputPlace="Search"
                  // inputStyleCss={{h: "40px"}}
                  onKeyPress={searchanything}
                  maxLength={50}
                  onChange={(e) => setSerachText(e.target.value)}
                  inputValue={searchtext}
                />
                <PrimaryButton
                  buttonText="Filter"
                  id="filterButton"
                  variant="mdBtn"
                  btnStyle={{w: "80px"}}
                  onClick={Filteranything}
                />
                <PrimaryButton
                  buttonText="Reset"
                  id="resetButton"
                  variant="grayBtn"
                  btnStyle={{ color: "#AA2F27" }}
                  // onClick={()=>fetchLabList(1)}
                  onClick={resetFields}

                />
                <PrimaryButton
                  buttonText="Add"
                  id="filterButton"
                  variant="mdBtn"
                  btnStyle={{w: "80px"}}
                  onClick={openaddmodal}
                  isDisabled={
                    actionAccess && !actionAccess.create
                      ? true
                      : false
                  }
                />
              </Flex>
            </Box>
            </Box>
            <Divider />
            {lablist && lablist.length > 0 ? (
                      <Box>
                      <Flex
                        w="100%"
                        flexDir="column"
                        gap="1rem"
                        p="1rem"
                        h="calc(100vh - 70px)"
                      >
                            <SimpleTable
                              headers={TableHeader}
                              isDataPresent={true}
                              ThStyle={{
                                bg: "#FAFAFA",
                              }}
                              footerStyle={{
                                pos: "fixed",
                                bottom: "0px",
                                boxShadow: "rgba(0, 0, 0, 0.15) 0px 5px 15px 0px",
                                zIndex:'999',
                                w:"100%"
                              }}
                              tableStyle={{
                                minH: "calc(100vh - 240px)",
                                maxH: "calc(100vh - 240px)",
                                overflowY: "auto",
                                tableLayout: "fixed",
                                width: "100%",
                                border: "1px solid #E6E7E9",
                              }}
                              tableBody={
                                <>
                                  {lablist &&
                                    lablist.map((step, index) => (
                                      <Tr w="100%" key={index}>
                                        <Td w="100x">
                                        <Text fontSize=".875rem" fontWeight="500">
                                            {step.testname? step.testname:""}
                                          </Text>
                                        </Td>

                                    

                                      
                                        <Td pos='relative'>
                              <Menu isLazy>
                                <MenuButton as="button" zIndex={1}>
                                  <Image
                                    w="1.5rem"
                                    src="/assets/svgs/more-options.svg"
                                  />
                                </MenuButton>
                                <MenuList
                                  zIndex={2}
                                  pos="relative"
                                  right="100px"
                                  minW="125px"
                                >
                                  <MenuItem onClick={() => openEditModal(step)}
                                  isDisabled={ actionAccess && (!actionAccess.update) ? true : false} >
                                    Edit
                                  </MenuItem>
                                  <MenuItem onClick={() => openDeleteModal(step)}
                                  isDisabled={ actionAccess && (!actionAccess.delete) ? true : false} >
                                    Delete
                                  </MenuItem>
                                </MenuList>
                              </Menu>
                            </Td>
                                      
                                      </Tr>
                                    ))}
                                </>
                              }
                              footerSection={
  <>
  <Tr w='100%'>
  <Td colSpan={8} width='calc(100vw - 6.5rem)'>
    <Box
      w="100%"
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      p="0.5rem 0"
    >
      <Box 
        visibility={labTotalItemCount > 0 ? "visible" : "hidden"}
      >
        <Text>
          Showing <b>{labCountFrom}</b> to <b>{labCountTo}</b> of{" "}
          <b>{labTotalItemCount}</b> results
        </Text>
      </Box>
      
      <Box  
        gap="2.5rem"
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <Box 
          as="button" 
          onClick={handleLabPrevClick} 
          disabled={labCurrentPage === 1} 
          opacity={labCurrentPage === 1 ? 0.5 : 1}
          cursor={labCurrentPage === 1 ? "not-allowed" : "pointer"}
          p="0.5rem 0.75rem" 
          border="0.0625rem solid #E6E7E9" 
          borderRadius="0.75rem" 
          fontSize="1rem" 
          fontWeight="500"
          _hover={labCurrentPage === 1 ? {} : { bg: "#f5f5f5" }}
        >
          Previous
        </Box>
        
        <Box>
          <Text textAlign="center" fontSize=".875rem" fontWeight="600">
            Page {labCurrentPage} of {labTotalPages}
          </Text>
        </Box>
        
        <Box 
          as="button" 
          p="0.5rem 0.75rem" 
          border="0.0625rem solid #E6E7E9" 
          borderRadius="0.75rem" 
          onClick={handleLabNextClick} 
          disabled={labCurrentPage === labTotalPages} 
          opacity={labCurrentPage === labTotalPages ? 0.5 : 1}
          cursor={labCurrentPage === labTotalPages ? "not-allowed" : "pointer"}
          fontSize="1rem" 
          fontWeight="500"
          _hover={labCurrentPage === labTotalPages ? {} : { bg: "#f5f5f5" }}
        >
          Next
        </Box>
      </Box>
    </Box>
  </Td>
  </Tr>
  </>
  }
                            //  footerSection={
                            //    <>
                            //      <Tr w='100%'>
                            //        <Td colSpan={8} width='calc(100vw - 6.5rem)'>
                            //          <Box
                            //            w="100%"
                            //            display="flex"
                            //            justifyContent="space-between"
                            //            alignItems="center"
                            //          >
                            //             <Box 
                            //          visibility={(totalItemCount < countTo && !totalExceedsPageCount)  ? "hidden" : "visible"}
                            //          >
                            //             <Text>Showing  <b>{countFrom}</b> to <b>{countTo}</b>  of {totalItemCount} results</Text>
                            //             </Box>
            
            
                            //           <Box  
                            //           gap="2.5rem"
                            //            display="flex"
                            //           justifyContent="space-between"
                            //           alignItems="center" >
                            //            <Box as="button" onClick={handlePreviousClick} disabled={currentPage === 1} visibility={currentPage === 1 ? 'hidden' : 'visible'} p="0.5rem 0.75rem" border="0.0625rem solid #E6E7E9" borderRadius="0.75rem" fontSize="1rem" fontWeight="500">
                            //                Previous
                            //              </Box>
                            //            <Box>
                            //              <Text textAlign="center" fontSize=".875rem" fontWeight="600">
                            //              Page {currentPage} of {totalPages}
                            //              </Text>
                            //            </Box>
                            //            {(totalItemCount >= countTo && !totalExceedsPageCount)  && 
                            //              <Box as="button" p="0.5rem 0.75rem" mr='2.5rem' border="0.0625rem solid #E6E7E9" borderRadius="0.75rem" onClick={handleNextClick} 
                            //              disabled={currentPage === totalPages} 
                            //              visibility={currentPage === totalPages ? 'hidden' : 'visible'} 
                            //              fontSize="1rem" fontWeight="500">
                            //                Next
                            //              </Box>
                            //            }
                            //          </Box>
                            //          </Box>
                            //        </Td>
                            //      </Tr>
                            //    </>
                            //  }
                            />
                          </Flex>
                          </Box>
                      ) : (
                        <SimpleTable
                          headers={TableHeader}
                          // isDataPresent={false}
                        />
                      )}
          </Box>
                        {/* Table end */}
                      </>
                    )}
   
                    {/* Imaging setup Tab */}
                    {activeTab == "imagingsetup" && (
                      <>
                        <Box w="100%">
              {/* <SecondaryNav withBack="Imaging Setup" goBack={gobackfunction} /> */}
              <Box
                gap="10px"
                my="1rem"
                px="1rem"
                w="100%"
                display="flex"
                flexDirection="row"
                justifyContent="center"
                alignItems="center"
              >
              <Box w="100%" display="flex" justifyContent='space-between'>
                <Flex w='100%' gap='1rem'>
                <PrimaryInput
                    variant="fullRound"
                    inputPlace="Search"
                    // inputStyleCss={{h: "40px"}}
                    onKeyPress={searchanythingimaging}
                    maxLength={50}
                    onChange={(e) => setSerachText(e.target.value)}
                    inputValue={searchtext}
                  />
                  <PrimaryButton
                    buttonText="Filter"
                    id="filterButton"
                    variant="mdBtn"
                    btnStyle={{w: "80px"}}
                    onClick={Filteranythingimaging}
                  />
                  <PrimaryButton
                    buttonText="Reset"
                    id="resetButton"
                    variant="grayBtn"
                    btnStyle={{ color: "#AA2F27" }}
                    onClick={imagingresetFields}
                  />
                  <PrimaryButton
                    buttonText="Add"
                    id="filterButton"
                    variant="mdBtn"
                    btnStyle={{w: "80px"}}
                    onClick={openaddmodalimaging}
                    isDisabled={
                      actionAccess && !actionAccess.create
                        ? true
                        : false
                    }
                  />
                </Flex>
              </Box>
              </Box>
              <Divider />
              {imaginglist && imaginglist.length > 0 ? (
                        <Box>
                        <Flex
                          w="100%"
                          flexDir="column"
                          gap="1rem"
                          //  p="1rem"
                          h="calc(100vh - 70px)"
                        >
                              <SimpleTable
                                headers={imagingTableHeader}
                                isDataPresent={true}
                                ThStyle={{
                                  bg: "#FAFAFA",
                                }}
                                footerStyle={{
                                  pos: "fixed",
                                  bottom: "0px",
                                  w:"100%",
                                  zIndex: "99",
                                  boxShadow: "rgba(0, 0, 0, 0.15) 0px 5px 15px 0px",
                                }}
                                tableStyle={{
                                  maxH: "calc(100vh - 250px)",
                                  overflowY: "auto",
                                  tableLayout: "fixed",
                                  width: "100%",
                                  border: "1px solid #E6E7E9",
                                  h: "100%"
                                }}
                                tableBody={
                                  <>
                                    {imaginglist &&
                                      imaginglist.map((step, index) => (
                                        <Tr w="100%" key={index}>
                                          <Td w="100x">
                                          <Text fontSize=".875rem" fontWeight="500">
                                              {step.testname? step.testname:""}
                                            </Text>
                                          </Td>
  
                                        
                                          <Td pos='relative'>
                                <Menu isLazy>
                                  <MenuButton as="button" zIndex={1}>
                                    <Image
                                      w="1.5rem"
                                      src="/assets/svgs/more-options.svg"
                                    />
                                  </MenuButton>
                                  <MenuList
                                    zIndex={9}
                                    pos="relative"
                                    right="100px"
                                    minW="125px"
                                  >
                                    <MenuItem onClick={() => openEditImagingModal(step)}
                                    isDisabled={ actionAccess && (!actionAccess.update) ? true : false} >
                                      Edit
                                    </MenuItem>
                                    <MenuItem onClick={() => openDeleteImagingModal(step)}
                                    isDisabled={ actionAccess && (!actionAccess.delete) ? true : false} >
                                      Delete
                                    </MenuItem>
                                  </MenuList>
                                </Menu>
                              </Td>
                                        
                                        </Tr>
                                      ))}
                                  </>
                                }
                                footerSection={
                                  <>
                                    <Tr w='100%'>
                                      <Td colSpan={8} width='calc(100vw - 6.5rem)'>
                                        <Box
                                          w="100%"
                                          display="flex"
                                          justifyContent="space-between"
                                          alignItems="center"
                                        >
                                          <Box 
                                        visibility={(totalItemCount < countTo && !totalExceedsPageCount)  ? "hidden" : "visible"}
                                        >
                                          <Text>Showing  <b>{countFrom}</b> to <b>{countTo}</b>  of {totalItemCount} results</Text>
                                          </Box>
              
              
                                        <Box  
                                        gap="2.5rem"
                                          display="flex"
                                        justifyContent="space-between"
                                        alignItems="center" >
                                          <Box as="button" onClick={handleImagingPreviousClick} disabled={currentPage === 1} visibility={currentPage === 1 ? 'hidden' : 'visible'} p="0.5rem 0.75rem" border="0.0625rem solid #E6E7E9" borderRadius="0.75rem" fontSize="1rem" fontWeight="500">
                                              Previous
                                            </Box>
                                          <Box>
                                            <Text textAlign="center" fontSize=".875rem" fontWeight="600">
                                            Page {currentPage} of {totalPages}
                                            </Text>
                                          </Box>
                                          {(totalItemCount >= countTo && !totalExceedsPageCount)  && 
                                            <Box as="button" p="0.5rem 0.75rem" mr='2.5rem' border="0.0625rem solid #E6E7E9" borderRadius="0.75rem" onClick={handleImagingNextClick} 
                                            disabled={currentPage === totalPages} 
                                            visibility={currentPage === totalPages ? 'hidden' : 'visible'} 
                                            fontSize="1rem" fontWeight="500">
                                              Next
                                            </Box>
                                          }
                                        </Box>
                                        </Box>
                                      </Td>
                                    </Tr>
                                  </>
                                }
                              />
                            </Flex>
                            </Box>
                        ) : (
                          <SimpleTable
                            headers={imagingTableHeader}
                            // isDataPresent={false}
                          />
                        )}
            </Box>
                        {/* Table end */}
                      </>
                    )}
   
                    {/* vaccinationsetup setup Tab */}
                    {activeTab == "vaccinationsetup" && (
                      <>
                        <Box w="100%">
              {/* <SecondaryNav withBack="Imaging Setup" goBack={gobackfunction} /> */}
              <Box
                gap="10px"
                my="1rem"
                px="1rem"
                w="100%"
                display="flex"
                flexDirection="row"
                justifyContent="center"
                alignItems="center"
              >
              <Box w="100%" display="flex" justifyContent='space-between'>
                <Flex w='100%' gap='1rem'>
                <PrimaryInput
                    variant="fullRound"
                    inputPlace="Search"
                    // inputStyleCss={{h: "40px"}}
                    onKeyPress={searchanythingVaccine}
                    maxLength={50}
                    onChange={(e) => setVaccineSearchText(e.target.value)}
                    inputValue={vaccineSearchText}
                  />
                  <PrimaryButton
                    buttonText="Filter"
                    id="filterButton"
                    variant="mdBtn"
                    btnStyle={{w: "80px"}}
                    onClick={FilteranythingVaccine}
                  />
                  <PrimaryButton
                    buttonText="Reset"
                    id="resetButton"
                    variant="grayBtn"
                    btnStyle={{ color: "#AA2F27" }}
                    onClick={vaccinneresetFields}
                  />
                  <PrimaryButton
                    buttonText="Add"
                    id="filterButton"
                    variant="mdBtn"
                    btnStyle={{w: "80px"}}
                    onClick={openaddmodalvaccine}
                    isDisabled={
                      actionAccess && !actionAccess.create
                        ? true
                        : false
                    }
                  />
                </Flex>
              </Box>
              </Box>
              <Divider />
              {Vaccinelist && Vaccinelist.length > 0 ? (
                        <Box>
                        <Flex
                          w="100%"
                          flexDir="column"
                          gap="1rem"
                          //  p="1rem"
                          h="calc(100vh - 70px)"
                        >
                              <SimpleTable
                                headers={VaccineTableHeader}
                                isDataPresent={true}
                                ThStyle={{
                                  bg: "#FAFAFA",
                                }}
                                footerStyle={{
                                  pos: "fixed",
                                  bottom: "0px",
                                  w:"100%",
                                  zIndex: "99",
                                  boxShadow: "rgba(0, 0, 0, 0.15) 0px 5px 15px 0px",
                                }}
                                tableStyle={{
                                  maxH: "calc(100vh - 250px)",
                                  overflowY: "auto",
                                  tableLayout: "fixed",
                                  width: "100%",
                                  border: "1px solid #E6E7E9",
                                  h: "100%"
                                }}
                                tableBody={
                                  <>
                                    {Vaccinelist &&
                                      Vaccinelist.map((step, index) => (
                                        <Tr w="100%" key={index}>
                                          <Td w="100x">
                                          <Text fontSize=".875rem" fontWeight="500">
                                              {step.vaccinename? step.vaccinename:""}
                                            </Text>
                                          </Td>
  
                                        
                                          <Td pos='relative'>
                                <Menu isLazy>
                                  <MenuButton as="button" zIndex={1}>
                                    <Image
                                      w="1.5rem"
                                      src="/assets/svgs/more-options.svg"
                                    />
                                  </MenuButton>
                                  <MenuList
                                    zIndex={9}
                                    pos="relative"
                                    right="100px"
                                    minW="125px"
                                  >
                                    <MenuItem onClick={() => openEditVaccineModal(step)}
                                    isDisabled={ actionAccess && (!actionAccess.update) ? true : false} >
                                      Edit
                                    </MenuItem>
                                    <MenuItem onClick={() => openDeleteVaccineModal(step)}
                                    isDisabled={ actionAccess && (!actionAccess.delete) ? true : false} >
                                      Delete
                                    </MenuItem>
                                  </MenuList>
                                </Menu>
                              </Td>
                                        
                                        </Tr>
                                      ))}
                                  </>
                                }
                                footerSection={
<>
  <Tr w='100%'>
    <Td colSpan={8} width='calc(100vw - 6.5rem)'>
      <Box
        w="100%"
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        p="0.5rem 0"
      >
        <Box 
          visibility={vaccineTotalItemCount > 0 ? "visible" : "hidden"}
        >
          <Text>
            Showing <b>{vaccineCountFrom}</b> to <b>{vaccineCountTo}</b> of{" "}
            <b>{vaccineTotalItemCount}</b> results
          </Text>
        </Box>
        
        <Box  
          gap="2.5rem"
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <Box 
            as="button" 
            onClick={handleVaccinePreviousClick} 
            disabled={vaccineCurrentPage === 1} 
            opacity={vaccineCurrentPage === 1 ? 0.5 : 1}
            cursor={vaccineCurrentPage === 1 ? "not-allowed" : "pointer"}
            p="0.5rem 0.75rem" 
            border="0.0625rem solid #E6E7E9" 
            borderRadius="0.75rem" 
            fontSize="1rem" 
            fontWeight="500"
            _hover={vaccineCurrentPage === 1 ? {} : { bg: "#f5f5f5" }}
          >
            Previous
          </Box>
          
          <Box>
            <Text textAlign="center" fontSize=".875rem" fontWeight="600">
              Page {vaccineCurrentPage} of {vaccineTotalPages}
            </Text>
          </Box>
          
          <Box 
            as="button" 
            p="0.5rem 0.75rem" 
            border="0.0625rem solid #E6E7E9" 
            borderRadius="0.75rem" 
            onClick={handleVaccineNextClick} 
            disabled={vaccineCurrentPage === vaccineTotalPages} 
            opacity={vaccineCurrentPage === vaccineTotalPages ? 0.5 : 1}
            cursor={vaccineCurrentPage === vaccineTotalPages ? "not-allowed" : "pointer"}
            fontSize="1rem" 
            fontWeight="500"
            _hover={vaccineCurrentPage === vaccineTotalPages ? {} : { bg: "#f5f5f5" }}
          >
            Next
          </Box>
        </Box>
      </Box>
    </Td>
  </Tr>
</>
}
                              //  footerSection={
                              //    <>
                              //      <Tr w='100%'>
                              //        <Td colSpan={8} width='calc(100vw - 6.5rem)'>
                              //          <Box
                              //            w="100%"
                              //            display="flex"
                              //            justifyContent="space-between"
                              //            alignItems="center"
                              //          >
                              //             <Box 
                              //          visibility={(totalItemCount < countTo && !totalExceedsPageCount)  ? "hidden" : "visible"}
                              //          >
                              //             <Text>Showing  <b>{countFrom}</b> to <b>{countTo}</b>  of {totalItemCount} results</Text>
                              //             </Box>
              
              
                              //           <Box  
                              //           gap="2.5rem"
                              //            display="flex"
                              //           justifyContent="space-between"
                              //           alignItems="center" >
                              //            <Box as="button" onClick={handleVaccinePreviousClick} disabled={currentPage === 1} visibility={currentPage === 1 ? 'hidden' : 'visible'} p="0.5rem 0.75rem" border="0.0625rem solid #E6E7E9" borderRadius="0.75rem" fontSize="1rem" fontWeight="500">
                              //                Previous
                              //              </Box>
                              //            <Box>
                              //              <Text textAlign="center" fontSize=".875rem" fontWeight="600">
                              //              Page {currentPage} of {totalPages}
                              //              </Text>
                              //            </Box>
                              //            {(totalItemCount >= countTo && !totalExceedsPageCount)  && 
                              //              <Box as="button" p="0.5rem 0.75rem" mr='2.5rem' border="0.0625rem solid #E6E7E9" borderRadius="0.75rem" onClick={handleVaccineNextClick} 
                              //              disabled={currentPage === totalPages} 
                              //              visibility={currentPage === totalPages ? 'hidden' : 'visible'} 
                              //              fontSize="1rem" fontWeight="500">
                              //                Next
                              //              </Box>
                              //            }
                              //          </Box>
                              //          </Box>
                              //        </Td>
                              //      </Tr>
                              //    </>
                              //  }
                              />
                            </Flex>
                            </Box>
                        ) : (
                          <SimpleTable
                            headers={VaccineTableHeader}
                            // isDataPresent={false}
                          />
                        )}
            </Box>
                        {/* Table end */}
                      </>
                    )}

                    {/* Imaging setup Tab */}
                    {activeTab == "proceduresetup" && (
                      <>
                        <Box w="100%">
              {/* <SecondaryNav withBack="Imaging Setup" goBack={gobackfunction} /> */}
              <Box
                gap="10px"
                my="1rem"
                px="1rem"
                w="100%"
                display="flex"
                flexDirection="row"
                justifyContent="center"
                alignItems="center"
              >
              <Box w="100%" display="flex" justifyContent='space-between'>
                <Flex w='100%' gap='1rem'>
                <PrimaryInput
                    variant="fullRound"
                    inputPlace="Search"
                    // inputStyleCss={{h: "40px"}}
                    onKeyPress={searchanythingprocedure}
                    maxLength={50}
                    onChange={(e) => setSerachText(e.target.value)}
                    inputValue={searchtext}
                  />
                  <PrimaryButton
                    buttonText="Filter"
                    id="filterButton"
                    variant="mdBtn"
                    btnStyle={{w: "80px"}}
                    onClick={Filteranythingprocedure}
                  />
                  <PrimaryButton
                    buttonText="Reset"
                    id="resetButton"
                    variant="grayBtn"
                    btnStyle={{ color: "#AA2F27" }}
                    onClick={procedureresetFields}
                  />
                  <PrimaryButton
                    buttonText="Add"
                    id="filterButton"
                    variant="mdBtn"
                    btnStyle={{w: "80px"}}
                    onClick={openaddmodalprocedure}
                    isDisabled={
                      actionAccess && !actionAccess.create
                        ? true
                        : false
                    }
                  />
                </Flex>
              </Box>
              </Box>
              <Divider />
              {procedurelist && procedurelist.length > 0 ? (
                        <Box>
                        <Flex
                          w="100%"
                          flexDir="column"
                          gap="1rem"
                          //  p="1rem"
                          h="calc(100vh - 70px)"
                        >
                              <SimpleTable
                                headers={procedureTableHeader}
                                isDataPresent={true}
                                ThStyle={{
                                  bg: "#FAFAFA",
                                }}
                                footerStyle={{
                                  pos: "fixed",
                                  bottom: "0px",
                                  w:"100%",
                                  zIndex: "99",
                                  boxShadow: "rgba(0, 0, 0, 0.15) 0px 5px 15px 0px",
                                }}
                                tableStyle={{
                                  maxH: "calc(100vh - 250px)",
                                  overflowY: "auto",
                                  tableLayout: "fixed",
                                  width: "100%",
                                  border: "1px solid #E6E7E9",
                                  h: "100%"
                                }}
                                tableBody={
                                  <>
                                    {procedurelist &&
                                      procedurelist.map((step, index) => (
                                        <Tr w="100%" key={index}>
                                          <Td w="100x">
                                          <Text fontSize=".875rem" fontWeight="500">
                                              {step.testname? step.testname:""}
                                            </Text>
                                          </Td>
  
                                        
                                          <Td pos='relative'>
                                <Menu isLazy>
                                  <MenuButton as="button" zIndex={1}>
                                    <Image
                                      w="1.5rem"
                                      src="/assets/svgs/more-options.svg"
                                    />
                                  </MenuButton>
                                  <MenuList
                                    zIndex={9}
                                    pos="relative"
                                    right="100px"
                                    minW="125px"
                                  >
                                    <MenuItem onClick={() => openEditProcedureModal(step)}
                                    isDisabled={ actionAccess && (!actionAccess.update) ? true : false} >
                                      Edit
                                    </MenuItem>
                                    <MenuItem onClick={() => openDeleteProcedureModal(step)}
                                    isDisabled={ actionAccess && (!actionAccess.delete) ? true : false} >
                                      Delete
                                    </MenuItem>
                                  </MenuList>
                                </Menu>
                              </Td>
                                        
                                        </Tr>
                                      ))}
                                  </>
                                }
                                footerSection={
                                  <>
                                    <Tr w='100%'>
                                      <Td colSpan={8} width='calc(100vw - 6.5rem)'>
                                        <Box
                                          w="100%"
                                          display="flex"
                                          justifyContent="space-between"
                                          alignItems="center"
                                        >
                                          <Box 
                                        visibility={(totalItemCount < countTo && !totalExceedsPageCount)  ? "hidden" : "visible"}
                                        >
                                          <Text>Showing  <b>{countFrom}</b> to <b>{countTo}</b>  of {totalItemCount} results</Text>
                                          </Box>
              
              
                                        <Box  
                                        gap="2.5rem"
                                          display="flex"
                                        justifyContent="space-between"
                                        alignItems="center" >
                                          <Box as="button" onClick={handleProcedurePreviousClick} disabled={currentPage === 1} visibility={currentPage === 1 ? 'hidden' : 'visible'} p="0.5rem 0.75rem" border="0.0625rem solid #E6E7E9" borderRadius="0.75rem" fontSize="1rem" fontWeight="500">
                                              Previous
                                            </Box>
                                          <Box>
                                            <Text textAlign="center" fontSize=".875rem" fontWeight="600">
                                            Page {currentPage} of {totalPages}
                                            </Text>
                                          </Box>
                                          {(totalItemCount >= countTo && !totalExceedsPageCount)  && 
                                            <Box as="button" p="0.5rem 0.75rem" mr='2.5rem' border="0.0625rem solid #E6E7E9" borderRadius="0.75rem" onClick={handleProcedureNextClick} 
                                            disabled={currentPage === totalPages} 
                                            visibility={currentPage === totalPages ? 'hidden' : 'visible'} 
                                            fontSize="1rem" fontWeight="500">
                                              Next
                                            </Box>
                                          }
                                        </Box>
                                        </Box>
                                      </Td>
                                    </Tr>
                                  </>
                                }
                              />
                            </Flex>
                            </Box>
                        ) : (
                          <SimpleTable
                            headers={procedureTableHeader}
                            // isDataPresent={false}
                          />
                        )}
            </Box>
                        {/* Table end */}
                      </>
                    )}

                   </Box>
                 </Flex>
               </Box>
             </Flex>
           ) : (
             <>
               <MobileNavbar />
               <MobileSecondaryNav header='Orders' handlebackarrow={() => navigate('/home')} />
               {/* Tab buttons start */}
               <Box
                 display="flex"
                 gap="1rem"
                 borderBottom="1px solid #E6E7E9"
                 bg="white"
                 p="1.25rem 1.5rem"
                 overflow='scroll hidden'
               >
                 <Box
                   as="button"
                   display="flex"
                   justifyContent="center"
                   alignItems="center"
                   pos="relative"
                   className={activeTab == "labs" ? "activeTab" : ""}
                   fontSize="0.87rem"
                   fontWeight="600"
                   onClick={() => tabChanged("labs")}
                   color={activeTab == "labs" ? "#061027" : "#898D97"}
                 >
                   <Text>Labs</Text>
                   <Box as="span" className="whiteBorder" />
                 </Box>
                 <Box
                   as="button"
                   display="flex"
                   justifyContent="center"
                   alignItems="center"
                   pos="relative"
                   className={activeTab == "imaging" ? "activeTab" : ""}
                   fontSize="0.87rem"
                   fontWeight="600"
                   onClick={() => tabChanged("imaging")}
                   color={activeTab == "imaging" ? "#061027" : "#898D97"}
                 >
                   <Text>Imaging</Text>
                   <Box as="span" className="whiteBorder" />
                 </Box>
               </Box>
               {/* Tab buttons end */}
   
   
             </>
           )}
         </Box>
      

   {/* ---------------------- new modals for lab setup ----------------------------- */}
   {/* Modal To ADD orders - labs and imaging  */}
    <ModalRight
  ref={addOrder}
  header={`Add Favorite Labs`}
  body={
    <>
      <Box display="flex" flexDir="column" gap="20px">
        <PrimaryButton
          buttonText={`Search Labs`}
          variant="grayBtn"
          btnStyle={{ w: "100%", color: COLORS.PRIMARY_COLOR }}
          isDisabled={false} // Always enabled
          onClick={() => fetchMasterData("labs")}
        />

        {orderInputFields.map((field, index) => (
          <Box
            key={field.id}
            display="flex"
            alignItems="center"
            gap="10px"
          >
            <PrimaryInput
              variant="bothSide"
              inputType="text"
              inputPlace="Lab name"
              value={currentOrderNames.find(order => order.id === field.id)?.name || ""}
              onChange={(event) =>
                handleAddOrderName(field.id, event.target.value)
              }
            />
            <Box
              as="button"
              border="1px solid #E6E7E9"
              borderRadius="full"
              w="36px"
              h="36px"
              p="10px"
              display="flex"
              justifyContent="center"
              alignItems="center"
              onClick={() => deleteOrderInputField(field.id)}
            >
              <Image w="13px" src="/assets/imgs/delete.png" />
            </Box>
          </Box>
        ))}
        <Divider />
        <Box marginTop="12px" textAlign="left">
          <Button
            onClick={addOrderInputField}
            bg="#fcfcfd"
            color="blue"
            w="90%"
            textAlign="left"
          >
            {`+ Add Lab`}
          </Button>
        </Box>
      </Box>
    </>
  }
  footerActions={
    <>
      <Box w="100%" display="flex" flexDirection="row" gap="15px">
        <PrimaryButton
          buttonText={`Save Lab`}
          isDisabled={
                isSaveButtonDisabled || !actionAccessMain(22)?.create
              }
          // isDisabled={
          //   isSaveButtonDisabled || 
          //   !actionAccessMain(22)?.create ||
          //   currentOrderNames.every(order => order.name.trim() === "")
          // }
          onClick={AddOrder}
        />
      </Box>
    </>
  }
/>

    {/* 2nd Modal To Search Specific Order  */}
    <ModalRight
  ref={openSearchSpecificOrder}
  header={"Search Labs"}
  body={
    <>
      <SearchBar
        passInputPlace="Search labs"
        value={searchValue}
        onChange={(e) => setSearchValue(e.target.value)}
      />
      <RadioGroup>
        <Stack direction="column" gap="0">
          {specificSearchOrderData && specificSearchOrderData.length > 0 ? (
            specificSearchOrderData
              .filter((item) =>
                item.subtype &&
                item.subtype.toLowerCase().includes(searchValue.toLowerCase())
              )
              .map((item) => (
                <label key={item.id}>         
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    borderBottom="1px solid #e2e8f0"
                    p="15px"
                    pl="5px"
                    minH="50px"
                    width="100%"
                    sx={{
                      _hover: {
                        border: "2px solid #384052",
                        borderRadius: "10px",
                      },
                    }}
                  >
                    <Box display="flex" alignItems="center">
                      <Text
                        fontSize="16px"
                        lineHeight="normal"
                        fontWeight="600"
                      >
                        {/* {item.testname} */}
                        Labs: {item.subtype}
                      </Text>
                    </Box>
                    <Box display="flex" justifyContent="end">
                      <Checkbox
                        colorScheme="green"
                        sx={{
                          ".chakra-checkbox__control": {
                            width: "20px",
                            height: "20px",
                            borderRadius: "5px",
                          },
                        }}
                        onChange={() => handleCheckboxChange(item)}
                        isChecked={isChecked(item.id)}
                      />
                    </Box>
                  </Box>
                </label>
              ))
          ) : (
            <Box
              p="15px"
              fontSize="16px"
              fontWeight="600"
              textAlign="center"
            >
              No labs available
            </Box>
          )}
          
          {specificSearchOrderData && specificSearchOrderData.length > 0 &&
            specificSearchOrderData.every(
              (item) =>
                !item.subtype ||
                !item.subtype.toLowerCase().includes(searchValue.toLowerCase())
            ) && (
              <Box
                p="15px"
                fontSize="16px"
                fontWeight="600"
                textAlign="center"
              >
                No matching results found!
              </Box>
            )}
        </Stack>
      </RadioGroup>
    </>
  }
  footerActions={
    <>
      <Box w="100%" display="flex" flexDirection="row">
        <PrimaryButton
          buttonText={"Save To Favourites"}
          isDisabled={selectedItems.length === 0}
          onClick={handleSpecificOrderSearchSaveButtonClick}
        />
      </Box>
    </>
  }
/>
   <ModalRight
      ref={addlabprice}
      header="Add Lab Test"
      modalWidth={{ base: "100%", lg: "calc(100vw - 50%)" }}
      body={
        <>
          <Box w="100%" mt="1rem">
            <Box w="100%" display="flex">
            <PrimaryInput
                variant="leftSide"
                inputPlace="Test Name*"
                onChange={(e) => {
                  const value = e.target.value;
                  // Allow only digits (no decimals, no characters)
                  if (/^[a-zA-Z0-9.'-\s]*$/.test(value)) {
                    setLabName(value);
                  }
                }}
                inputValue={labname}
                defaultValue={labname}
                maxLength={60}
              />
              
            </Box>
          
          </Box>
        </>
      }
      footerActions={
        <>
          <Box w="100%" display="flex" gap="1rem">
            <PrimaryButton
              buttonText="Cancel"
              variant="grayBtnFull"
              btnStyle={{ color: "#AA2F27" }}
              
              onClick={() => addlabprice.current.closeRight()}
            />

            <PrimaryButton
              buttonText="Save"
              onClick={() => addLabtest()}
            />
          </Box>
        </>
      }
    />
    <ModalRight
      ref={editlabprice}
      header="Edit Lab Pricing"
      // modalWidth={{ base: "100%", lg: "calc(100vw - 50%)" }}
      body={
        <>
          <Box w="100%" mt="1rem">
          <Box w="100%" display="flex">
            <PrimaryInput
                variant="leftSide"
                inputPlace="Lab Name*"
                onChange={(e) => {
                  const value = e.target.value;
                  // Allow only digits (no decimals, no characters)
                  if (/^[a-zA-Z0-9.'-\s]*$/.test(value)) {
                    setLabName(value);
                  }
                }}
                inputValue={labname}
                defaultValue={labname}
                maxLength={60}
              />
            </Box>
          </Box>
        </>
      }
      footerActions={
        <>
          <Box w="100%" display="flex" gap="1rem">
            <PrimaryButton
              buttonText="Update Lab"
              onClick={() => editLabtest()}
            />
          </Box>
        </>
      }
    />
      <DynamicModal
      ref={deletelabprice}
      modalHeader="Delete Lab"
      modalBody={
        <>
          <Text fontSize="14px" fontWeight="600">
            Are you sure you want to delete <b>{labname}</b>?
          </Text>
        </>
      }
      modalFooterBtn={
        <>
          <PrimaryButton
            variant="deleteBtn"
            buttonText="Delete"
            onClick={deleteLab}
          />
        </>
      }
    />
   
   {/* ---------------------- new modals for imaging setup ----------------------------- */}
   
     {/* Modal To ADD orders - labs and imaging  */}
    <ModalRight
      ref={addImaging}
      // header={`Add ${currentOrderType}`}
      header={`Add Favorite Imagings`}
      body={
        <>
          <Box display="flex" flexDir="column" gap="20px">
            <PrimaryButton
              // buttonText={`Search ${currentOrderType}`}
              buttonText={`Search Imagings`}
              variant="grayBtn"
              btnStyle={{ w: "100%", color: COLORS.PRIMARY_COLOR }}
              isDisabled={isImagingSaveButtonDisabled}
              onClick={() =>
                // openSpecificSearchOrderOverlay(currentOrderType)
                fetchMasterImagingData(currentImagingType)
              }
            />

            {imagingInputFields.map((field, index) => (
              <Box
                key={field.id}
                display="flex"
                alignItems="center"
                gap="10px"
              >
                <PrimaryInput
                  variant="bothSide"
                  inputType="text"
                  inputPlace={`${currentImagingType} name`}
                  value={currentImagingNames.find(order => order.id === field.id)?.name || ""}
                  onChange={(event) =>
                    handleAddImagingName(field.id, event.target.value)
                  }
                />
                <Box
                  as="button"
                  border="1px solid #E6E7E9"
                  borderRadius="full"
                  w="36px"
                  h="36px"
                  p="10px"
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  onClick={() => deleteImagingInputField(field.id)}
                >
                  <Image w="13px" src="/assets/imgs/delete.png" />
                </Box>
                {/* {index < orderInputFields.length - 1 && (
                  <Divider marginTop="20px" />
                )} */}
              </Box>
            ))}
            <Divider />
            <Box marginTop="12px" textAlign="left">
              <Button
                onClick={addImagingInputField}
                bg="#fcfcfd"
                color="blue"
                w="90%" // Make the button full width
                textAlign="left" // Align the text to the left
              >
                {/* {`+ Add ${currentOrderType}`} */}
                {`+ Add Imaging`}
              </Button>
            </Box>
          </Box>
        </>
      }
      footerActions={
        <>
          <Box w="100%" display="flex" flexDirection="row" gap="15px">
            <PrimaryButton
              // buttonText={`Save ${currentOrderType}`}
              buttonText={`Save Imaging`}
              isDisabled={
                isImagingSaveButtonDisabled || !actionAccessMain(22)?.create
              }
              onClick={AddImaging}
            />
          </Box>
        </>
      }
    />

    {/* 2nd Modal To Search Specific Order  */}
    <ModalRight
      ref={openSearchSpecificImaging}
      // modalWidth={"25%"}
      header={"Search"}
      body={
        <>
          <SearchBar
            passInputPlace="Search"
            onChange={(e) => setSearchValue(e.target.value)}
          />
          <RadioGroup>
            <Stack direction="column" gap="0">
          {specificSearchImagingData && specificSearchImagingData.length > 0 ? (
            specificSearchImagingData
              .filter((item) =>
                item.subtype &&
                item.subtype.toLowerCase().includes(searchValue.toLowerCase())
              )
              .map((item) => (
                <label key={item.id}>         
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    borderBottom="1px solid #e2e8f0"
                    p="15px"
                    pl="5px"
                    minH="50px"
                    width="100%"
                    sx={{
                      _hover: {
                        border: "2px solid #384052",
                        borderRadius: "10px",
                      },
                    }}
                  >
                    <Box display="flex" alignItems="center">
                      <Text
                        fontSize="16px"
                        lineHeight="normal"
                        fontWeight="600"
                      >
                        {/* {item.testname} */}
                        Imaging: {item.subtype}
                      </Text>
                    </Box>
                    <Box display="flex" justifyContent="end">
                      <Checkbox
                        colorScheme="green"
                        sx={{
                          ".chakra-checkbox__control": {
                            width: "20px",
                            height: "20px",
                            borderRadius: "5px",
                          },
                        }}
                        onChange={() => handleImagingCheckboxChange(item)}
                        isChecked={isImagingChecked(item.id)}
                      />
                    </Box>
                  </Box>
                </label>
              ))
          ) : (
            <Box
              p="15px"
              fontSize="16px"
              fontWeight="600"
              textAlign="center"
            >
              No imaging available
            </Box>
          )}
          
          {specificSearchImagingData && specificSearchImagingData.length > 0 &&
            specificSearchImagingData.every(
              (item) =>
                !item.subtype ||
                !item.subtype.toLowerCase().includes(searchValue.toLowerCase())
            ) && (
              <Box
                p="15px"
                fontSize="16px"
                fontWeight="600"
                textAlign="center"
              >
                No matching results found!
              </Box>
            )}
        </Stack>
          </RadioGroup>
        </>
      }
      footerActions={
        <>
          <Box w="100%" display="flex" flexDirection="row">
            <PrimaryButton
              buttonText={"Save To Favourites"}
              isDisabled={false}
              onClick={handleSpecificImagingSearchSaveButtonClick}
            />
          </Box>
        </>
      }
    />
     <ModalRight
             ref={addimagingprice}
             header="Add Imaging"
             modalWidth={{ base: "100%", lg: "calc(100vw - 60%)" }}
             body={
               <>
                 <Box w="100%" mt="1rem">
                   <Box w="100%" display="flex">
                   <PrimaryInput
                       variant="leftSide"
                       inputPlace="Name*"
                       onChange={(e) => {
                         const value = e.target.value;
                         // Allow only digits (no decimals, no characters)
                         if (/^[a-zA-Z\s!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]*$/.test(value)) {
                           setImagingName(value);
                         }
                       }}
                        inputValue={imagingname}
                        defaultValue={imagingname}
                        maxLength={60}
                     />
                     
                    
                   </Box>
                 </Box>
               </>
             }
             footerActions={
               <>
                 <Box w="100%" display="flex" gap="1rem">
                   <PrimaryButton
                     buttonText="Cancel"
                     variant="grayBtnFull"
                     btnStyle={{ color: "#AA2F27" }}
                     
                     onClick={() => addimagingprice.current.closeRight()}
                   />
     
                   <PrimaryButton
                     buttonText="Save"
                     onClick={() => addImaging()}
                   />
                 </Box>
               </>
             }
           />
           <ModalRight
             ref={editimagingprice}
             header="Edit Imaging"
             modalWidth={{ base: "100%", lg: "calc(100vw - 60%)" }}
             body={
               <>
                 <Box w="100%" mt="1rem">
                 <Box w="100%" display="flex">
                   <PrimaryInput
                       variant="leftSide"
                       inputPlace="Name*"
                       onChange={(e) => {
                         const value = e.target.value;
                         // Allow only digits (no decimals, no characters)
                         if (/^[a-zA-Z\s!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]*$/.test(value)) {
                           setImagingName(value);
                         }
                       }}
                        inputValue={imagingname}
                       //  defaultValue={imagingname}
                        maxLength={60}
                     />
                  
                     
                    
                   </Box>
                 </Box>
               </>
             }
             footerActions={
               <>
                 <Box w="100%" display="flex" gap="1rem">
                   <PrimaryButton
                     buttonText="Cancel"
                     variant="grayBtnFull"
                     btnStyle={{ color: "#AA2F27" }}
                     
                     onClick={() => editimagingprice.current.closeRight()}
                   />
     
                   <PrimaryButton
                     buttonText="Save"
                     onClick={() => editImagingtest()}
                   />
                 </Box>
               </>
             }
           />
     
     <DynamicModal
             ref={deleteimagingprice}
             modalHeader="Delete Imaging"
             modalBody={
               <>
                 <Text fontSize="14px" fontWeight="600">
                   Are you sure you want to delete <b>{imagingname}</b>?
                 </Text>
               </>
             }
             modalFooterBtn={
               <>
                 <PrimaryButton
                   variant="deleteBtn"
                   buttonText="Delete"
                   onClick={deleteImaging}
                 />
               </>
             }
           />

    {/* ---------------------- new modals for procedure setup ----------------------------- */}
   
     {/* Modal To ADD orders - labs and imaging  */}
    <ModalRight
      ref={addProcedure}
      // header={`Add ${currentOrderType}`}
      header={`Add Favorite Procedures`}
      body={
        <>
          <Box display="flex" flexDir="column" gap="20px">
            <PrimaryButton
              // buttonText={`Search ${currentOrderType}`}
              buttonText={`Search Procedures`}
              variant="grayBtn"
              btnStyle={{ w: "100%", color: COLORS.PRIMARY_COLOR }}
              isDisabled={isProcedureSaveButtonDisabled}
              onClick={() =>
                // openSpecificSearchOrderOverlay(currentOrderType)
                fetchMasterProcedureData(currentProcedureType)
              }
            />

            {procedureInputFields.map((field, index) => (
              <Box
                key={field.id}
                display="flex"
                alignItems="center"
                gap="10px"
              >
                <PrimaryInput
                  variant="bothSide"
                  inputType="text"
                  inputPlace={`${currentProcedureType} name`}
                  value={currentProcedureNames.find(order => order.id === field.id)?.name || ""}
                  onChange={(event) =>
                    handleAddProcedureName(field.id, event.target.value)
                  }
                />
                <Box
                  as="button"
                  border="1px solid #E6E7E9"
                  borderRadius="full"
                  w="36px"
                  h="36px"
                  p="10px"
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  onClick={() => deleteProcedureInputField(field.id)}
                >
                  <Image w="13px" src="/assets/imgs/delete.png" />
                </Box>
                {/* {index < orderInputFields.length - 1 && (
                  <Divider marginTop="20px" />
                )} */}
              </Box>
            ))}
            <Divider />
            <Box marginTop="12px" textAlign="left">
              <Button
                onClick={addProcedureInputField}
                bg="#fcfcfd"
                color="blue"
                w="90%" // Make the button full width
                textAlign="left" // Align the text to the left
              >
                {/* {`+ Add ${currentOrderType}`} */}
                {`+ Add Procedure`}
              </Button>
            </Box>
          </Box>
        </>
      }
      footerActions={
        <>
          <Box w="100%" display="flex" flexDirection="row" gap="15px">
            <PrimaryButton
              // buttonText={`Save ${currentOrderType}`}
              buttonText={`Save Procedure`}
              isDisabled={
                isImagingSaveButtonDisabled || !actionAccessMain(22)?.create
              }
              onClick={AddProcedure}
            />
          </Box>
        </>
      }
    />

    {/* 2nd Modal To Search Specific Order  */}
    <ModalRight
      ref={openSearchSpecificProcedure}
      // modalWidth={"25%"}
      header={"Search"}
      body={
        <>
          <SearchBar
            passInputPlace="Search"
            onChange={(e) => setSearchValue(e.target.value)}
          />
          <RadioGroup>
            <Stack direction="column" gap="0">
          {specificSearchProcedureData && specificSearchProcedureData.length > 0 ? (
            specificSearchProcedureData
              .filter((item) =>
                item.subtype &&
                item.subtype.toLowerCase().includes(searchValue.toLowerCase())
              )
              .map((item) => (
                <label key={item.id}>         
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    borderBottom="1px solid #e2e8f0"
                    p="15px"
                    pl="5px"
                    minH="50px"
                    width="100%"
                    sx={{
                      _hover: {
                        border: "2px solid #384052",
                        borderRadius: "10px",
                      },
                    }}
                  >
                    <Box display="flex" alignItems="center">
                      <Text
                        fontSize="16px"
                        lineHeight="normal"
                        fontWeight="600"
                      >
                        {/* {item.testname} */}
                        Procedure: {item.subtype}
                      </Text>
                    </Box>
                    <Box display="flex" justifyContent="end">
                      <Checkbox
                        colorScheme="green"
                        sx={{
                          ".chakra-checkbox__control": {
                            width: "20px",
                            height: "20px",
                            borderRadius: "5px",
                          },
                        }}
                        onChange={() => handleProcedureCheckboxChange(item)}
                        isChecked={isProcedureChecked(item.id)}
                      />
                    </Box>
                  </Box>
                </label>
              ))
          ) : (
            <Box
              p="15px"
              fontSize="16px"
              fontWeight="600"
              textAlign="center"
            >
              No imaging available
            </Box>
          )}
          
          {specificSearchProcedureData && specificSearchProcedureData.length > 0 &&
            specificSearchProcedureData.every(
              (item) =>
                !item.subtype ||
                !item.subtype.toLowerCase().includes(searchValue.toLowerCase())
            ) && (
              <Box
                p="15px"
                fontSize="16px"
                fontWeight="600"
                textAlign="center"
              >
                No matching results found!
              </Box>
            )}
        </Stack>
          </RadioGroup>
        </>
      }
      footerActions={
        <>
          <Box w="100%" display="flex" flexDirection="row">
            <PrimaryButton
              buttonText={"Save To Favourites"}
              isDisabled={false}
              onClick={handleSpecificProcedureSearchSaveButtonClick}
            />
          </Box>
        </>
      }
    />
     <ModalRight
             ref={addprocedureprice}
             header="Add Procedure"
             modalWidth={{ base: "100%", lg: "calc(100vw - 60%)" }}
             body={
               <>
                 <Box w="100%" mt="1rem">
                   <Box w="100%" display="flex">
                   <PrimaryInput
                       variant="leftSide"
                       inputPlace="Name*"
                       onChange={(e) => {
                         const value = e.target.value;
                         // Allow only digits (no decimals, no characters)
                         if (/^[a-zA-Z\s!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]*$/.test(value)) {
                           setProcedureName(value);
                         }
                       }}
                        inputValue={procedurename}
                        defaultValue={procedurename}
                        maxLength={60}
                     />
                     
                    
                   </Box>
                 </Box>
               </>
             }
             footerActions={
               <>
                 <Box w="100%" display="flex" gap="1rem">
                   <PrimaryButton
                     buttonText="Cancel"
                     variant="grayBtnFull"
                     btnStyle={{ color: "#AA2F27" }}
                     
                     onClick={() => addprocedureprice.current.closeRight()}
                   />
     
                   <PrimaryButton
                     buttonText="Save"
                     onClick={() => addProcedure()}
                   />
                 </Box>
               </>
             }
           />
           <ModalRight
             ref={editprocedureprice}
             header="Edit Procedure"
             modalWidth={{ base: "100%", lg: "calc(100vw - 60%)" }}
             body={
               <>
                 <Box w="100%" mt="1rem">
                 <Box w="100%" display="flex">
                   <PrimaryInput
                       variant="leftSide"
                       inputPlace="Name*"
                       onChange={(e) => {
                         const value = e.target.value;
                         // Allow only digits (no decimals, no characters)
                         if (/^[a-zA-Z\s!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]*$/.test(value)) {
                           setProcedureName(value);
                         }
                       }}
                        inputValue={procedurename}
                       //  defaultValue={imagingname}
                        maxLength={60}
                     />
                  
                     
                    
                   </Box>
                 </Box>
               </>
             }
             footerActions={
               <>
                 <Box w="100%" display="flex" gap="1rem">
                   <PrimaryButton
                     buttonText="Cancel"
                     variant="grayBtnFull"
                     btnStyle={{ color: "#AA2F27" }}
                     
                     onClick={() => editprocedureprice.current.closeRight()}
                   />
     
                   <PrimaryButton
                     buttonText="Save"
                     onClick={() => editProceduretest()}
                   />
                 </Box>
               </>
             }
           />
     
     <DynamicModal
             ref={deleteprocedureprice}
             modalHeader="Delete Procedure"
             modalBody={
               <>
                 <Text fontSize="14px" fontWeight="600">
                   Are you sure you want to delete <b>{procedurename}</b>?
                 </Text>
               </>
             }
             modalFooterBtn={
               <>
                 <PrimaryButton
                   variant="deleteBtn"
                   buttonText="Delete"
                   onClick={deleteProcedure}
                 />
               </>
             }
           />
   
    {/* ---------------------- new modals for vaccine setup ----------------------------- */}

{/* Modal To ADD Vaccine - Same as labs */}
<ModalRight
  ref={addOrderVaccine}
  header={`Add Favorite Vaccines`}
  body={
    <>
      <Box display="flex" flexDir="column" gap="20px">
        <PrimaryButton
          buttonText={`Search Vaccines`}
          variant="grayBtn"
          btnStyle={{ w: "100%", color: COLORS.PRIMARY_COLOR }}
          isDisabled={isSaveButtonDisabledVaccine}
          onClick={fetchMasterVaccineData}
        />

        {orderInputFieldsVaccine.map((field, index) => (
          <Box
            key={field.id}
            display="flex"
            alignItems="center"
            gap="10px"
          >
            <PrimaryInput
              variant="bothSide"
              inputType="text"
              inputPlace={`Vaccine name`}
              value={currentOrderNamesVaccine.find(order => order.id === field.id)?.name || ""}
              onChange={(event) =>
                handleAddOrderNameVaccine(field.id, event.target.value)
              }
            />
            <Box
              as="button"
              border="1px solid #E6E7E9"
              borderRadius="full"
              w="36px"
              h="36px"
              p="10px"
              display="flex"
              justifyContent="center"
              alignItems="center"
              onClick={() => deleteOrderInputFieldVaccine(field.id)}
            >
              <Image w="13px" src="/assets/imgs/delete.png" />
            </Box>
          </Box>
        ))}
        <Divider />
        <Box marginTop="12px" textAlign="left">
          <Button
            onClick={addOrderInputFieldVaccine}
            bg="#fcfcfd"
            color="blue"
            w="90%"
            textAlign="left"
          >
            {`+ Add Vaccine`}
          </Button>
        </Box>
      </Box>
    </>
  }
  footerActions={
    <>
      <Box w="100%" display="flex" flexDirection="row" gap="15px">
        <PrimaryButton
          buttonText={`Save Vaccine`}
          isDisabled={
            isSaveButtonDisabledVaccine || !actionAccessMain(22)?.create
          }
          onClick={AddOrderVaccine}
        />
      </Box>
    </>
  }
/>

{/* 2nd Modal To Search Specific Vaccine  */}
{/* 2nd Modal To Search Specific Vaccine */}
<ModalRight
  ref={openSearchSpecificVaccineOrder}
  header={"Search Vaccines"}
  body={
    <>
      <SearchBar
        passInputPlace="Search vaccines"
        value={searchValueVaccine}
        onChange={(e) => setSearchValueVaccine(e.target.value)}
      />
      <RadioGroup>
        <Stack direction="column" gap="0">
          {specificSearchVaccineData && specificSearchVaccineData.length > 0 ? (
            specificSearchVaccineData
              .filter((item) =>
                item.condition &&
                item.condition.toLowerCase().includes(searchValueVaccine.toLowerCase())
              )
              .map((item) => (
                <label key={item.condition_cd || item.id}>
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    borderBottom="1px solid #e2e8f0"
                    p="15px"
                    pl="5px"
                    minH="50px"
                    width="100%"
                    sx={{
                      _hover: {
                        border: "2px solid #384052",
                        borderRadius: "10px",
                      },
                    }}
                  >
                    <Box display="flex" alignItems="center">
                      <Text
                        fontSize="16px"
                        lineHeight="normal"
                        fontWeight="600"
                      >
                        {item.condition}
                      </Text>
                    </Box>
                    <Box display="flex" justifyContent="end">
                      <Checkbox
                        colorScheme="green"
                        sx={{
                          ".chakra-checkbox__control": {
                            width: "20px",
                            height: "20px",
                            borderRadius: "5px",
                          },
                        }}
                        onChange={() => handleCheckboxVaccineChange(item)}
                        isChecked={isVaccineChecked(item)}
                      />
                    </Box>
                  </Box>
                </label>
              ))
          ) : (
            <Box
              p="15px"
              fontSize="16px"
              fontWeight="600"
              textAlign="center"
            >
              No vaccines available
            </Box>
          )}
          
          {specificSearchVaccineData && specificSearchVaccineData.length > 0 &&
            specificSearchVaccineData.every(
              (item) =>
                !item.condition ||
                !item.condition.toLowerCase().includes(searchValueVaccine.toLowerCase())
            ) && (
              <Box
                p="15px"
                fontSize="16px"
                fontWeight="600"
                textAlign="center"
              >
                No matching results found!
              </Box>
            )}
        </Stack>
      </RadioGroup>
    </>
  }
  footerActions={
    <>
      <Box w="100%" display="flex" flexDirection="row">
        <PrimaryButton
          buttonText={"Save To Favourites"}
          isDisabled={selectedVaccineItems.length === 0}
          onClick={handleSpecificVaccineSearchSaveButtonClick}
        />
      </Box>
    </>
  }
/>

            <ModalRight
  ref={AddVaccineModal}
  header="Add vaccine"
  body={
    <>
      <SearchBar 
        passInputPlace="Search vaccine" 
        value={searchValue}
        onChange={(e) => setSearchValue(e.target.value)} 
      />
      <RadioGroup>
        <Stack direction="column" gap="0">
          <Box display="flex" justifyContent="end" w="100%">
            <Stack direction="column" gap="0" w="100%">
              {conditionsList && conditionsList.length > 0 ? (
                conditionsList
                  .filter(vaccine => 
                    vaccine.vaccinename?.toLowerCase().includes(searchValue.toLowerCase())
                  )
                  .length > 0 ? (
                  conditionsList
                    .filter(vaccine => 
                      vaccine.vaccinename?.toLowerCase().includes(searchValue.toLowerCase())
                    )
                    .map(vaccine => (
                      <label key={vaccine.id}>
                        <Box
                          display="flex"
                          justifyContent="space-between"
                          borderBottom="1px solid #e2e8f0"
                          p="15px"
                          pl="5px"
                          minH="50px"
                          width="100%"
                          sx={{
                            _hover: { border: "2px solid #384052", borderRadius: "10px" },
                          }}
                        >
                          <Box display="flex" alignItems="center">
                            <Text fontSize="16px" lineHeight="normal" fontWeight="600">
                              {vaccine.vaccinename}
                            </Text>
                          </Box>
                          <Box display="flex" justifyContent="end">
                            <Checkbox
                              colorScheme="green"
                              sx={{
                                ".chakra-checkbox__control": {
                                  width: "20px",
                                  height: "20px",
                                  borderRadius: "5px",
                                },
                              }}
                              onChange={() => handleCheckboxVaccineChange(vaccine)}
                              isChecked={selectedConditions.some(
                                (item) => item.id === vaccine.id
                              )}
                            />
                          </Box>
                        </Box>
                      </label>
                    ))
                ) : (
                  <Box p="15px" fontSize="16px" fontWeight="600" textAlign="center">
                    No matching vaccines found!
                  </Box>
                )
              ) : (
                <Box p="15px" fontSize="16px" fontWeight="600" textAlign="center">
                  {conditionsList ? 'No vaccines available' : 'Loading vaccines...'}
                </Box>
              )}
            </Stack>
          </Box>
        </Stack>
      </RadioGroup>
    </>
  }
  footerActions={
    <>
      <Box w="100%" display="flex" flexDirection="row" gap="15px">
        <PrimaryButton
          buttonText="Save"
          isDisabled={selectedConditions.length === 0}
          onClick={addVaccine}
        />
      </Box>
    </>
  }
/>
           
           <ModalRight
  ref={EditVaccineModal}
  header="Edit Vaccine"
  body={
    <>
      <Box w="100%" mt="1rem">
        <Box w="100%" display="flex">
          <PrimaryInput
            variant="leftSide"
            inputPlace="Name*"
            onChange={(e) => {
              const value = e.target.value;
              setVaccineName(value);
            }}
            inputValue={Vaccinename}
            maxLength={60}
          />
        </Box>
      </Box>
    </>
  }
  footerActions={
    <>
      <Box w="100%" display="flex" gap="1rem">
        {/* <PrimaryButton
          buttonText="Cancel"
          variant="grayBtnFull"
          btnStyle={{ color: "#AA2F27" }}
          onClick={() => {
            EditVaccineModal.current.closeRight();
            setVaccineName("");
            setVaccineID("");
          }}
        /> */}
        <PrimaryButton
          buttonText="Update Vaccine"
          onClick={editVaccinetest}
        />
      </Box>
    </>
  }
/>
     
     <DynamicModal
             ref={DeleteVaccineModal}
             modalHeader="Delete Vaccine"
             modalBody={
               <>
                 <Text fontSize="14px" fontWeight="600">
                   Are you sure you want to delete <b>{Vaccinename}</b>?
                 </Text>
               </>
             }
             modalFooterBtn={
               <>
                 <PrimaryButton
                   variant="deleteBtn"
                   buttonText="Delete"
                   onClick={deleteVaccine}
                 />
               </>
             }
           />
   

     <DynamicModal
             ref={deleteRowModal}
             modalHeader="Delete row"
             modalBody={
               <>
                 <Text fontSize="14px" fontWeight="600">
                   Are you sure you want to delete?
                 </Text>
               </>
             }
             modalFooterBtn={
               <>
                 <PrimaryButton
                   variant="deleteBtn"
                   buttonText="Delete"
                   onClick={deleteRowHandler}
                 />
               </>
             }
           />
  

  <DynamicModal
        ref={addmedications}
        modalHeader="Add Medication"
        modalWidth={{base:'100%', md: 'calc(100vw - 10%)'}}
        modalBody={
          <>
            <Box display="flex" flexDir="column" gap="20px">
              <Stack>
                <Flex>
                  <InputGroup>
                    <Input
                      pr="4.5rem" // Padding right to make room for the icon
                      type="text"
                      placeholder="Medicine name*"
                      // value={medicinename}
                      value={medicinename.charAt(0).toUpperCase() + medicinename.slice(1)}
                      sx={{
                        height: "48px",
                        borderRadius: "10px 0 0 10px",
                        _hover: {
                          border: "2px solid",
                          borderColor: COLORS.INPUT_FOCUS_DARK,
                          outline: "none",
                          bg: "none",
                          _focus: {
                            borderRadius: "10px",
                            borderColor: COLORS.INPUT_FOCUS_DARK,
                            outline: "none",
                          },
                          _focusVisible: { borderColor: "none" },
                        },
                      }}
                      onChange={handlemedicinename}
                      maxLength={80}
                    />
                    <InputRightElement width="4.5rem">
                      <Box
                        as="button"
                        h="1.75rem"
                        bg="none"
                        pt="8px"
                        onClick={() => document.getElementById("file-upload").click()}
                        sx={{ _hover: { bg: "none" } }}
                      >
                        <Image src="/assets/svgs/image-search-blue.svg" />
                      </Box>
                      <input
                        type="file"
                        id="file-upload"
                        style={{ display: "none" }}
                        //onChange={(e) => setFile(e.target.files[0])}
                        onChange={handleimageselection}
                      />
                    </InputRightElement>
                  </InputGroup>
                  <PrimaryInput
                    variant={"bothSide"}
                    onChange={handleManufacturer}
                    inputPlace="Manufacturer"
                    defaultValue={manufacturer}
                    inputValue={manufacturer}
                  />
                    <PrimaryInput
                      variant="bothSide"
                      inputValue={Composition}
                      onChange={(event) => setComposition(event.target.value)}
                      inputPlace="Medicine Composition"
                    />
                    {/* <PrimaryButton
                      buttonText="Fetch"
                      verticalAlign="bottom"
                      variant="grayBtn"
                      btnStyle={{
                        w: "15%",
                        color: COLORS.PRIMARY_COLOR,
                        verticalAlign: "bottom",
                        ml: "4px",
                        mb: "0px",
                        h: "48px",
                        m: "0",
                        borderRadius: "0 10px 10px 0",
                        opacity: isChatbotAllowed() ? 1 : 0.6,
                        cursor: isChatbotAllowed() ? "pointer" : "not-allowed"
                      }}
                      onClick={() => {
                                  if (isChatbotAllowed()) {
                                    fetchComposition(medicinename);
                                  } else {
                                    showErrorToast("Please upgrade your subscription to use this feature");
                                  }
                                }}
                                isDisabled={!isChatbotAllowed()}
                                title={!isChatbotAllowed() ? "Please upgrade your subscription to use AI features" : ""}
                      // onClick={() => fetchComposition(medicinename)}
                      // isDisabled={false}
                    /> */}
                    <Box
                      as="button"
                      type="button"
                      border="1px solid #E6E7E9"
                      // borderRadius="full"
                      width={{ base: "100%", md: "10%" }}
                      // w="40px"
                      // h="40px"
                      p="8px"
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      // cursor={medicineTextFieldValue ? "pointer" : "not-allowed"}
                      // opacity={medicineTextFieldValue ? 1 : 0.5}
                      // pointerEvents={medicineTextFieldValue ? "auto" : "none"}
                      onClick={() => {
                      if (isChatbotAllowed()) {
                        fetchComposition(medicinename);
                      } else {
                        showErrorToast("Please upgrade your subscription to use this feature");
                      }
                    }}
                    isDisabled={!isChatbotAllowed()}
                    title={!isChatbotAllowed() ? "Please upgrade your subscription to use AI features" : ""}
                      bg="white"
                      // _hover={medicineTextFieldValue ? { bg: "#f0f0f0" } : {}}
                    >
                      <Image w="28px" src="/assets/svgs/ai-star-outline.svg" />
                    </Box>
                </Flex>
                {/* <Divider /> */}
                <RadioGroup
                  // mt="1rem"
                  // defaultValue={medicineTypeRadio || "Tablet"}
                  value={medicinetype}
                  // onChange={handlemedicinetypechange}
                  // onChange={(value) => handlemedicinetypechange(value, "radio")}
                   onChange={(value) => {
    console.log("Radio selected:", value);
    handlemedicinetypechange(value, "radio");
  }}
                >
                  <Stack direction="row" alignItems='center' spacing={4} wrap="wrap">
                    <Radio colorScheme="green" value="Tablet">Tablet</Radio>
                    <Radio colorScheme="green" value="Capsule">Capsule</Radio>
                    <Radio colorScheme="green" value="Syrup">Syrup</Radio>
                    <Radio colorScheme="green" value="Drops">Drops</Radio>
                    <Radio colorScheme="green" value="Injection">Injection</Radio>
                    <Radio colorScheme="green" value="Nebulization">Nebulization</Radio>
                    <Radio colorScheme="green" value="IVFluids">IV Fluids</Radio>
                    <Radio colorScheme="green" value="Inhaler">Inhaler</Radio>
                    <Radio colorScheme="green" value="Sachet">Sachet</Radio>
                    <Radio colorScheme="green" value="Ointment">Ointment</Radio>
                    <Radio colorScheme="green" value="Cream">Cream</Radio>
                    <Radio colorScheme="green" value="Gel">Gel</Radio>
  
                    {/* <Radio colorScheme="green" value="Respules">Respules</Radio>
                    <Radio colorScheme="green" value="Suspension">Suspension</Radio>
                    <Radio colorScheme="green" value="Foam">Foam</Radio>
                    <Radio colorScheme="green" value="Suppository">Suppository</Radio>
                    <Radio colorScheme="green" value="EA">EA</Radio>
                    <Radio colorScheme="green" value="Device">Device</Radio>
                    <Radio colorScheme="green" value="Box">Box</Radio>
                    <Radio colorScheme="green" value="Spray">Spray</Radio>
                    <Radio colorScheme="green" value="Lotion">Lotion</Radio>
                    <Radio colorScheme="green" value="Tube">Tube</Radio>
                    <Radio colorScheme="green" value="Gargle">Gargle</Radio>
                    <Radio colorScheme="green" value="Powder">Powder</Radio>
                    <Radio colorScheme="green" value="Soap">Soap</Radio>
                    <Radio colorScheme="green" value="Aerosol">Aerosol</Radio>
                    <Radio colorScheme="green" value="Shampoo">Shampoo</Radio>
                    <Radio colorScheme="green" value="Topical Cleanser">Topical Cleanser</Radio>
                    <Radio colorScheme="green" value="Custom">Custom</Radio> */}
                    <Text>-Or-</Text>
                    <Box mx='1rem'>
                  {/* <DropdownInput
    variant="bothSide"
    dropDownPlace="More Medicine Types"
    options={additionalMedicineTypes}
    onClick={(value) => handleDropdownMedTypeChange(value)}
    value={dropdownMedType}
    defaultOption={dropdownMedType || "Select more types"}
  /> */}
   <DropdownInput
        variant="bothSide"
        dropDownPlace="More Types"
        options={additionalMedicineTypes}
        onClick={(value) => {
          console.log("Dropdown selected:", value);
          handleDropdownMedTypeChange(value);
        }}
        value={dropdownMedType}
        defaultOption={dropdownMedType || "Select more types"}
        // Add a clear prop if your DropdownInput component supports it
        clearValue={() => setDropdownMedType("")}
      />
  
                    </Box>
                  </Stack>
                </RadioGroup>
                {/* <Divider /> */}
                <Box>
                  <Flex>
                  <PrimaryInput
                    variant={"bothSide"}
                    onChange={handleDrugClass}
                    inputPlace="Drug Class"
                    defaultValue={drugClass}
                    inputValue={drugClass}
                  />
                  <PrimaryInput
                    variant={"bothSide"}
                    onChange={handleTherapeuticCategory}
                    inputPlace="Therapeutic category"
                    defaultValue={therapeutic}
                    inputValue={therapeutic}
                  />
                  {medicinetype == "Tablet" || medicinetype == "Capsule" || medicinetype == "Suppository" || medicinetype == "Powder" ? (
    <MiniDropdownInput
      variant="bothSide"
      options={[
        { label: "mg", value: "mg" },
        { label: "mcg", value: "mcg" },
        { label: "g", value: "g" },
      ]}
      placeholderProp="Strength"
      onSelect={handleChangeDosageUnit}
      handleInputChange={(e) =>
        setMedicineDosage(
          validationOfNumberWithOnly1Decimal(e.target.value),
        )
      }
      inputVal={dosage}
      defaultOptionProp={dosageunit}
      maxLength="6"
    />
  ) : medicinetype === "Inhaler" || medicinetype === "Spray" || medicinetype === "Aerosol" ? (
    <MiniDropdownInput
      variant="bothSide"
      options={[
        { label: "puffs", value: "puffs" },
        { label: "ml", value: "ml" },
        { label: "grms", value: "grms" },
      ]}
      placeholderProp="Volume"
      onSelect={handleChangeDosageUnit}
      handleInputChange={(e) =>
        setMedicineDosage(
          validationOfNumberWithOnly1Decimal(e.target.value),
        )
      }
      inputVal={dosage}
      defaultOptionProp={dosageunit}
      maxLength="6"
    />
  ) : medicinetype === "Syrup" ||
      medicinetype === "IVFluids" ||
      medicinetype === "Nebulization" ||
      medicinetype === "Drops" ||
      medicinetype === "Injection" ||
      medicinetype === "Suspension" ||
      medicinetype === "Respules" ||
      medicinetype === "Gargle" ||
      medicinetype === "Shampoo" ||
      medicinetype === "Topical Cleanser" ? (
    <MiniDropdownInput
      variant="bothSide"
      options={[{ label: "ml", value: "ml" }]}
      placeholderProp="Volume"
      onSelect={handleChangeDosageUnit}
      handleInputChange={(e) =>
        setMedicineDosage(
          validationOfNumberWithOnly1Decimal(e.target.value),
        )
      }
      inputVal={dosage}
      defaultOptionProp={dosageunit}
      maxLength="6"
    />
  ) : medicinetype === "Ointment" ||
      medicinetype === "Cream" ||
      medicinetype === "Gel" ||
      medicinetype === "Foam" ||
      medicinetype === "Lotion" ||
      medicinetype === "Tube" ||
      medicinetype === "Soap" ? (
    <MiniDropdownInput
      variant="bothSide"
      options={[{ label: "grms", value: "grms" }, { label: "ml", value: "ml" }]}
      placeholderProp="Weight/Volume"
      onSelect={handleChangeDosageUnit}
      handleInputChange={(e) =>
        setMedicineDosage(
          validationOfNumberWithOnly1Decimal(e.target.value),
        )
      }
      inputVal={dosage}
      defaultOptionProp={dosageunit}
      maxLength="6"
    />
  ) : medicinetype === "EA" || medicinetype === "Device" || medicinetype === "Box" ? (
    <MiniDropdownInput
      variant="bothSide"
      options={[{ label: "each", value: "each" }]}
      placeholderProp="Count"
      onSelect={handleChangeDosageUnit}
      handleInputChange={(e) =>
        setMedicineDosage(
          validationOfNumberWithOnly1Decimal(e.target.value),
        )
      }
      inputVal={dosage}
      defaultOptionProp={dosageunit}
      maxLength="6"
    />
  ) : medicinetype === "Sachet" ? (
    <MiniDropdownInput
      variant="bothSide"
      options={[
        { label: "mg", value: "mg" },
        { label: "g", value: "g" },
      ]}
      placeholderProp="Strength"
      onSelect={handleChangeDosageUnit}
      handleInputChange={(e) =>
        setMedicineDosage(
          validationOfNumberWithOnly1Decimal(e.target.value),
        )
      }
      inputVal={dosage}
      defaultOptionProp={dosageunit}
      maxLength="6"
    />
  ) : (
    // Default case for CUSTOM and any unexpected types
    <MiniDropdownInput
      variant="bothSide"
      options={[
        { label: "mg", value: "mg" },
        { label: "ml", value: "ml" },
        { label: "grms", value: "grms" },
        { label: "puffs", value: "puffs" },
        { label: "each", value: "each" },
      ]}
      placeholderProp={medicinetype === "Custom" ? "Custom Unit" : "Strength"}
      onSelect={handleChangeDosageUnit}
      handleInputChange={(e) =>
        setMedicineDosage(
          validationOfNumberWithOnly1Decimal(e.target.value),
        )
      }
      inputVal={dosage}
      defaultOptionProp={dosageunit}
      maxLength="6"
    />
  )}
  
  {medicinetype == "IVFluids" && (
    <MiniDropdownInput
      variant="bothSide"
      options={[
        { label: "ml/hr", value: "ml/hr" },
        { label: "ml/min", value: "ml/min" },
      ]}
      handleInputChange={(e) =>
        setRateOfInfusionValue(
          validationOfNumberWithOnly1Decimal(e.target.value),
        )
      }
      placeholderProp={"Rate of Infusion"}
      onSelect={handleRateOfInfusionUnit}
      maxLength="6"
    />
  )}
  
                  {/* existing code */}
                  {/* {medicinetype == "Tablet" || medicinetype == "Capsule" ? (
                    <MiniDropdownInput
                      variant="bothSide"
                      options={[
                        { label: "mg", value: "mg" },
                        { label: "mcg", value: "mcg" },
                        { label: "g", value: "g" },
                      ]}
                      placeholderProp={
                        medicinetype == "Syrup" ||
                        medicinetype == "Injection" ||
                        medicinetype == "Nebulization" ||
                        medicinetype == "IVFluids" ||
                        medicinetype == "Drops"
                          ? "Volume"
                          : "Strength"
                      }
                      onSelect={handleChangeDosageUnit}
                      handleInputChange={(e) =>
                        setMedicineDosage(
                          validationOfNumberWithOnly1Decimal(e.target.value),
                        )
                      }
                      inputVal={dosage}
                      defaultOptionProp={dosageunit}
                      maxLength="6"
                    />
                  ) : medicinetype === "Inhaler" ? (
                    <MiniDropdownInput
                      variant="bothSide"
                      options={[
                        { label: "puffs", value: "puffs" },
                        { label: "ml", value: "ml" },
                        { label: "grms", value: "grms" },
                      ]}
                      placeholderProp={
                        medicinetype == "Inhaler" ? "Volume" : "Strength"
                      }
                      onSelect={handleChangeDosageUnit}
                      handleInputChange={(e) =>
                        setMedicineDosage(
                          validationOfNumberWithOnly1Decimal(e.target.value),
                        )
                      }
                      inputVal={dosage}
                      defaultOptionProp={dosageunit}
                      maxLength="6"
                    />
                  ) : medicinetype === "Syrup" ||
                    medicinetype === "IVFluids" ||
                    medicinetype === "Nebulization" ||
                    medicinetype === "Drops" ||
                    medicinetype === "Injection" ? (
                    <MiniDropdownInput
                      variant="bothSide"
                      options={[{ label: "ml", value: "ml" }]}
                      placeholderProp={
                        medicinetype == "Syrup" ||
                        medicinetype == "Injection" ||
                        medicinetype == "Nebulization" ||
                        medicinetype == "IVFluids" ||
                        medicinetype == "Drops"
                          ? "Volume"
                          : "Strength"
                      }
                      onSelect={handleChangeDosageUnit}
                      handleInputChange={(e) =>
                        setMedicineDosage(
                          validationOfNumberWithOnly1Decimal(e.target.value),
                        )
                      }
                      inputVal={dosage}
                      defaultOptionProp={dosageunit}
                      maxLength="6"
                    />
                  ) : (
                    <MiniDropdownInput
                      variant="bothSide"
                      options={[
                        { label: "mg", value: "mg" },
                        { label: "ml", value: "ml" },
                        { label: "grms", value: "grms" },
                      ]}
                      placeholderProp={
                        medicinetype == "Syrup" ||
                        medicinetype == "Injection" ||
                        medicinetype == "Nebulization" ||
                        medicinetype == "IVFluids" ||
                        medicinetype == "Drops"
                          ? "Volume"
                          : "Strength"
                      }
                      onSelect={handleChangeDosageUnit}
                      handleInputChange={(e) =>
                        setMedicineDosage(
                          validationOfNumberWithOnly1Decimal(e.target.value),
                        )
                      }
                      inputVal={dosage}
                      defaultOptionProp={dosageunit}
                      maxLength="6"
                    />
                  )}
  
                  {medicinetype == "IVFluids" && (
                    <MiniDropdownInput
                      variant="bothSide"
                      options={[
                        { label: "ml/hr", value: "ml/hr" },
                        { label: "ml/min", value: "ml/min" },
                      ]}
                      handleInputChange={(e) =>
                        setRateOfInfusionValue(
                          validationOfNumberWithOnly1Decimal(e.target.value),
                        )
                      }
                      placeholderProp={"Rate of Infusion"}
                      onSelect={handleRateOfInfusionUnit}
                      maxLength="6"
                    />
                  )} */}
  
                  <DropdownInput
                    variant="bothSide"
                    dropDownPlace={
                      medicinetype == "Ointment" || medicinetype === "Cream" || medicinetype === "Gel"
                        ? "Application Frequency"
                        : medicinetype == "Nebulization" ||
                            medicinetype == "Inhaler" ||
                            medicinetype == "IVFluids"
                          ? "Frequency"
                          : "Consumption Quantity"
                    }
                    // options={["0.5", "1", "2", "3", "4"]}
                    options={(medicinetype === "Ointment" || medicinetype === "Cream" || medicinetype === "Gel") ? ["1", "2", "3", "4"] : ["0.5", "1", "2", "3", "4"]}
                    onClick={handleconsumptionfrequencychange}
                    value={frequency || "1"}
                    defaultOption={frequency || "1"}
                  />
                </Flex>
                  {/* <Divider my="10px" /> */}
                <Flex flexDir='column'>
                  { (medicinetype == "Injection" ||
                    medicinetype == "Tablet" ||
                    medicinetype == "Capsule") || medicinetype == "Nebulization" || medicinetype == "Inhaler" ? (
                    <Text fontSize="0.875rem" fontWeight="600" my="0.5rem">
                      Duration
                    </Text>
                    ) : medicinetype == "Ointment" ? (
                      <Text fontSize="0.875rem" fontWeight="600" my="0.5rem">
                        Application Duration
                      </Text>
                    ) : (
                      medicinetype == "IVFluids" && 
                      <Text fontSize="0.875rem" fontWeight="600" my="0.5rem">
                        Infusion Duration
                      </Text>
                    )
                  }
                  <Flex w='100%'>
                  {(medicinetype == "Injection" ||
                    medicinetype == "Tablet" ||
                    medicinetype == "Capsule") && (
                    <>
                      {/* <Divider my="10px" /> */}
                      {/* <Box display="flex" flexDir="row"> */}
                        <Box width={medicinetype == "Injection" ? "50%" : "100%"}>
                          <DropdownInput
                            variant="bothSide"
                            dropDownPlace="Duration"
                            options={["Days", "Weeks", "Months", "Years"]}
                            onClick={handleDurationUnit}
                            // defaultOption={durationUnit}
                            defaultOption="Days"
                          />
                        </Box>
                        <Box width={medicinetype == "Injection" ? "50%" : "100%"}>
                          <DropdownInput
                            variant="bothSide"
                            dropDownPlace="Interval Value"
                            options={["1", "2", "3", "4", "5", "6", "7"]}
                            onClick={handleDurationValue}
                            // defaultOption={durationValue}
                            defaultOption="5"
                          />
                        </Box>
                      {/* </Box> */}
                      {/* <Divider my="10px" /> */}
                    </>
                  )}
  
                  {medicinetype == "Injection" && (
                    <>
                      <DropdownInput
                        variant="bothSide"
                        dropDownPlace="Route of Administration"
                        options={[
                          "Intravenous (IV)",
                          "Intramuscular (IM)",
                          "Subcutaneous (SC)",
                        ]}
                        onClick={handleRouteOfAdministration}
                      />
                      <Box w='50%'>
                        <PrimaryInput
                          variant={"bothSide"}
                          onChange={handleTiming}
                          inputPlace="Timing"
                        />
                      </Box>
                    </>
                  )}
  
                  {medicinetype == "Ointment" && (
                    <>
                      {/* <Divider my="10px" /> */}
                      {/* <Text fontSize="0.875rem" fontWeight="500" mb="10px">
                        Application Duration
                      </Text> */}
                      {/* <Box display="flex" flexDir="row"> */}
                        <Box width="100%">
                          <DropdownInput
                            variant="bothSide"
                            dropDownPlace="Duration"
                            options={["Days", "Weeks", "Months", "Years"]} // Interval units as options
                            onClick={handleDurationUnit}
                            // defaultOption={durationUnit}
                            defaultOption="Days"
                          />
                        </Box>
                        <Box width="100%">
                          <DropdownInput
                            variant="bothSide"
                            dropDownPlace="Interval Value"
                            options={["1", "2", "3", "4", "5", "6", "7"]}
                            onClick={handleDurationValue}
                            // defaultOption={durationValue}
                            defaultOption="5"
                          />
                        </Box>
                      {/* </Box> */}
  
                      {/* <Divider my="10px" /> */}
  
                      <DropdownInput
                        variant="bothSide"
                        dropDownPlace="Quantity"
                        options={[
                          "Pea-sized",
                          "Thin layer",
                          "Fingertip unit (FTU)",
                          "Half a fingertip",
                        ]}
                        onClick={handleQuantity}
                        value={quantity || ""}
                        defaultOption={quantity}
                      />
                      <DropdownInput
                        variant="bothSide"
                        dropDownPlace="Area of Application"
                        options={["On Scalp", "On Skin", "On Wound", "On Hair"]}
                        onClick={(value) => setAreaOfApplication(value)}
                        value={areaOfApplication || ""}
                        defaultOption={areaOfApplication}
                      />
                    </>
                  )}
  
                  {medicinetype == "Nebulization" && (
                    <>
                      {/* <Divider my="10px" /> */}
                      {/* <Text fontSize="0.875rem" fontWeight="500" mb="10px">
                        Duration
                      </Text> */}
  
                      {/* <Box display="flex" flexDir="row"> */}
                        <Box width="100%">
                          <DropdownInput
                            variant="bothSide"
                            dropDownPlace="Duration"
                            options={["Days", "Weeks", "Months", "Years"]}
                            onClick={handleDurationUnit}
                            // defaultOption={durationUnit}
                            defaultOption="Days"
                          />
                        </Box>
                        <Box width="100%">
                          <DropdownInput
                            variant="bothSide"
                            dropDownPlace="Interval Value"
                            options={["1", "2", "3", "4", "5", "6", "7"]}
                            onClick={handleDurationValue}
                            // defaultOption={durationValue}
                            defaultOption="5"
                          />
                        </Box>
                      {/* </Box> */}
                      {/* <Divider my="10px" /> */}
  
                      <DropdownInput
                        variant="bothSide"
                        dropDownPlace="Diluent"
                        options={["Normal saline", "Distilled water", "3% saline"]}
                        onClick={handleDiluent}
                      />
                    </>
                  )}
  
                  {medicinetype == "IVFluids" && (
                    <>
                      {/* <Divider my="10px" /> */}
                      {/* <Text fontSize="0.875rem" fontWeight="500" mb="10px">
                        Infusion Duration
                      </Text> */}
  
                      <DropdownInput
                        variant="bothSide"
                        dropDownPlace="Infusion frequency"
                        options={["1", "2", "3", "4", "5", "6", "7"]}
                        onClick={handleDurationValue}
                        // defaultOption={durationValue}
                        defaultOption="5"
                      />
                      <DropdownInput
                        variant="bothSide"
                        dropDownPlace="Infusion Duration"
                        options={["Days", "Weeks", "Months", "Years"]}
                        onClick={handleDurationUnit}
                        // defaultOption={durationUnit}
                        defaultOption="Days"
                      />
  
                      {/* <Divider my="10px" /> */}
  
                      <PrimaryInput
                        variant={"bothSide"}
                        onChange={handleAdditives}
                        inputPlace="Additives"
                      />
                    </>
                  )}
  
                  {medicinetype == "Inhaler" && (
                    <>
                      {/* <Text fontSize="0.875rem" fontWeight="500" mb="10px">
                        Duration
                      </Text> */}
  
                      {/* <Box display="flex" flexDir="row"> */}
                        <Box width="100%">
                          <DropdownInput
                            variant="bothSide"
                            dropDownPlace="Duration"
                            options={["Days", "Weeks", "Months", "Years"]}
                            onClick={handleDurationUnit}
                            // defaultOption={durationUnit}
                            defaultOption="Days"
                          />
                        </Box>
                        <Box width="100%">
                          <DropdownInput
                            variant="bothSide"
                            dropDownPlace="Interval Value"
                            options={["1", "2", "3", "4", "5", "6", "7"]}
                            onClick={handleDurationValue}
                            // defaultOption={durationValue}
                            defaultOption="5"
                          />
                        </Box>
                      {/* </Box> */}
                      {/* <Divider my="10px" /> */}
                    </>
                  )}
  
                  
                  {/* <MonthYearPicker
                    placeholderProp="Medicine Expiry"
                    value={medicineexpirydate}
                    onDateChange={handleMonthYearChange}
                    datePickerInputStyle={{ borderRadius: "0" }}
                    minYear={moment().year()}
                  /> */}
                  </Flex>
                </Flex>
                <Flex justifyContent="space-between" mt='0.75rem' alignItems='center'>
                  {/* OLD CHECKBOX GROUP - REPLACED WITH MEAL TIMING DROPDOWN
                  <CheckboxGroup
                    colorScheme="green"
                    onChange={handlemedicinetime}
                    value={timeValues}
                  >
                    <Stack spacing={2} direction="row">
                      <Checkbox value="morning">Morning</Checkbox>
                      <Checkbox value="afternoon">Afternoon</Checkbox>
                      <Checkbox value="night">Night</Checkbox>
                    </Stack>
                  </CheckboxGroup>
                  */}

                  {/* Dropdown for Meal Timing */}
                  <Box width='180px'>
                    <DropdownInput
                      variant="bothSide"
                      dropDownPlace="Meal Timing"
                      arrowCSS={{pr:0}}
                      options={[
                        "1-0-0",
                        "0-1-0",
                        "0-0-1",
                        "1-1-0",
                        "1-0-1",
                        "0-1-1",
                        "1-1-1",
                        "0-0-0"
                      ]}
                      onClick={(value) => {
                        if (value) {
                          const { morning, afternoon, night } = parseMealTiming(value);
                          setMorning(morning ? "1" : "0");
                          setAfternoon(afternoon ? "1" : "0");
                          setEvening(night ? "1" : "0");
                        }
                      }}
                      value={getMealTimingLabel(String(morning) === "1" ? 1 : 0, String(afternoon) === "1" ? 1 : 0, String(setnight) === "1" ? 1 : 0)}
                    />
                  </Box>
  
                  <Text fontWeight='600' whiteSpace='nowrap'>- Or -</Text>
                  {/* <Text
                    fontWeight="600"
                    width="50%"
                    display="flex"
                    justifyContent="center"
                    whiteSpace="nowrap"
                    my='0.5rem'
                  >
                    - Or -
                  </Text> */}
  
                  <Flex width="100%">
    <Box width='150px'>
                    <DropdownInput
                      variant="bothSide"
                      dropDownPlace="Frequency"
                      options={["Hours", "Daily", "Weekly"]}
                      onClick={handleFrequencyUnit}
                      value={medicineFreqUnit}
                    />
                    </Box>
                    <Box width='150px'>
                    <DropdownInputForVitals
                      variant="bothSide"
                      dropDownPlace="Value"
                      options={["1", "2", "3", "4", "8"]}
                      onClick={handleFrequencyValue}
                      value={medicineFreqValue}
                      readOnly=""
                      inputValueProp={medicineFreqValue}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (value) {
                          setTimeValues([]);
                          setMorning(0);
                          setAfternoon(0);
                          setNight(0);
                        }
                        setMedicineFreqValue(value);
                      }}
                      maxLength={2}
                    />
                    </Box>
                  </Flex>
                  {/* <Box display="flex" w='100%' alignItems='center' gap='0.75rem'> */}
                  <Box width='50%'>
                    {/* CONDITIONAL TIMING: TOPICAL VS FOOD */}
                    {(medicinetype === "Cream" || medicinetype === "Ointment" || medicinetype === "Gel") ? (
                      <Box w='100%'>
                        {/* <DropdownInput
                          variant="bothSide"
                          dropDownPlace="Product Quantity"
                          options={["1", "2", "3", "4"]}
                          onClick={(value) => setProductQuantity(value)}
                          value={productQuantity || "1"}
                        /> */}

                        {/* <Text fontSize="sm" mb={1} mt={2}>Application Timing</Text> */}
                        <DropdownInput
                          variant="bothSide"
                          dropDownPlace="Application Timing"
                          options={[
                            "After Bath",
                            "Before Bath",
                            "After Sun",
                            "Before Sun",
                            "Time-based",
                          ]}
                          onClick={(value) => {
                            setFoodTiming(value);
                          }}
                          value={foodTiming}
                        />

                        {/* <Box mt={2}>
                          <DropdownInput
                            variant="bothSide"
                            dropDownPlace="Area of Application"
                            options={["On Scalp", "On Skin", "On Wound", "On Hair"]}
                            onClick={(value) => setAreaOfApplication(value)}
                            value={areaOfApplication || ""}
                            defaultOption={areaOfApplication}
                          />
                        </Box> */}
                      </Box>
                    ) : (
                      <RadioGroup
                        w='100%'
                        colorScheme="green"
                        onChange={handlemedicinetimebeforeafter}
                        value={foodTiming}
                      >
                        <Stack spacing={2} direction="row">
                          <Radio value="beforefood">Before Food</Radio>
                          <Radio value="afterfood">After Food</Radio>
                        </Stack>
                      </RadioGroup>
                    )}
                  </Box>
                </Flex>
                </Box>
                <Box>
                  {/* <Box w="100%" pos="relative" cursor="pointer">
                    <PrimaryInput
                      inputPlace="Prescribed by"
                      variant="defaultSide"
                      inputValue={prescribedby}
                      onChange={(e) =>
                        handleSurgeonNameChange(
                          handleAlphaDotAndSpace(e.target.value, 50),
                        )
                      }
                      onClick={() => listOfSurgeonNames(false)}
                      inputIdProp={"DoctorNameInAdd"}
                      boolProp={boolValForSuggestions}
                    />
                    <Image
                      top="33%"
                      right="6.5%"
                      w="15px"
                      onClick={() => listOfSurgeonNames(true)}
                      pos="absolute"
                      src="/assets/imgs/double-arrow.png"
                    />
                  </Box> */}
                  {showDocNamesDropdown && suggestions.length > 0 && (
                    <Menu isOpen={true}>
                      <MenuButton
                        as={Box}
                        w="100%"
                        display="block"
                        pos="relative"
                        zIndex="999"
                      >
                        <Box
                          pos="absolute"
                          top="100%"
                          left="0"
                          w="100%"
                          bg="white"
                          borderTop="none"
                          border="1px solid #E6E7E9"
                          borderRadius="0 0 12px 12px"
                        />
                      </MenuButton>
                      <MenuList
                        w="100%"
                        borderRadius="0 0 12px 12px"
                        zIndex="999"
                        bg="white"
                        maxH="150px"
                        overflow="hidden auto"
                      >
                        {suggestions.map((suggestion, index) => (
                          <MenuItem
                            key={index}
                            onClick={() => handleSelect(suggestion)}
                            cursor="pointer"
                            p="1rem"
                            py="0.5rem"
                            borderBottom="1px solid #E6E7E9"
                          >
                            <Text fontSize="0.875rem" fontWeight="500">
                              {suggestion.doctorname}
                            </Text>
                          </MenuItem>
                        ))}
                      </MenuList>
                    </Menu>
                  )}
                  {/* <PrimaryInput
                    inputPlace="Hospital name"
                    variant="downSide"
                    onChange={(e) =>
                      setHospitalname(handleAlphaNumericDotAndSpace(e.target.value))
                    }
                    inputValue={hospitalname}
                  /> */}
  
                  {/* <Textarea
                    mt='0.5rem'
                    borderRadius='10px'
                    placeholder="Instructions"
                    defaultValue={instructions}
                    onChange={handleInstructions}
                    inputValue={instructions}
                  /> */}
  
                  <Box position='relative' display='flex' alignItems='flex-end' flexDirection='row'>
                    <Box
                      as="form"
                      width='100%'
                      bg="white"
                      pt={"2px"}
                    >
                      <Box flex="1" width="100%" position="relative" bg={"#f9fafb"}>
                        <Textarea
                          borderRadius='0'
                          // value={newMedicine.custommessage || ''}
                          value={instructions || ''}
                          onChange={(e) => {
                      handleInstructions(e.target.value);
                      setValue("textField", e.target.value); 
                    }}
                    //       onChange={(e) => {
                    //   handleNewMedicineChange("custommessage", e.target.value);
                    //   setValue("textField", e.target.value); 
                    // }}
                          height="100%"
                          padding="2"
                          resize="none"
                          // disabled={typing} // Disable when AI typing is true
                          style={{ overflowWrap: "break-word", whiteSpace: "pre-wrap" }}
                        />                      
                        {!instructions && (
                          <Text
                            position="absolute"
                            bottom="2"
                            left="50%"
                            transform="translateX(-50%)"
                            fontSize="sm"
                            color="gray.500"
                            w={{ base: "100%", md: "unset" }}
                            textAlign={{ base: "center", md: "unset" }}
                          >
                            {placeholder}
                          </Text>
                        )}
                      </Box>
                      
                    </Box>
                  </Box>
                  {/* <Box mt=".5rem">
                    <Checkbox
                      colorScheme="green"
                      sx={{
                        ".chakra-checkbox__control": {
                          width: "20px",
                          height: "20px",
                          borderRadius: "5px",
                        },
                      }}
                      onChange={handleIsCurrent}
                    >
                      Current
                    </Checkbox>
                  </Box> */}
                </Box>
                {/* Audio & Language Controls Row - Highlighted Section */}
                      <Box
                        bg="#f8f9fa"
                        border="1px solid #e9ecef"
                        borderRadius="8px"
                        p="1rem"
                        mt="1rem"
                        // mb="1rem"
                      >
                        <Flex
                          alignItems="center"
                          justifyContent="space-around"
                          // justifyContent="space-between"
                          gap="1rem"
                          flexWrap={{ base: "wrap", md: "nowrap" }}
                        >
                          {/* Input Language Dropdown */}
                          <Box flex="1" minW="120px">
                            <DropdownWithMultiLingual 
                              menuList={{pos:'relative', right:'75px'}}
                              placeholder="English"
                              onClick={handleChangeLanguage}
                              options={languageOptions.map(value => ({ value }))}
                              title="Input Language"
                            />
                          </Box>
                          
                          {/* Audio Controls and Wave Display */}
                          <Box 
                      flex="1"
                      display="flex" 
                      alignItems="center" 
                      justifyContent="center"
                      gap="0.75rem"
                      minH="50px"
                      px="1rem"
                    >
                      <GPUChatAudioManagerSpeechMode
                        transcriber={activeTranscriber}
                        mode={mode}
                        setPlaceholder={setPlaceholder}
                        setTyping={setTyping}
                        onRecordingStateChange={handleRecordingStateChange} 
                      />
                
                      {isRecording && (
                        <Box flex="1" minW="180px" maxW="250px">
                          <AudioDisplayForClutter
                            borderRadius="lg"
                            stream={stream}
                            width="100%"
                          />
                        </Box>
                      )}
                    </Box>
                
                          {/* Output Language Dropdown */}
                          <Box flex="1" minW="120px">
                            <DropdownWithMultiLingual 
                              menuList={{pos:'relative', right:'75px'}}
                              placeholder="English"
                              onClick={handleChangeOutputLanguage}
                              options={languageOptions.map(value => ({ value }))}
                              title="Output Language"
                            />
                          </Box>
                
                          {/* AI Correction Button */}
                          <Box
                            as="button"
                            type="button"
                            border="1px solid #E6E7E9"
                            borderRadius="full"
                            w="40px"
                            h="40px"
                            p="8px"
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            cursor={textFieldValue ? "pointer" : "not-allowed"}
                            opacity={textFieldValue ? 1 : 0.5}
                            pointerEvents={textFieldValue ? "auto" : "none"}
                            onClick={() => textFieldValue && correctOrders("add")}
                            flexShrink="0"
                            bg="white"
                            _hover={textFieldValue ? { bg: "#f0f0f0" } : {}}
                          >
                            <Image w="28px" src="/assets/svgs/ai-star-outline.svg" />
                          </Box>
                        </Flex>
                      </Box>
                {filenameArray.map((filename, indexToDelete) => (
                  <Button
                    fontSize="14px"
                    fontWeight="500"
                    w="100%"
                    h="48px"
                    borderRadius="10px"
                    border="1px solid #E6E7E9"
                    display="flex"
                    justifyContent="space-between"
                    bg="white"
                    color="#1C4EC5"
                    sx={{ _hover: { bg: "none" } }}
                  >
                    Document {indexToDelete + 1}
                    <Box as="span">
                      <Image src="/assets/imgs/delete.png" />
                    </Box>
                  </Button>
                ))}
                <input
                  type="file"
                  id="file-upload"
                  onChange={(e) => handleMedicationUpload(e)}
                  ref={fileInputRef} // Set the ref for the file input
                  style={{ display: "none" }} // Hide the file input
                />
              </Stack>
            </Box>
          </>
        }
        modalFooterBtn={
          <>
          {/* <Box position='relative' display='flex' alignItems='flex-end' flexDirection='row'>        
            <GPUChatAudioManager
                transcriber={activeTranscriber}
                setPlaceholder={setPlaceholder}
                setTyping={setTyping}
                // onTranscribedText={handleTranscribedText}  // This is the key addition
                  onTranscribedText={(text) => {
              handleInstructions(text);
              setValue("textField", text);
            }}
              />
              <Box
                as="button"
                type="button" 
                border="1px solid #E6E7E9"
                borderRadius="full"
                w="36px"
                h="auto"
                p="10px"
                mr='10px'
                display="flex"
                justifyContent="center"
                alignItems="center"
                cursor={textFieldValue ? "pointer" : "not-allowed"}
                opacity={textFieldValue ? 1 : 0.5}
                pointerEvents={textFieldValue ? "auto" : "none"}
                onClick={() => textFieldValue && correctOrders("add")}
              >
                <Image w="26px" src="/assets/svgs/ai-star-outline.svg" />
              </Box>
          </Box> */}
            <PrimaryButton buttonText="Add Medication" onClick={addmedicine} />
          </>
        }
      />
  
      <DynamicModal
        ref={editmedications}
        modalHeader="Edit Medication"
        modalWidth={{base:'100%', md: 'calc(100vw - 10%)'}}
        modalBody={
          <>
            <Box display="flex" flexDir="column" gap="20px">
              <Stack>
                <Flex>
                  <InputGroup>
                    <Input
                      pr="4.5rem" // Padding right to make room for the icon
                      type="text"
                      placeholder="Medicine name*"
                      // value={medicinename}
                      value={medicinename.charAt(0).toUpperCase() + medicinename.slice(1)}
                      sx={{
                        height: "48px",
                        borderRadius: "10px 0 0 10px",
                        _hover: {
                          border: "2px solid",
                          borderColor: COLORS.INPUT_FOCUS_DARK,
                          outline: "none",
                          bg: "none",
                          _focus: {
                            borderRadius: "10px",
                            borderColor: COLORS.INPUT_FOCUS_DARK,
                            outline: "none",
                          },
                          _focusVisible: { borderColor: "none" },
                        },
                      }}
                      onChange={handlemedicinename}
                      maxLength={80}
                    />
                    <InputRightElement width="4.5rem">
                      <Box
                        as="button"
                        h="1.75rem"
                        bg="none"
                        pt="8px"
                        onClick={() => document.getElementById("file-upload").click()}
                        sx={{ _hover: { bg: "none" } }}
                      >
                        <Image src="/assets/svgs/image-search-blue.svg" />
                      </Box>
                      <input
                        type="file"
                        id="file-upload"
                        style={{ display: "none" }}
                        //onChange={(e) => setFile(e.target.files[0])}
                        onChange={handleimageselection}
                      />
                    </InputRightElement>
                  </InputGroup>
                  <PrimaryInput
                    variant={"bothSide"}
                    onChange={handleManufacturer}
                    inputPlace="Manufacturer"
                    defaultValue={manufacturer}
                    inputValue={manufacturer}
                  />
                    <PrimaryInput
                      variant="bothSide"
                      inputValue={Composition}
                      onChange={(event) => setComposition(event.target.value)}
                      inputPlace="Medicine Composition"
                      // isDisabled
                    />
                    {/* <PrimaryButton
                      buttonText="Fetch"
                      verticalAlign="bottom"
                      variant="grayBtn"
                      btnStyle={{
                        w: "15%",
                        color: COLORS.PRIMARY_COLOR,
                        verticalAlign: "bottom",
                        ml: "4px",
                        mb: "0px",
                        h: "48px",
                        m: "0",
                        borderRadius: "0 10px 10px 0",
                        opacity: isChatbotAllowed() ? 1 : 0.6,
                        cursor: isChatbotAllowed() ? "pointer" : "not-allowed"
                      }}
                      onClick={() => {
                                  if (isChatbotAllowed()) {
                                    fetchEditComposition(medicinename);
                                  } else {
                                    showErrorToast("Please upgrade your subscription to use this feature");
                                  }
                                }}
                                isDisabled={!isChatbotAllowed()}
                                title={!isChatbotAllowed() ? "Please upgrade your subscription to use AI features" : ""}
                      // onClick={() => fetchComposition(medicinename)}
                      // isDisabled={false}
                    /> */}
                    <Box
                      as="button"
                      type="button"
                      border="1px solid #E6E7E9"
                      // borderRadius="full"
                      width={{ base: "100%", md: "10%" }}
                      // w="40px"
                      // h="40px"
                      p="8px"
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      // cursor={medicineTextFieldValue ? "pointer" : "not-allowed"}
                      // opacity={medicineTextFieldValue ? 1 : 0.5}
                      // pointerEvents={medicineTextFieldValue ? "auto" : "none"}
                      onClick={() => {
                      if (isChatbotAllowed()) {
                        fetchEditComposition(medicinename);
                      } else {
                        showErrorToast("Please upgrade your subscription to use this feature");
                      }
                    }}
                    isDisabled={!isChatbotAllowed()}
                    title={!isChatbotAllowed() ? "Please upgrade your subscription to use AI features" : ""}
                      bg="white"
                      // _hover={medicineTextFieldValue ? { bg: "#f0f0f0" } : {}}
                    >
                      <Image w="28px" src="/assets/svgs/ai-star-outline.svg" />
                    </Box>
                </Flex>
                {/* <Divider /> */}
                <RadioGroup
                  // mt="1rem"
                  // defaultValue={medicineTypeRadio}
                  // defaultValue={medicinetype}
                  value={medicinetype}
                  // onChange={handlemedicinetypechange}
                  onChange={(value) => {
    console.log("Radio selected:", value);
    handlemedicinetypechange(value, "radio");
  }}
                >
                  <Stack direction="row" alignItems='center' spacing={4} wrap="wrap">
                    <Radio colorScheme="green" value="Tablet">Tablet</Radio>
                    <Radio colorScheme="green" value="Capsule">Capsule</Radio>
                    <Radio colorScheme="green" value="Syrup">Syrup</Radio>
                    <Radio colorScheme="green" value="Drops">Drops</Radio>
                    <Radio colorScheme="green" value="Injection">Injection</Radio>
                    <Radio colorScheme="green" value="Nebulization">Nebulization</Radio>
                    <Radio colorScheme="green" value="IVFluids">IV Fluids</Radio>
                    <Radio colorScheme="green" value="Inhaler">Inhaler</Radio>
                    <Radio colorScheme="green" value="Sachet">Sachet</Radio>
                    <Radio colorScheme="green" value="Ointment">Ointment</Radio>
                    <Radio colorScheme="green" value="Cream">Cream</Radio>
                    <Radio colorScheme="green" value="Gel">Gel</Radio>
  
                    {/* <Radio colorScheme="green" value="Respules">Respules</Radio>
                    <Radio colorScheme="green" value="Suspension">Suspension</Radio>
                    <Radio colorScheme="green" value="Foam">Foam</Radio>
                    <Radio colorScheme="green" value="Suppository">Suppository</Radio>
                    <Radio colorScheme="green" value="EA">EA</Radio>
                    <Radio colorScheme="green" value="Device">Device</Radio>
                    <Radio colorScheme="green" value="Box">Box</Radio>
                    <Radio colorScheme="green" value="Spray">Spray</Radio>
                    <Radio colorScheme="green" value="Lotion">Lotion</Radio>
                    <Radio colorScheme="green" value="Tube">Tube</Radio>
                    <Radio colorScheme="green" value="Gargle">Gargle</Radio>
                    <Radio colorScheme="green" value="Powder">Powder</Radio>
                    <Radio colorScheme="green" value="Soap">Soap</Radio>
                    <Radio colorScheme="green" value="Aerosol">Aerosol</Radio>
                    <Radio colorScheme="green" value="Shampoo">Shampoo</Radio>
                    <Radio colorScheme="green" value="Topical Cleanser">Topical Cleanser</Radio>
                    <Radio colorScheme="green" value="Custom">Custom</Radio> */}
                  <Text>-Or-</Text>
                  <Box mx='1rem'>
  
                  {/* <DropdownInput
    variant="bothSide"
    dropDownPlace="More Medicine Types"
    options={additionalMedicineTypes}
    onClick={(value) => handleDropdownMedTypeChange(value)}
    value={selectedValue}
    defaultOption={selectedValue || "Select more types"}
  /> */}
  <DropdownInput
        variant="bothSide"
        dropDownPlace="More Types"
        options={additionalMedicineTypes}
        onClick={(value) => {
          console.log("Dropdown selected:", value);
          handleDropdownMedTypeChange(value);
        }}
        value={dropdownMedType}
        defaultOption={dropdownMedType || "Select more types"}
        // Add a clear prop if your DropdownInput component supports it
        clearValue={() => setDropdownMedType("")}
      />
  
                  </Box>
                  </Stack>
                </RadioGroup>
                {/* <Divider /> */}
                <Box>
                  <Flex>
                  <PrimaryInput
                    variant={"bothSide"}
                    onChange={handleDrugClass}
                    inputPlace="Drug Class"
                    defaultValue={drugClass}
                    inputValue={drugClass}
                  />
                  <PrimaryInput
                    variant={"bothSide"}
                    onChange={handleTherapeuticCategory}
                    inputPlace="Therapeutic category"
                    defaultValue={therapeutic}
                    inputValue={therapeutic}
                  />
  
                  {/* newly added code */}
                  {medicinetype == "Tablet" || medicinetype == "Capsule" || medicinetype == "Suppository" || medicinetype == "Powder" ? (
    <MiniDropdownInput
      variant="bothSide"
      options={[
        { label: "mg", value: "mg" },
        { label: "mcg", value: "mcg" },
        { label: "g", value: "g" },
      ]}
      placeholderProp="Strength"
      onSelect={handleChangeDosageUnit}
      handleInputChange={(e) =>
        setMedicineDosage(
          validationOfNumberWithOnly1Decimal(e.target.value),
        )
      }
      inputVal={dosage}
      defaultOptionProp={dosageunit}
      maxLength="6"
    />
  ) : medicinetype === "Inhaler" || medicinetype === "Spray" || medicinetype === "Aerosol" ? (
    <MiniDropdownInput
      variant="bothSide"
      options={[
        { label: "puffs", value: "puffs" },
        { label: "ml", value: "ml" },
        { label: "grms", value: "grms" },
      ]}
      placeholderProp="Volume"
      onSelect={handleChangeDosageUnit}
      handleInputChange={(e) =>
        setMedicineDosage(
          validationOfNumberWithOnly1Decimal(e.target.value),
        )
      }
      inputVal={dosage}
      defaultOptionProp={dosageunit}
      maxLength="6"
    />
  ) : medicinetype === "Syrup" ||
      medicinetype === "IVFluids" ||
      medicinetype === "Nebulization" ||
      medicinetype === "Drops" ||
      medicinetype === "Injection" ||
      medicinetype === "Suspension" ||
      medicinetype === "Respules" ||
      medicinetype === "Gargle" ||
      medicinetype === "Shampoo" ||
      medicinetype === "Topical Cleanser" ? (
    <MiniDropdownInput
      variant="bothSide"
      options={[{ label: "ml", value: "ml" }]}
      placeholderProp="Volume"
      onSelect={handleChangeDosageUnit}
      handleInputChange={(e) =>
        setMedicineDosage(
          validationOfNumberWithOnly1Decimal(e.target.value),
        )
      }
      inputVal={dosage}
      defaultOptionProp={dosageunit}
      maxLength="6"
    />
  ) : medicinetype === "Ointment" ||
      medicinetype === "Cream" ||
      medicinetype === "Gel" ||
      medicinetype === "Foam" ||
      medicinetype === "Lotion" ||
      medicinetype === "Tube" ||
      medicinetype === "Soap" ? (
    <MiniDropdownInput
      variant="bothSide"
      options={[{ label: "grms", value: "grms" }, { label: "ml", value: "ml" }]}
      placeholderProp="Weight/Volume"
      onSelect={handleChangeDosageUnit}
      handleInputChange={(e) =>
        setMedicineDosage(
          validationOfNumberWithOnly1Decimal(e.target.value),
        )
      }
      inputVal={dosage}
      defaultOptionProp={dosageunit}
      maxLength="6"
    />
  ) : medicinetype === "EA" || medicinetype === "Device" || medicinetype === "Box" ? (
    <MiniDropdownInput
      variant="bothSide"
      options={[{ label: "each", value: "each" }]}
      placeholderProp="Count"
      onSelect={handleChangeDosageUnit}
      handleInputChange={(e) =>
        setMedicineDosage(
          validationOfNumberWithOnly1Decimal(e.target.value),
        )
      }
      inputVal={dosage}
      defaultOptionProp={dosageunit}
      maxLength="6"
    />
  ) : medicinetype === "Sachet" ? (
    <MiniDropdownInput
      variant="bothSide"
      options={[
        { label: "mg", value: "mg" },
        { label: "g", value: "g" },
      ]}
      placeholderProp="Strength"
      onSelect={handleChangeDosageUnit}
      handleInputChange={(e) =>
        setMedicineDosage(
          validationOfNumberWithOnly1Decimal(e.target.value),
        )
      }
      inputVal={dosage}
      defaultOptionProp={dosageunit}
      maxLength="6"
    />
  ) : (
    // Default case for CUSTOM and any unexpected types
    <MiniDropdownInput
      variant="bothSide"
      options={[
        { label: "mg", value: "mg" },
        { label: "ml", value: "ml" },
        { label: "grms", value: "grms" },
        { label: "puffs", value: "puffs" },
        { label: "each", value: "each" },
      ]}
      placeholderProp={medicinetype === "Custom" ? "Custom Unit" : "Strength"}
      onSelect={handleChangeDosageUnit}
      handleInputChange={(e) =>
        setMedicineDosage(
          validationOfNumberWithOnly1Decimal(e.target.value),
        )
      }
      inputVal={dosage}
      defaultOptionProp={dosageunit}
      maxLength="6"
    />
  )}
  
  {medicinetype == "IVFluids" && (
    <MiniDropdownInput
      variant="bothSide"
      options={[
        { label: "ml/hr", value: "ml/hr" },
        { label: "ml/min", value: "ml/min" },
      ]}
      handleInputChange={(e) =>
        setRateOfInfusionValue(
          validationOfNumberWithOnly1Decimal(e.target.value),
        )
      }
      placeholderProp={"Rate of Infusion"}
      onSelect={handleRateOfInfusionUnit}
      maxLength="6"
    />
  )}
  
                  {/* existing code for edit */}
                  {/* {medicinetype == "Tablet" || medicinetype == "Capsule" ? (
                    <MiniDropdownInput
                      variant="bothSide"
                      options={[
                        { label: "mg", value: "mg" },
                        { label: "mcg", value: "mcg" },
                        { label: "g", value: "g" },
                      ]}
                      placeholderProp={
                        medicinetype == "Syrup" ||
                        medicinetype == "Injection" ||
                        medicinetype == "Nebulization" ||
                        medicinetype == "IVFluids" ||
                        medicinetype == "Drops"
                          ? "Volume"
                          : "Strength"
                      }
                      onSelect={handleChangeDosageUnit}
                      handleInputChange={(e) =>
                        setMedicineDosage(
                          validationOfNumberWithOnly1Decimal(e.target.value),
                        )
                      }
                      inputVal={dosage}
                      defaultOptionProp={dosageunit}
                      maxLength="6"
                    />
                  ) : medicinetype === "Inhaler" ? (
                    <MiniDropdownInput
                      variant="bothSide"
                      options={[
                        { label: "puffs", value: "puffs" },
                        { label: "ml", value: "ml" },
                        { label: "grms", value: "grms" },
                      ]}
                      placeholderProp={
                        medicinetype == "Inhaler" ? "Volume" : "Strength"
                      }
                      isDisabled={medicinetype == "Dosage" ? true : false}
                      onSelect={handleChangeDosageUnit}
                      handleInputChange={(e) =>
                        setMedicineDosage(
                          validationOfNumberWithOnly1Decimal(e.target.value),
                        )
                      }
                      inputVal={dosage}
                      defaultOptionProp={dosageunit}
                      maxLength="6"
                    />
                  ) : medicinetype === "Syrup" ||
                    medicinetype === "IVFluids" ||
                    medicinetype === "Nebulization" ||
                    medicinetype === "Drops" ||
                    medicinetype === "Injection" ? (
                    <MiniDropdownInput
                      variant="bothSide"
                      options={[{ label: "ml", value: "ml" }]}
                      placeholderProp={
                        medicinetype == "Syrup" ||
                        medicinetype == "Injection" ||
                        medicinetype == "Nebulization" ||
                        medicinetype == "IVFluids" ||
                        medicinetype == "Drops"
                          ? "Volume"
                          : "Strength"
                      }
                      onSelect={handleChangeDosageUnit}
                      handleInputChange={(e) =>
                        setMedicineDosage(
                          validationOfNumberWithOnly1Decimal(e.target.value),
                        )
                      }
                      inputVal={dosage}
                      defaultOptionProp={dosageunit}
                      maxLength="6"
                    />
                  ) : (
                    <MiniDropdownInput
                      variant="bothSide"
                      options={[
                        { label: "mg", value: "mg" },
                        { label: "ml", value: "ml" },
                        { label: "grms", value: "grms" },
                      ]}
                      placeholderProp={
                        medicinetype == "Syrup" ||
                        medicinetype == "Injection" ||
                        medicinetype == "Nebulization" ||
                        medicinetype == "IVFluids" ||
                        medicinetype == "Drops"
                          ? "Volume"
                          : "Strength"
                      }
                      onSelect={handleChangeDosageUnit}
                      handleInputChange={(e) =>
                        setMedicineDosage(
                          validationOfNumberWithOnly1Decimal(e.target.value),
                        )
                      }
                      inputVal={dosage}
                      defaultOptionProp={dosageunit}
                      maxLength="6"
                    />
                  )}
  
                  {medicinetype == "IVFluids" && (
                    <MiniDropdownInput
                      variant="bothSide"
                      options={[
                        { label: "ml/hr", value: "ml/hr" },
                        { label: "ml/min", value: "ml/min" },
                      ]}
                      handleInputChange={(e) =>
                        setRateOfInfusionValue(
                          validationOfNumberWithOnly1Decimal(e.target.value),
                        )
                      }
                      placeholderProp={"Rate of Infusion"}
                      onSelect={handleRateOfInfusionUnit}
                      maxLength="6"
                    />
                  )} */}
  
                  <DropdownInput
                    variant="bothSide"
                    dropDownPlace={
                      medicinetype == "Ointment" || medicinetype === "Cream" || medicinetype === "Gel"
                        ? "Application Frequency"
                        : medicinetype == "Nebulization" ||
                            medicinetype == "Inhaler" ||
                            medicinetype == "IVFluids"
                          ? "Frequency"
                          : "Consumption Quantity"
                    }
                    // options={["0.5", "1", "2", "3", "4"]}
                    options={(medicinetype === "Ointment" || medicinetype === "Cream" || medicinetype === "Gel") ? ["1", "2", "3", "4"] : ["0.5", "1", "2", "3", "4"]}
                    onClick={handleconsumptionfrequencychange}
                    value={frequency || "1"}
                    defaultOption={frequency || "1"}
                  />
                </Flex>
                  {/* <Divider my="10px" /> */}
                <Flex flexDir='column'>
                  { (medicinetype == "Injection" ||
                    medicinetype == "Tablet" ||
                    medicinetype == "Capsule") || medicinetype == "Nebulization" || medicinetype == "Inhaler" ? (
                    <Text fontSize="0.875rem" fontWeight="600" my="0.5rem">
                      Duration
                    </Text>
                    ) : medicinetype == "Ointment" ? (
                      <Text fontSize="0.875rem" fontWeight="600" my="0.5rem">
                        Application Duration
                      </Text>
                    ) : (
                      medicinetype == "IVFluids" && 
                      <Text fontSize="0.875rem" fontWeight="600" my="0.5rem">
                        Infusion Duration
                      </Text>
                    )
                  }
                  <Flex w='100%'>
                  {(medicinetype == "Injection" ||
                    medicinetype == "Tablet" ||
                    medicinetype == "Capsule") && (
                    <>
                      {/* <Divider my="10px" /> */}
                      {/* <Box display="flex" flexDir="row"> */}
                        <Box width={medicinetype == "Injection" ? "50%" : "100%"}>
                          <DropdownInput
                            variant="bothSide"
                            dropDownPlace="Duration"
                            options={["Days", "Weeks", "Months", "Years"]}
                            onClick={handleDurationUnit}
                            // defaultOption={durationUnit}
                            defaultOption="Days"
                          />
                        </Box>
                        <Box width={medicinetype == "Injection" ? "50%" : "100%"}>
                          <DropdownInput
                            variant="bothSide"
                            dropDownPlace="Interval Value"
                            options={["1", "2", "3", "4", "5", "6", "7"]}
                            onClick={handleDurationValue}
                            // defaultOption={durationValue}
                            defaultOption="5"
                          />
                        </Box>
                      {/* </Box> */}
                      {/* <Divider my="10px" /> */}
                    </>
                  )}
  
                  {medicinetype == "Injection" && (
                    <>
                      <DropdownInput
                        variant="bothSide"
                        dropDownPlace="Route of Administration"
                        options={[
                          "Intravenous (IV)",
                          "Intramuscular (IM)",
                          "Subcutaneous (SC)",
                        ]}
                        onClick={handleRouteOfAdministration}
                      />
                      <Box w='50%'>
                        <PrimaryInput
                          variant={"bothSide"}
                          onChange={handleTiming}
                          inputPlace="Timing"
                        />
                      </Box>
                    </>
                  )}
  
                  {medicinetype == "Ointment" && (
                    <>
                      {/* <Divider my="10px" /> */}
                      {/* <Text fontSize="0.875rem" fontWeight="500" mb="10px">
                        Application Duration
                      </Text> */}
                      {/* <Box display="flex" flexDir="row"> */}
                        <Box width="100%">
                          <DropdownInput
                            variant="bothSide"
                            dropDownPlace="Duration"
                            options={["Days", "Weeks", "Months", "Years"]} // Interval units as options
                            onClick={handleDurationUnit}
                            // defaultOption={durationUnit}
                            defaultOption="Days"
                          />
                        </Box>
                        <Box width="100%">
                          <DropdownInput
                            variant="bothSide"
                            dropDownPlace="Interval Value"
                            options={["1", "2", "3", "4", "5", "6", "7"]}
                            onClick={handleDurationValue}
                            // defaultOption={durationValue}
                            defaultOption="5"
                          />
                        </Box>
                      {/* </Box> */}
  
                      {/* <Divider my="10px" /> */}
  
                      <DropdownInput
                        variant="bothSide"
                        dropDownPlace="Quantity"
                        options={[
                          "Pea-sized",
                          "Thin layer",
                          "Fingertip unit (FTU)",
                          "Half a fingertip",
                        ]}
                        onClick={handleQuantity}
                        value={quantity || ""}
                        defaultOption={quantity}
                      />
                      <DropdownInput
                            variant="bothSide"
                            dropDownPlace="Area of Application"
                            options={["On Scalp", "On Skin", "On Wound", "On Hair"]}
                            onClick={(value) => setAreaOfApplication(value)}
                            value={areaOfApplication || ""}
                            defaultOption={areaOfApplication}
                          />
                      {/* <PrimaryInput
                        variant={"bothSide"}
                        onChange={handleAreaOfApplication}
                        inputPlace="Area of Application"
                      /> */}
                    </>
                  )}
  
                  {medicinetype == "Nebulization" && (
                    <>
                      {/* <Divider my="10px" /> */}
                      {/* <Text fontSize="0.875rem" fontWeight="500" mb="10px">
                        Duration
                      </Text> */}
  
                      {/* <Box display="flex" flexDir="row"> */}
                        <Box width="100%">
                          <DropdownInput
                            variant="bothSide"
                            dropDownPlace="Duration"
                            options={["Days", "Weeks", "Months", "Years"]}
                            onClick={handleDurationUnit}
                            // defaultOption={durationUnit}
                            defaultOption="Days"
                          />
                        </Box>
                        <Box width="100%">
                          <DropdownInput
                            variant="bothSide"
                            dropDownPlace="Interval Value"
                            options={["1", "2", "3", "4", "5", "6", "7"]}
                            onClick={handleDurationValue}
                            // defaultOption={durationValue}
                            defaultOption="5"
                          />
                        </Box>
                      {/* </Box> */}
                      {/* <Divider my="10px" /> */}
  
                      <DropdownInput
                        variant="bothSide"
                        dropDownPlace="Diluent"
                        options={["Normal saline", "Distilled water", "3% saline"]}
                        onClick={handleDiluent}
                      />
                    </>
                  )}
  
                  {medicinetype == "IVFluids" && (
                    <>
                      {/* <Divider my="10px" /> */}
                      {/* <Text fontSize="0.875rem" fontWeight="500" mb="10px">
                        Infusion Duration
                      </Text> */}
  
                      <DropdownInput
                        variant="bothSide"
                        dropDownPlace="Infusion frequency"
                        options={["1", "2", "3", "4", "5", "6", "7"]}
                        onClick={handleDurationValue}
                        // defaultOption={durationValue}
                        defaultOption="5"
                      />
                      <DropdownInput
                        variant="bothSide"
                        dropDownPlace="Infusion Duration"
                        options={["Days", "Weeks", "Months", "Years"]}
                        onClick={handleDurationUnit}
                        // defaultOption={durationUnit}
                        defaultOption="Days"
                      />
  
                      {/* <Divider my="10px" /> */}
  
                      <PrimaryInput
                        variant={"bothSide"}
                        onChange={handleAdditives}
                        inputPlace="Additives"
                      />
                    </>
                  )}
  
                  {medicinetype == "Inhaler" && (
                    <>
                      {/* <Text fontSize="0.875rem" fontWeight="500" mb="10px">
                        Duration
                      </Text> */}
  
                      {/* <Box display="flex" flexDir="row"> */}
                        <Box width="100%">
                          <DropdownInput
                            variant="bothSide"
                            dropDownPlace="Duration"
                            options={["Days", "Weeks", "Months", "Years"]}
                            onClick={handleDurationUnit}
                            // defaultOption={durationUnit}
                            defaultOption="Days"
                          />
                        </Box>
                        <Box width="100%">
                          <DropdownInput
                            variant="bothSide"
                            dropDownPlace="Interval Value"
                            options={["1", "2", "3", "4", "5", "6", "7"]}
                            onClick={handleDurationValue}
                            // defaultOption={durationValue}
                            defaultOption="5"
                          />
                        </Box>
                      {/* </Box> */}
                      {/* <Divider my="10px" /> */}
                    </>
                  )}
  
                  
                  {/* <MonthYearPicker
                    placeholderProp="Medicine Expiry"
                    value={medicineexpirydate}
                    onDateChange={handleMonthYearChange}
                    datePickerInputStyle={{ borderRadius: "0" }}
                    minYear={moment().year()}
                  /> */}
                  </Flex>
                </Flex>
                <Flex justifyContent="space-between" mt='0.75rem' alignItems='center'>
                  {/* OLD CHECKBOX GROUP - REPLACED WITH MEAL TIMING DROPDOWN
                  <CheckboxGroup
                    colorScheme="green"
                    onChange={handlemedicinetime}
                    defaultValue={timeValues}
                  >
                    <Stack spacing={2} direction="row">
                      <Checkbox value="morning">Morning</Checkbox>
                      <Checkbox value="afternoon">Afternoon</Checkbox>
                      <Checkbox value="night">Night</Checkbox>
                    </Stack>
                  </CheckboxGroup>
                  */}

                  {/* Dropdown for Meal Timing */}
                  <Box width='180px'>
                    <DropdownInput
                      variant="bothSide"
                      dropDownPlace="Meal Timing"
                      arrowCSS={{pr:0}}
                      options={[
                        "1-0-0",
                        "0-1-0",
                        "0-0-1",
                        "1-1-0",
                        "1-0-1",
                        "0-1-1",
                        "1-1-1",
                        "0-0-0"
                      ]}
                      onClick={(value) => {
                        if (value) {
                          const { morning, afternoon, night } = parseMealTiming(value);
                          setMorning(morning ? "1" : "0");
                          setAfternoon(afternoon ? "1" : "0");
                          setEvening(night ? "1" : "0");
                        }
                      }}
                      value={getMealTimingLabel(String(morning) === "1" ? 1 : 0, String(afternoon) === "1" ? 1 : 0, String(setnight) === "1" ? 1 : 0)}
                    />
                  </Box>
  
                  <Text fontWeight='600' whiteSpace='nowrap'>- Or -</Text>
                  {/* <Text
                    fontWeight="600"
                    width="50%"
                    display="flex"
                    justifyContent="center"
                    whiteSpace="nowrap"
                    my='0.5rem'
                  >
                    - Or -
                  </Text> */}
  
                  <Flex width="100%">
    <Box width='150px'>
                    <DropdownInput
                      variant="bothSide"
                      dropDownPlace="Frequency"
                      options={["Hours", "Daily", "Weekly"]}
                       onClick={handleEditFrequencyUnit}
                      // onClick={handleFrequencyUnit}
                      value={medicineFreqUnit}
                    />
                    </Box>
  
                    <Box width='80px'>
                    <DropdownInputForVitals
                      variant="bothSide"
                      dropDownPlace="Value"
                      options={["1", "2", "3", "4", "8"]}
                      // onClick={handleFrequencyValue}
                      onClick={handleEditFrequencyValue}
                      value={medicineFreqValue}
                      readOnly=""
                      inputValueProp={medicineFreqValue}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (value) {
                          setTimeValues([]);
                          setMorning(0);
                          setAfternoon(0);
                          setNight(0);
                        }
                        setMedicineFreqValue(value);
                      }}
                      maxLength={2}
                    />
                    </Box>
                  </Flex>
                  {/* <Box display="flex" w='100%' alignItems='center' gap='0.75rem'> */}
                  <Box w='50%'>
                    {/* CONDITIONAL TIMING: TOPICAL VS FOOD */}
                    {(medicinetype === "Cream" || medicinetype === "Ointment" || medicinetype === "Gel") ? (
                      <Box w='100%'>
                        {/* <DropdownInput
                          variant="bothSide"
                          dropDownPlace="Product Quantity"
                          options={["1", "2", "3", "4"]}
                          onClick={(value) => setProductQuantity(value)}
                          value={productQuantity || "1"}
                        /> */}
                        {/* <Text fontSize="sm" mb={1} mt={2}>Application Timing</Text> */}
                        <DropdownInput
                          variant="bothSide"
                          dropDownPlace="Application Timing"
                          options={[
                            "After Bath",
                            "Before Bath",
                            "After Sun",
                            "Before Sun",
                            "Time-based",
                          ]}
                          onClick={(value) => {
                            setFoodTiming(value);
                          }}
                          value={foodTiming}
                        />

                        {/* <Box mt={2}>
                          <DropdownInput
                            variant="bothSide"
                            dropDownPlace="Area of Application"
                            options={["On Scalp", "On Skin", "On Wound", "On Hair"]}
                            onClick={(value) => setAreaOfApplication(value)}
                            value={areaOfApplication || ""}
                            defaultOption={areaOfApplication}
                          />
                        </Box> */}
                      </Box>
                    ) : (
                      <RadioGroup
                        w='100%'
                        colorScheme="green"
                        onChange={handlemedicinetimebeforeafter}
                        value={foodTiming}
                      >
                        <Stack spacing={2} direction="row">
                          <Radio value="beforefood">Before Food</Radio>
                          <Radio value="afterfood">After Food</Radio>
                        </Stack>
                      </RadioGroup>
                    )}
                  </Box>
                </Flex>
                </Box>
                <Box>
                  {/* <Box w="100%" pos="relative" cursor="pointer">
                    <PrimaryInput
                      inputPlace="Prescribed by"
                      variant="defaultSide"
                      inputValue={prescribedby}
                      onChange={(e) =>
                        handleSurgeonNameChange(
                          handleAlphaDotAndSpace(e.target.value, 50),
                        )
                      }
                      onClick={() => listOfSurgeonNames(false)}
                      inputIdProp={"DoctorNameInAdd"}
                      boolProp={boolValForSuggestions}
                    />
                    <Image
                      top="33%"
                      right="6.5%"
                      w="15px"
                      onClick={() => listOfSurgeonNames(true)}
                      pos="absolute"
                      src="/assets/imgs/double-arrow.png"
                    />
                  </Box> */}
                  {showDocNamesDropdown && suggestions.length > 0 && (
                    <Menu isOpen={true}>
                      <MenuButton
                        as={Box}
                        w="100%"
                        display="block"
                        pos="relative"
                        zIndex="999"
                      >
                        <Box
                          pos="absolute"
                          top="100%"
                          left="0"
                          w="100%"
                          bg="white"
                          borderTop="none"
                          border="1px solid #E6E7E9"
                          borderRadius="0 0 12px 12px"
                        />
                      </MenuButton>
                      <MenuList
                        w="100%"
                        borderRadius="0 0 12px 12px"
                        zIndex="999"
                        bg="white"
                        maxH="150px"
                        overflow="hidden auto"
                      >
                        {suggestions.map((suggestion, index) => (
                          <MenuItem
                            key={index}
                            onClick={() => handleSelect(suggestion)}
                            cursor="pointer"
                            p="1rem"
                            py="0.5rem"
                            borderBottom="1px solid #E6E7E9"
                          >
                            <Text fontSize="0.875rem" fontWeight="500">
                              {suggestion.doctorname}
                            </Text>
                          </MenuItem>
                        ))}
                      </MenuList>
                    </Menu>
                  )}
                  {/* <PrimaryInput
                    inputPlace="Hospital name"
                    variant="downSide"
                    onChange={(e) =>
                      setHospitalname(handleAlphaNumericDotAndSpace(e.target.value))
                    }
                    inputValue={hospitalname}
                  /> */}
  
                  {/* <Textarea
                    mt='0.5rem'
                    borderRadius='10px'
                    placeholder="Instructions"
                    defaultValue={instructions}
                    onChange={handleInstructions}
                    inputValue={instructions}
                  /> */}
  
                  <Box position='relative' display='flex' alignItems='flex-end' flexDirection='row'>
                    <Box
                      as="form"
                      width='100%'
                      bg="white"
                      pt={"2px"}
                    >
                      <Box flex="1" width="100%" position="relative" bg={"#f9fafb"}>
                        <Textarea
                          borderRadius='0'
                          value={editInstructions || ''}
                          onChange={(e) => {
                            handleEditInstructions(e.target.value);
                            setValue("textField", e.target.value); 
                          }}
                          height="100%"
                          padding="2"
                          resize="none"
                          style={{ overflowWrap: "break-word", whiteSpace: "pre-wrap" }}
                        />                      
                        {!editInstructions && (
                          <Text
                            position="absolute"
                            bottom="2"
                            left="50%"
                            transform="translateX(-50%)"
                            fontSize="sm"
                            color="gray.500"
                            w={{ base: "100%", md: "unset" }}
                            textAlign={{ base: "center", md: "unset" }}
                          >
                            {placeholder}
                          </Text>
                        )}
                      </Box>
                    </Box>
                  </Box>
                  {/* <Box mt=".5rem">
                    <Checkbox
                      colorScheme="green"
                      sx={{
                        ".chakra-checkbox__control": {
                          width: "20px",
                          height: "20px",
                          borderRadius: "5px",
                        },
                      }}
                      onChange={handleIsCurrent}
                    >
                      Current
                    </Checkbox>
                  </Box> */}
                </Box>
  
                {/* Audio & Language Controls Row - Highlighted Section */}
                      <Box
                        bg="#f8f9fa"
                        border="1px solid #e9ecef"
                        borderRadius="8px"
                        p="1rem"
                        mt="1rem"
                        // mb="1rem"
                      >
                        <Flex
                          alignItems="center"
                          justifyContent="space-around"
                          // justifyContent="space-between"
                          gap="1rem"
                          flexWrap={{ base: "wrap", md: "nowrap" }}
                        >
                          {/* Input Language Dropdown */}
                          <Box flex="1" minW="120px">
                            <DropdownWithMultiLingual 
                              menuList={{pos:'relative', right:'75px'}}
                              placeholder="English"
                              onClick={handleChangeLanguage}
                              options={languageOptions.map(value => ({ value }))}
                              title="Input Language"
                            />
                          </Box>
                          
                          {/* Audio Controls and Wave Display */}
                          <Box 
                      flex="1"
                      display="flex" 
                      alignItems="center" 
                      justifyContent="center"
                      gap="0.75rem"
                      minH="50px"
                      px="1rem"
                    >
                      <GPUChatAudioManagerSpeechMode
                        transcriber={activeTranscriber}
                        mode={mode}
                        setPlaceholder={setPlaceholder}
                        setTyping={setTyping}
                        onRecordingStateChange={handleRecordingStateChange} 
                      />
                
                      {isRecording && (
                        <Box flex="1" minW="180px" maxW="250px">
                          <AudioDisplayForClutter
                            borderRadius="lg"
                            stream={stream}
                            width="100%"
                          />
                        </Box>
                      )}
                    </Box>
                
                          {/* Output Language Dropdown */}
                          <Box flex="1" minW="120px">
                            <DropdownWithMultiLingual 
                              menuList={{pos:'relative', right:'75px'}}
                              placeholder="English"
                              onClick={handleChangeOutputLanguage}
                              options={languageOptions.map(value => ({ value }))}
                              title="Output Language"
                            />
                          </Box>
                
                          {/* AI Correction Button */}
                          <Box
                            as="button"
                            type="button"
                            border="1px solid #E6E7E9"
                            borderRadius="full"
                            w="40px"
                            h="40px"
                            p="8px"
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            cursor={textFieldValue ? "pointer" : "not-allowed"}
                            opacity={textFieldValue ? 1 : 0.5}
                            pointerEvents={textFieldValue ? "auto" : "none"}
                            onClick={() => textFieldValue && correctOrders("edit")}
                            flexShrink="0"
                            bg="white"
                            _hover={textFieldValue ? { bg: "#f0f0f0" } : {}}
                          >
                            <Image w="28px" src="/assets/svgs/ai-star-outline.svg" />
                          </Box>
                        </Flex>
                      </Box>
                {filenameArray.map((filename, indexToDelete) => (
                  <Button
                    fontSize="14px"
                    fontWeight="500"
                    w="100%"
                    h="48px"
                    borderRadius="10px"
                    border="1px solid #E6E7E9"
                    display="flex"
                    justifyContent="space-between"
                    bg="white"
                    color="#1C4EC5"
                    sx={{ _hover: { bg: "none" } }}
                  >
                    Document {indexToDelete + 1}
                    <Box as="span">
                      <Image src="/assets/imgs/delete.png" />
                    </Box>
                  </Button>
                ))}
                <input
                  type="file"
                  id="file-upload"
                  onChange={(e) => handleMedicationUpload(e)}
                  ref={fileInputRef} // Set the ref for the file input
                  style={{ display: "none" }} // Hide the file input
                />
              </Stack>
            </Box>
          </>
        }
        modalFooterBtn={
          <>
          {/* <Box position='relative' display='flex' alignItems='flex-end' flexDirection='row'>        
            <GPUChatAudioManager
                transcriber={activeTranscriber}
                setPlaceholder={setPlaceholder}
                setTyping={setTyping}
                  onTranscribedText={(text) => {
              handleEditInstructions(text);
              setValue("textField", text);
            }}
              />
              <Box
                as="button"
                type="button" 
                border="1px solid #E6E7E9"
                borderRadius="full"
                w="36px"
                h="auto"
                p="10px"
                mr='10px'
                display="flex"
                justifyContent="center"
                alignItems="center"
                cursor={textFieldValue ? "pointer" : "not-allowed"}
                opacity={textFieldValue ? 1 : 0.5}
                pointerEvents={textFieldValue ? "auto" : "none"}
                onClick={() => textFieldValue && correctOrders("edit")}
              >
                <Image w="26px" src="/assets/svgs/ai-star-outline.svg" />
              </Box>
          </Box> */}
            <PrimaryButton buttonText="Edit Medication" onClick={editmedicine} />
          </>
        }
      />

      <DynamicModal
            ref={dynamicModal}
            modalHeader="Delete Medicine?"
            modalBody={
              <>
                <Text fontSize="14px" fontWeight="600">
                  Are you sure you want to delete
                  <strong> {medName ? `"${medName}"` : "this medicine"}</strong>?
                  {/* <strong> "{medName}"</strong> */}
                </Text>
              </>
            }
            modalFooterBtn={
              <>
                <PrimaryButton
                  variant="deleteBtn"
                  buttonText="Delete"
                  onClick={deleteMedicine}
                />
              </>
            }
          />
         
       </>
  );
};

export default DoctorfavIndex;
